/**
 * Finnish (fi) admin strings.
 *
 * MACHINE/LLM-TRANSLATED from language.en.ts (with language.se.ts for context) — NOT reviewed by a
 * native Finnish speaker. Needs native-Finnish review before production: this is a live client UI
 * (Noi Tre, Soupster). Keys flagged as uncertain are listed in language.fi.REVIEW.md.
 *
 * Same key set as language.en.ts plus the Swedish-only keys, so no string falls back to its key.
 * The array entries (ALCOHOL_STRINGS, STRINGS, DRINK_LIST) are matching tokens against product data
 * and are kept as in the English file.
 */
export const lang = {
    get: (string, parameters?) => {
        switch (string) {
            // Integrations + Fortnox (Z): MACHINE-TRANSLATED from Swedish/English, needs native-Finnish review (language.fi.REVIEW.md)
            case 'INTEG_INTRO': return `Ota käyttöön ja hallinnoi lisäosia: ${parameters[0]}.`;
            case 'INTEG_CONNECTED_TO': return `Yhdistetty: ${parameters[0]}`;
            case 'INTEG_CONNECTED_TO_AUTO': return `Yhdistetty: ${parameters[0]} · automaattinen vienti päällä`;
            case 'INTEG_STATUS_FAILED': return `Tilaa ei voitu hakea (${parameters[0]})`;
            case 'FZ_NOTICE_ORG_MISMATCH': return `Väärä yritys: Fortnox-tili kuuluu yritykselle ${parameters[0]} (${parameters[1]}), mutta ravintola kuuluu yritykselle ${parameters[2]}. Mitään ei tallennettu.`;
            case 'FZ_NOTICE_DENIED': return `Yhdistäminen peruttiin Fortnoxissa: ${parameters[0]}`;
            case 'FZ_NOTICE_ERROR': return `Yhdistäminen epäonnistui: ${parameters[0]}`;
            case 'FZ_CONNECTED_META': return `yhdistetty ${parameters[0]}, yhdistäjä ${parameters[1]}`;
            case 'FZ_SCOPE_NOTE': return `Yhteys koskee kaikkia yritykselle ${parameters[0]} kuuluvia ravintoloita. Alla olevat asetukset koskevat vain ravintolaa ${parameters[1]}.`;
            case 'FZ_ORG_MISMATCH_WARN': return `Ravintolan yrityksen Y-tunnus PubQ:ssa on ${parameters[0]}, mutta se on yhdistetty tunnukseen ${parameters[1]}.`;
            case 'FZ_REAUTH_WARN': return `Yrityksen ${parameters[0]} Fortnox-yhteys on vanhentunut, ja se on hyväksyttävä uudelleen.`;
            case 'FZ_ALREADY_CONNECTED': return `Yritys ${parameters[0]} on jo yhdistetty – ravintola on nyt liitetty.`;
            case 'FZ_SETTINGS_FOR': return `Asetukset: ${parameters[0]}`;
            case 'FZ_FROM_Z': return `Z ${parameters[0]} alkaen`;
            case 'FZ_EG': return `esim. ${parameters[0]}`;
            case 'FZ_APPROVED_SO_FAR': return `${parameters[0]} kirjattu tähän mennessä`;
            case 'FZ_PREVIEW_TITLE': return `Tosite: Z ${parameters[0]}`;
            case 'FZ_SERIES_X': return `sarja ${parameters[0]}`;
            case 'FZ_PREVIEW_SUMMARY': return `${parameters[0]} kuittia · Z-raportin kokonaissumma ${parameters[1]} kr`;
            case 'FZ_DROPPED': return `${parameters[0]} nollariviä jätetty pois`;
            case 'FZ_RESEND_TITLE': return `Lähetetäänkö Z ${parameters[0]} uudelleen?`;
            case 'FZ_RESEND_ALREADY': return `Z ${parameters[0]} on jo kirjattu.`;
            case 'FZ_RESEND_ALREADY_AS': return `Z ${parameters[0]} on jo kirjattu tositteeksi ${parameters[1]}.`;
            case 'FZ_DISCONNECT_ALL': return `Tämä katkaisee Fortnox-yhteyden kaikilta yritykselle ${parameters[0]} kuuluvilta ravintoloilta.`;
            case 'FZ_TOAST_SENT': return `Z ${parameters[0]} kirjattu`;
            case 'FZ_TOAST_SENT_AS': return `Z ${parameters[0]} kirjattu tositteeksi ${parameters[1]}`;
            case 'FZ_TOAST_NOT_SENT': return `Z ${parameters[0]}: ei lähetetty`;
            case 'FZ_BACKFILL_RESULT': return `Jälkilähetys: ${parameters[0]} kirjattu, ${parameters[1]} ei`;
            case 'FZ_BACKFILL_STOPPED': return `Pysähtyi kohtaan Z ${parameters[0]}: ${parameters[1]}`;
            case 'FZ_ERR_SECTION_TIMEOUT': return `Fortnox-palvelu ei vastannut ${parameters[0]} sekunnissa`;
            case 'FZ_ERR_SIGNIN_TIMEOUT': return `Kirjautuminen ei vastannut ${parameters[0]} sekunnissa`;
            case 'FZ_CUST_REFRESHED': return `Päivitetty Fortnoxista: ${parameters[0]} kenttää muuttui.`;
            case 'CARD_ADDED_FOR':
                return `Kortti luotu ${parameters[0]}`;
            case 'REMOVE_NAME':
                return `Poistetaanko ${parameters[0]}?`;
            case 'REMOVED_IMAGE':
                return `Poistettu ${parameters}`;
            case 'PRODUCTS_UPDATED':
                return `${parameters[0]} tuotetta päivitetty`;
            case 'UPDATING_PRODUCTS_PROGRESS':
                return `Päivitetään tuotteita ${parameters[0]}/${parameters[1]}`;
            case 'SAVING_MENU':
                return `Tallennetaan menu: ${parameters[0]}`;
            case 'REMOVE_MENU':
                return `Poistetaanko ${parameters[0]}?`;
            case 'SAVING_GALLERY':
                return `Tallennetaan galleria: ${parameters[0]}`;
            case 'NUMBER_ARTICLES':
                return `${parameters[0]} tuotetta`;
            case 'UPDATE_ITEM':
                return `Päivitetty ${parameters[0]}`;
            case 'PRODUCT_ADDED':
                return `${parameters[0]} lisätty`;
            case 'PRODUCT_REMOVED':
                return `${parameters[0]} poistettu`;
            case 'REMOVE_PRODUCT_CATEGORY':
                return `Haluatko varmasti poistaa tuotekategorian ${parameters[0]}?`;
            case 'REMOVE_BONG_CATEGORY':
                return `Haluatko varmasti poistaa keittiötulostuskategorian ${parameters[0]}?`;
            case 'SHARE_NEWS_WITH':
                return `Jaetaanko uutinen: ${parameters[0]}?`;
            case 'NEWS_SHARED':
                return `Jaettu ${parameters[0]}`;
            case 'TIMELINE_SAVED_FOR':
                return `Tallennetaan aikajana: ${parameters[0]}`;
            case 'SHARING_OFFER_WITH':
                return `Jaetaan tarjous: ${parameters[0]}`;
            case 'OFFER_SHARED':
                return `Jaettu ${parameters[0]}`;
            case 'REMOVE_COUPON':
                return `Poistetaanko ${parameters[0]}?`;
            case 'LINKED_PRODUCT':
                return `Linkitetty ${parameters[0]}`;
            case 'COPY_FROM':
                return `Kopioidaanko kohteesta ${parameters[0]}?`;
            case 'REMOVE':
                return `Poistetaanko ${parameters[0]}?`;
            case 'REMOVE_CORPORATE_USER_QUESTION':
                return `Haluatko varmasti poistaa käyttäjän ${parameters[0]}?`;
            case 'REMOVING':
                return `Poistettu ${parameters[0]}`;
            case 'ADDED':
                return `Lisätty ${parameters[0]}`;
            case 'PRODUCT_SAVED':
                return `${parameters[0]} tallennettu`;
            case 'SAVING_PRODUCT':
                return `Tallennetaan tuote: ${parameters[0]}`;
            case 'CONFIRM_REMOVE_ACCOUNTING':
                return `Haluatko varmasti poistaa kohteen ${parameters[0]}?`;
            case 'SAVED':
                return `Tallennettu ${parameters[0]}`;
            case 'RECEIPTS_AMOUNT':
                return `Yhteensä: ${parameters[0]} kuittia & ${parameters[1]}`;
            case 'PRINTER_ALREADY_EXISTS':
                return `Tulostin on jo olemassa: ${parameters[0]}`;
            case 'ARE_YOU_SURE_YOU_WANT_TO_MARK_THIS_ORDER_AS':
                return `Haluatko varmasti merkitä tämän tilauksen tilaan ${parameters[0]}?`;
            case 'ARE_YOU_SURE_YOU_WANT_TO_REMOVE': return `Haluatko varmasti poistaa kohteen "${parameters[0]}" kohteesta "${parameters[1]}"?`;
            case 'ARE_YOU_SURE_YOU_WANT_TO_DELETE': return `Haluatko varmasti poistaa kohteen "${parameters[0]}"? Toimintoa ei voi peruuttaa.`;
            case 'MENU_DEACTIVATED_DETAIL': return `Menu "${parameters[0]}" on poistettu käytöstä.`;
            case 'MENU_ACTIVATED_DETAIL': return `Menu "${parameters[0]}" on nyt käytössä.`;
            case 'CAMPAIGN_MENU_ACTIVATED_DETAIL': return `Kampanjamenu "${parameters[0]}" on nyt käytössä.`;
            case 'PRODUCT_REMOVED_FROM_CATEGORY': return `Tuote "${parameters[0]}" poistettu kategoriasta "${parameters[1]}".`;
            case 'PRODUCT_ADDED_TO_CATEGORY': return `Tuote "${parameters[0]}" lisätty kategoriaan "${parameters[1]}".`;
            case 'ORDER_STATUS_UPDATED': return `Tilauksen tila päivitetty: "${parameters[0]}".`;
            case 'COLUMNS_SELECTED': return `Valitut sarakkeet: ${parameters[0]}`;
            case 'ITEM_COMPLETED_DETAIL':
                return `${parameters[0]} merkitty valmiiksi.`;
            case 'FOOD_ITEM_COMPLETED_DETAIL':
                return `${parameters[0]} merkitty valmiiksi.`;
            case 'DRINK_ITEM_COMPLETED_DETAIL':
                return `${parameters[0]} merkitty valmiiksi.`;
            case 'FOOD_ITEMS_COMPLETED_DETAIL':
                return `${parameters[0]} ruokatuotetta merkitty valmiiksi: ${parameters[1]}`;
            case 'DRINK_ITEMS_COMPLETED_DETAIL':
                return `${parameters[0]} juomaa merkitty valmiiksi: ${parameters[1]}`;
            case 'ITEMS_COMPLETED_DETAIL':
                return [
                    parameters[0][0] ? `Ruoka: ${parameters[1]}` : '',
                    parameters[0][1] ? `Juomat: ${parameters[2]}` : ''
                ].filter(Boolean).join('. ');
            case 'TIMER_STARTED_DETAIL':
                // parameters[1] is the English plural "s"; Finnish says "min" for both.
                return `Ajastin käynnistetty: ${parameters[0]} min.`;
            case 'CATERING_ADDON_MORE_PRODUCTS':
                return `+${parameters[0]} lisää`;
            case 'CATERING_ADDON_ERR_MAX_EXCEEDS_OPTIONS':
                return `Valintojen enimmäismäärä ei voi ylittää ${parameters[0]} vaihtoehtoa.`;
            case 'CATERING_ADDON_ERR_MIN_EXCEEDS_OPTIONS':
                return `Valintojen vähimmäismäärä ei voi ylittää ${parameters[0]} vaihtoehtoa.`;
            default:
                return '';
        }
    },
    ALCOHOL_STRINGS: ["vin","shot","drink","sprit","cognac","öl","cider","whisk","whiskey","whisky","rom","likör","vodka","limoncello","alkoläsk"],
    AMOUNT_MIN_MOBILE_WALLET: "Siirron vähimmäissumma",
    AMOUNT_1_MOBILE_WALLET: "Summa 1",
    AMOUNT_2_MOBILE_WALLET: "Summa 2",
    AMOUNT_3_MOBILE_WALLET: "Summa 3",
    AMOUNT_4_MOBILE_WALLET: "Summa 4",
    AMOUNT_5_MOBILE_WALLET: "Summa 5",
    AMOUNT_6_MOBILE_WALLET: "Summa 6",
    AMOUNT_7_MOBILE_WALLET: "Summa 7",
    AMOUNT_8_MOBILE_WALLET: "Summa 8",
    AMOUNT_9_MOBILE_WALLET: "Summa 9",
    AMOUNT_10_MOBILE_WALLET: "Summa 10",
    STRINGS: ["Öl","Vin","Alkoholfritt","Mat","Cider","Drink","Sprit","Dricks","Presentkort"],
    DRINK_LIST: ["dricka","dryck"],
    WEEL_LIST: ["Su","Ma","Ti","Ke","To","Pe","La"],
    CHOSE_PRINTER: "Valitse tulostin",
    SAVE_AS_PDF: "Tallenna PDF-muodossa",
    MY_ACCOUNT: "Oma tili",
    USER_ID: "Käyttäjätunnus",
    REMOVE_ACCOUNTING: "Tiliöinti poistettu",
    PROFILE: "Profiili",
    ADD_INFO_TO_PROFILE: "Lisää tietoja profiiliisi, jotta voimme tukea sinua paremmin.",
    PLEASE_ENTER_ADDRESS: "Anna osoitteesi",
    FIRST_NAME: "Etunimi",
    LAST_NAME: "Sukunimi",
    POSTCODE: "Postinumero",
    CITY: "Kaupunki",
    COUNTRY: "Maa",
    NEXT_STEP: "Seuraava vaihe",
    ORGANIZATION: "Organisaatio",
    ENTER_ORG_INFO: "Anna organisaatiosi tiedot.",
    ENTER_COMPANY_NAME: "Anna yrityksen nimi",
    VALIDATE: "VAHVISTA",
    VALIDATING: "VAHVISTETAAN",
    VALIDATED: "VAHVISTETTU",
    PREVIOUS: "Edellinen",
    REVIEW_DETAILS_SUBMIT: "Tarkista tietosi ja lähetä",
    WIZARD3_TEXT1: "Rekisteröityminen on melkein valmis. Tarkista vielä tietosi alta.",
    WIZARD3_TEXT2: "Sen jälkeen voit alkaa tutustua PubQ-alustaan.",
    WIZARD3_TEXT3: "Uusi yritys luodaan nimellä",
    FREE_REGISTER: "Rekisteröidy maksutta ja aloita",
    STEP: "Vaihe",
    SIGNUP: "Luo tili",
    CREATE_ACC_DETAILS: "Luo tili antamalla tietosi",
    FULLNAME: "Koko nimi",
    IS_REQUIRED: "on pakollinen",
    CONFIRM_PASSWORD: "Vahvista salasana",
    REGISTER: "Lähetä",
    LOG_OUT: "Kirjaudu ulos",
    HANDLE_PERSONNELCARD: "Hae henkilökuntakortti",
    CREATE_NEW_CARD: "Luo uusi kortti",
    PERSONNELCARD: "Henkilökuntakortti",
    NAME: "Nimi",
    TEXT_ON_CARD: "Kortin teksti",
    AVAILABLE_THROUGH: "Voimassa asti",
    URL_TO_BACKGROUND: "Taustakuvan URL",
    REMOVE: "Poista",
    SAVE: "Tallenna",
    SEARCH: "Hae",
    SEARCH_IMAGE: "Hae kuvaa...",
    SEARCH_VIDEO: "Hae videota...",
    USER_WITH_CARD: "Käyttäjät, joilla on kortti",
    ID: "ID",
    CARD: "Kortti",
    JANUARY: "Tammikuu",
    FEBRUARY: "Helmikuu",
    MARS: "Maaliskuu",
    APRIL: "Huhtikuu",
    MAY: "Toukokuu",
    JUNE: "Kesäkuu",
    JULY: "Heinäkuu",
    AUGUST: "Elokuu",
    SEPTEMBER: "Syyskuu",
    OCTOBER: "Lokakuu",
    NOVEMBER: "Marraskuu",
    DECEMBER: "Joulukuu",
    JAN3: "Tammi",
    FEB3: "Helmi",
    MAR3: "Maalis",
    APR3: "Huhti",
    MAY3: "Touko",
    JUN3: "Kesä",
    JUL3: "Heinä",
    AUG3: "Elo",
    SEP3: "Syys",
    OCT3: "Loka",
    NOV3: "Marras",
    DEC3: "Joulu",
    OK: "OK",
    AUTHORIZED_USERS: "Valtuutetut käyttäjät",
    ADD_NEW_USER: "Lisää uusi käyttäjä",
    NO_AUTHORIZED_USERS: "Ei vielä valtuutettuja käyttäjiä.",
    ENTER_USER_NAME: "Anna käyttäjän nimi",
    ENTER_USER_EMAIL: "Anna käyttäjän sähköposti",
    CORPORATE_USER_INVITED: "Valtuutettu käyttäjä kutsuttu.",
    RESEND_INVITATION: "Lähetä kutsu uudelleen",
    CORPORATE_USER_INVITATION_RESENT: "Kutsu lähetetty uudelleen.",
    CORPORATE_USER_INVITATION_RESEND_FAILED: "Kutsun uudelleenlähetys epäonnistui.",
    CORPORATE_USER_ALREADY_LINKED: "Tämä käyttäjä on jo liitetty tähän yritysasiakkaaseen tässä yksikössä.",
    CORPORATE_USER_REMOVED: "Valtuutettu käyttäjä poistettu.",
    CORPORATE_USER_REMOVE_FAILED: "Valtuutetun käyttäjän poistaminen epäonnistui.",
    FAILED_TO_LOAD_AUTHORIZED_USERS: "Valtuutettujen käyttäjien lataaminen epäonnistui.",
    EMAIL_ADDRESS: "Sähköpostiosoite",
    EMAIL_ADDRESS_DESCRIPTION: "Mihin sähköpostiosoitteeseen raportti lähetetään?",
    ENTER_NAME: "Anna nimesi.",
    NAME_REQUIRED: "Nimi on pakollinen.",
    USERNAME: "KÄYTTÄJÄNIMI",
    DATE: "PÄIVÄMÄÄRÄ",
    DATE_FOR_PUSH: "Päivämäärä",
    ORDER_NAME: "TILAUKSEN NIMI",
    TOTAL_ITEMS: "TUOTTEITA YHTEENSÄ",
    ADDRESS: "Osoite",
    ACTIONS: "TOIMINNOT",
    PLACE_ORDER: "Tee tilaus",
    CANCEL: "Peruuta",
    SCHEDULE_VIEW: "Aikataulunäkymä",
    SORTED_ON_PRODUCT: "Lajittele tuotteen mukaan",
    DAY: "Päivä",
    TOTAL: "Yhteensä",
    ORDERS_TODAY: "Tilaukset tänään",
    ORDERS_THIS_MONTH: "Tilaukset tässä kuussa",
    ACTIVITY: "Aktiivisuus",
    COUPONS_IN_APP: "Sovelluksessa käytetyt kupongit",
    PER_PRODUCT: "Tuotteittain",
    USERS_WITH_CODES: "Käyttäjät, joilla on alennuskoodi",
    RECEIPTNO: "Kuittinro",
    TIME: "Aika",
    CODE: "Koodi",
    ORDERCODE: "Tilauskoodi",
    NAVIGATE_HERE: "Siirry tänne tai käytä vasemman yläkulman valikkoa",
    UPLOADING: "Ladataan",
    SELECT_RESTAURANTS: "Valitse ravintolat",
    UPLOAD: "Lataa…",
    UPLOAD_IMAGE: "Lataa kuva",
    SHARE_GALLERY: "Jaa galleria",
    SHARE_IMAGE: "Jaa kuva",
    GALLERY: "Galleria",
    GALLERY_IMAGE_LOAD_FAILED: "Kuvaa ei voitu ladata",
    GALLERY_RETRY: "Yritä uudelleen",
    GALLERY_SHOW_MORE: "Näytä lisää",
    GALLERY_IMAGE_REMOVED: "Kuva poistettu",
    GALLERY_VIDEO_REMOVED: "Video poistettu",
    ARE_YOU_SURE: "Oletko varma?",
    DELETE_IMAGE: "Poista kuva",
    ARE_YOU_SURE_GALLERY: "Haluatko varmasti poistaa kuvan galleriastasi?",
    UPDATING_IMAGE_QUICK: "Hetki… päivitämme kuvaasi",
    IMAGE_SHARED: "Kuva jaettu",
    SYNC_PRODUCTS: "Synkronoi tuotteet",
    CLEAR_EXISTING_PROUCTS: "Tyhjennetäänkö nykyiset tuotteet?",
    UPDATING_PRODUCTS: "Päivitetään tuotteita",
    SAVING_OPTION_GROUP: "Tallennetaan lisävalintaryhmää…",
    OPT_GROUP_SAVE_FAILED: "Lisävalintaryhmän tallentaminen epäonnistui.",
    PRODUCT_PAGE_VERIFY: "Tarkista tuotesivulla",
    FROM: "Alkaen",
    TO: "Päättyen",
    ORDERVALUE_COUPON: "Tilausarvo kuponkikoodilla",
    SUM_RECEPITS_COUPON: "Niiden kuittien summa, joissa asiakas käytti kuponkikoodia",
    CODE_CAPS: "KOODI",
    DISCOUNT_CAPS: "ALENNUS",
    NETTO_CAPS: "NETTO",
    VAT_CAPS: "ALV",
    TOTAL_CAPS: "YHTEENSÄ",
    TODAY_CAPS: "TÄNÄÄN",
    CLOSE_CAPS: "SULJE",
    CREATE_NEW_GROUP: "Luo uusi",
    PRODUCT_LIST_DESCRIPTION: "Hallitse, päivitä ja järjestä tuotteitasi",
    RESET_FORTNOX: "Nollaa Fortnox-yhteys",
    RESET_FORTNOX_TEXT: "Haluatko varmasti poistaa Fortnox-yhteyden ja nollata sen, jotta voit luoda uuden yhteyden?",
    NO: "Ei",
    YES: "Kyllä",
    AUTHORIZATIONCODE: "Valtuutuskoodi",
    AUTHORIZED: "VALTUUTETTU",
    VOUCHER_SERIES: "Tositesarja",
    ROUNDING_ACCOUNT: "Pyöristystili",
    ACTIVATE: "Aktivoi",
    INTEGRATIONS: "integraatio",
    PASSWORD: "Salasana",
    FORWARD: "Jatka",
    FORGOT_PASSWORD: "Unohditko salasanasi?",
    RESET_EMAIL_HEAD: "Sähköposti salasanan palautusta varten",
    RESET_EMAIL_TXT: "Anna sähköpostiosoitteesi",
    NEW_MENU: "Uusi menu",
    CREATE_NEW_MENU: "Luo uusi menu",
    COPY: "Kopioi",
    SURE: "Oletko varma?",
    MENU_SHARED: "Menu jaettu",
    SOMETHING_WRONG: "Jokin meni vikaan!",
    THIS_MENU_ACTIVE: "Tämä menu on aktiivinen",
    DELETE_MENU: "Poista menu",
    ACTIVATE_BEFORE_REMOVE: "Sinun on aktivoitava toinen menu ennen tämän poistamista",
    REMOVE_FOR_ALL: "Poistetaanko kaikilta?",
    REMOVE_EVEN_OTHERS: "Haluatko poistaa julkaisun myös muista ravintoloista, joissa se on olemassa?",
    REMOVED_FROM_ALL: "Poistettu kaikista ravintoloista ",
    MONDAY: "Maanantai",
    TUESDAY: "Tiistai",
    WEDNESDAY: "Keskiviikko",
    THURSDAY: "Torstai",
    FRIDAY: "Perjantai",
    SATURDAY: "Lauantai",
    SUNDAY: "Sunnuntai",
    FAILED: "Epäonnistui",
    SAVED: "Tallennettu!",
    MENUS: "Menut",
    VISIBLE_IN_APP: "Näkyy sovelluksessa",
    WEEKLY_MENU: "Viikkomenu",
    WEEKLY_MENU_PLANNER: "Viikkomenun suunnittelu",
    WEEKLY_MENU_PLANNER_DESCRIPTION: "Laadi tuotteiden viikkoaikataulu maanantaista sunnuntaihin.",
    GLOBAL_SETTINGS: "Ennakkotilausrajat",
    WEEKLY_MENU_GLOBAL_SETTINGS_DESCRIPTION: "Valitse, kuinka monta päivää etukäteen asiakkaat voivat tilata.",
    ORDER_DAYS_IN_ADVANCE: "Asiakkaat voivat tilata näin monta päivää etukäteen",
    DAY_SETTINGS: "Päiväkohtaiset asetukset",
    SEARCH_PRODUCTS: "Hae tuotteita",
    SEARCH_PRODUCT_REGISTER: "Hae tuoterekisteristä",
    WEEKLY_MENU_PRODUCT: "Viikkomenun tuote",
    WEEKLY_MENU_PRODUCT_HINT: "Näytä tämä tuote viikkomenun tuoterekisterissä.",
    WEEKLY_MENU_PRICE_HELP: "Valinnainen: jätä kenttä tyhjäksi, niin kyseiselle tarjoilutavalle käytetään perushintaa.",
    WEEKLY_MENU_AVAILABLE_THIS_DAY: "Saatavilla tänä päivänä",
    WEEKLY_MENU_PRODUCT_ENABLED_EVERYWHERE_HINT: "Kun asetus on pois päältä, tuote piilotetaan kaikkialla, missä sitä käytetään, eikä vain tänä viikonpäivänä.",
    CLOSED_FOR_ORDERING: "Suljettu tilauksilta",
    OPEN_FOR_ORDERING: "Avoinna tilauksille",
    ORDER_CUTOFF_TIME: "Tilausten takaraja",
    AVAILABLE_FROM: "Saatavilla alkaen",
    AVAILABLE_UNTIL: "Saatavilla asti",
    ORDERS_MUST_BE_PLACED_BEFORE_THIS_TIME: "Tilaukset on tehtävä ennen tätä aikaa.",
    SAVE_SETTINGS: "Tallenna asetukset",
    GLOBAL_SETTINGS_SAVED: "Yleiset asetukset tallennettu",
    SETTINGS_SAVED: "Asetukset tallennettu",
    SHOW_BUTTON: "Näytä Viikkomenu-painike sovelluksen aloitussivulla. Päivitä teksti joka viikko, jotta käyttäjät näkevät, mitä tarjolla on",
    UPLOAD_PROGRESS: "Ladataan",
    GALLERY_SHARED: "Galleria jaettu!",
    USE_IMAGE: "Käytä kuvaa",
    USE_VIDEO: "Käytä videota",
    PREVIEW_VIDEO: "Esikatsele videota",
    DELETE_VIDEO: "Poista video",
    UPDATING_IMAGE: "Hetki… päivitämme kuvaasi",
    UPDATING: "Päivitetään",
    COMPRESSING: "Pakataan",
    HELP: "Ohje",
    IN_STOCK: "Varastossa",
    OUT_OF_STOCK: "Loppu varastosta",
    STOCK_BALANCE_ERROR: "Varastosaldon on oltava suurempi kuin 0",
    FEW_LEFT_IN_STOCK: "Vain muutama jäljellä",
    CATEGORIES: "Kategoriat",
    MISCELLANEOUS: "Muut",
    PRODUCT_IMAGE: "Tuotekuva",
    SELECT_FILE: "Valitse tiedosto",
    FOOD: "Ruoka",
    ALL: "Kaikki",
    ALL_ORDERS: "Kaikki tilaukset",
    DRINKS: "Juomat",
    PRODUCTS: "Tuotteet",
    ADD: "Lisää",
    AUTOCOMPLETE: "Merkitse valmiiksi automaattisesti",
    SHOW_ON_KDS: "Näytä KDS:ssä",
    CATEGORY_ACTIONS: "Kategorian toiminnot",
    MENUS_TEXT: "Hallitse menuja – luo tai muokkaa",
    KDS_AND_PRINTER: "KDS ja tulostin",
    COOKINGTIME_MINUTES: "Valmistusaika minuutteina",
    PRINTED_ON: "Tulostetaan kohteeseen",
    DELETE_SUBCATEGORY: "Poista alakategoria",
    SET_LOCATIONS: "Kiinteät sijainnit",
    RESET_PASSWORD: "Palauta salasana",
    DISCARD_ALL_CHANGES: "Hylkää kaikki muutokset",
    DISCARD_ALL_CHANGES_QUESTION: "Haluatko varmasti peruuttaa ja hylätä kaikki muutokset?",
    ENTER_EMAIL_TO_RESET: "Anna sähköpostiosoite käyttäjän salasanan palauttamiseksi",
    PUBLISH_NEWS_TEXT: "Julkaise uutisia sovelluksessa ja pidä käyttäjäsi ajan tasalla",
    AUTO_ROTATE_NEWS: "Vaihda uutisia automaattisesti",
    ORDERS_AND_RECEIPTS: "Seuraa tilauksia ja hallitse asiakkaiden kuitteja",
    DO_YOU_WANT_TO_REMOVE: "Haluatko poistaa",
    DELETE_ADDON_QUESTION: "Haluatko varmasti poistaa lisävalintaryhmän",
    NO_FEATURED_PRODUCTS: "Nostettuja tuotteita ei ole",
    ADDON_GROUPS_TEXT: "Luo lisävalintaryhmiä ja liitä ne tuotteisiisi",
    ORDER_PRINTING_TEXT: "Määritä tilausten käsittely keittiötulostuskategorioittain",
    REMOVE_USER_QUESTION: "Haluatko poistaa tämän käyttäjän tämän yksikön tiimistä?",
    REMOVE_USER: "Poista käyttäjä",
    UPDATE: "Päivitä",
    CONFIRM: "Vahvista",
    ADD_NEW_OFFER: "Lisää uusi tarjous",
    ADD_NEW_COUPON_CODE: "Lisää uusi koodi",
    SELECT_LOCATION: "Valitse yksikkö...",
    PRODUCT_CATEGORIES: "Tuotekategoriat",
    BONG_CATEGORIES: "Keittiötulostuskategoriat",
    NEW_PRODUCT_CATEGORY: "Uusi tuotekategoria",
    REMOVE_CATEGORY: "Poista kategoria",
    REMOVE_PRODUCT_CATEGORY: "Haluatko varmasti poistaa kategorian",
    EDIT_PRODUCT_CATEGORY: "Muokkaa tuotekategoriaa",
    MENU_ACTIVATED: "Menu aktivoitu",
    MENU_TIMES_UPDATED: "Menun ajat päivitetty",
    MENU_SCHEDULE: "Menun aikataulu",
    MENU_SCHEDULE_ACTIVATED: "Menun aikataulu aktivoitu",
    SERVING_OPTIONS_UPDATED: "Toimitusvaihtoehdot päivitetty",
    DELIVERY_TO_FIXED_LOCATIONS: "Toimitus kiinteisiin sijainteihin",
    UPDATED_SUCCESSFULLY: "Päivitys onnistui",
    NEW_BONG_CATEGORY: "Uusi keittiötulostuskategoria",
    REMOVE_BONG_CATEGORY: "Poistetaanko keittiötulostuskategoria?",
    EDIT_BONG_CATEGORY: "Muokkaa keittiötulostuskategoriaa",
    TIMELINE: "Aikajana",
    NEW_POST: "Uusi julkaisu",
    SHARE: "Jaa",
    CHOOSE_IMAGE: "Valitse kuva",
    ADD_IMAGE: "Lisää kuva",
    CHANGE_IMAGE: "Vaihda kuva",
    TITLE: "Otsikko",
    TEXT: "Teksti",
    OFFER: "Tarjous",
    PRODUCT: "Tuote",
    URL: "URL",
    STATIC: "Staattinen",
    APP_TAB: "Sovelluksen välilehti, jolla tuote on",
    OFFER_INFO: "Tietoa tarjouksesta",
    WARNING: "Varoitus",
    CONFIRMATION: "Vahvistus",
    NONE: "Ei mitään",
    REMOVE_SPECIFIC_PRICE: "Poista erillinen hinta",
    NO_LOWER_PRICE: "Noutoruoan tai paikan päällä syötävän hinta ei voi olla 0. Aseta korkeampi hinta tai poista kenttä.",
    ALREADY_EDITING: "Muokkaat jo toista julkaisua. Haluatko varmasti hylätä tiedot?",
    ABORT_Q: "Peruutetaanko?",
    CONFIRM_CHANGES: "Haluatko varmasti peruuttaa? Muutokset menetetään.",
    REMOVE_ON_SEVERAL_UNITS: "Haluatko poistaa tuotteen myös muista yksiköistäsi?",
    PRODUCT_DELETED_ON_MENUS: "Tuote poistettu menuista",
    PRODUCT_DELETED: "Tuote poistettu",
    PRODUCT_REMOVED: "Tuote poistettu",
    MENU_UPDATED: "Menu päivitetty!",
    DELETE_PRODUCT: "Poista tuote",
    ARE_YOU_SURE_DELETE_PRODUCT: "Haluatko varmasti poistaa tämän tuotteen?",
    ARE_YOU_SURE_DELETE_SELECTED_PRODUCTS: "Haluatko varmasti poistaa valitut tuotteet?",
    FILL_ALL_FIELDS: "Täytä kaikki kentät otsikkoa ja tekstiä lukuun ottamatta",
    SAVE_NEWS: "Tallennetaan uutisia",
    MAIN_TEXT: "Leipäteksti",
    NEW_TITLE: "Uusi otsikko",
    REMOVE_POST: "Poistetaanko julkaisu?",
    REMOVE_POST_CONFIRM: "Haluatko varmasti poistaa julkaisun?",
    REMOVE_FOR_OTHERS: "Haluatko poistaa julkaisun myös muista ravintoloista, joissa se on olemassa?",
    TIMELINE_SHARED: "Aikajana jaettu!",
    TYPE: "Tyyppi",
    SERVING_METHOD: "Tarjoilutapa",
    APPLIES_FOR: "Koskee",
    PRODUCT_TYPES: "Tuotetyypit",
    DISCOUNT_PERCENTAGE: "Prosenttialennus",
    AUTOMATIC_ACTIVATION: "Otetaan automaattisesti käyttöön sovelluksessa",
    AUTOMATIC_ACTIVATION_HINT: "Kun tämä on käytössä, tarjous aktivoituu käyttäjälle ilman erillisiä toimenpiteitä.",
    CREATING_OFFER: "Luodaan tarjousta",
    OFFER_CREATED: "Tarjous luotu!",
    UPDATING_OFFER: "Päivitetään tarjousta",
    OFFER_UPDATED: "Tarjous päivitetty",
    REMOVING: "Poistetaan",
    OFFER_REMOVED: "Tarjous poistettu",
    NEW_BUTTON: "Uusi painike ",
    CREATE_NEW_BUTTON: "Luo uusi painike",
    CONNECT_BUTTON: "Mihin painike liitetään?",
    CHOOSE_BG_IMAGE: "Valitse taustakuva",
    BUTTON_LAYER: "Painikevarasto",
    FREE_TEXT: "Vapaa teksti",
    ACTIVATE_IN_POS: "AKTIVOI KASSASSA",
    ALLERGY_INFO_SAVED: "Allergeenitiedot tallennettu ja näkyvät sovelluksessa",
    MINIMUM_BONUS_SAVED: "Vähimmäisbonus tallennettu",
    MINIMUM_FEE: "Vähimmäismaksu",
    ADD_FEE: "Lisää maksu",
    MINIMUM_FEE_OPTIONAL: "Vähimmäismaksu (valinnainen)",
    PAYMENT_OPTIONS_SAVED: "Maksuvaihtoehdot tallennettu",
    SERVING_OPTIONS_SAVED: "Tarjoiluasetukset tallennettu",
    DELIVERY_SET_LOCATIONS: "Kiinteät sijainnit",
    NOTIFICATION_SAVED: "Ilmoitus tallennettu",
    INSTAGRAM_SAVED: " Instagram tallennettu",
    FACEBOOK_SAVED: " Facebook tallennettu",
    MENU_STYLE_SAVED: "Menun ulkoasu tallennettu",
    FOOD_SETTINGS_SAVED: "Ruoka-asetukset tallennettu",
    DRINK_SETTINGS_SAVED: "Juoma-asetukset tallennettu",
    DISCOUNT_SETTINGS_SAVED: "Alennusasetukset tallennettu",
    COUPON_NAME: "Kupongin nimi",
    COUPON_CODE: "Kuponkikoodi",
    ADD_DISCOUNT_CODE: "Lisää kuponkikoodi",
    PERCENTAGE_IN_DISOUNT: "Alennus prosentteina",
    TAKEAWAY: "Noutoruoka",
    TABLE_SERVING: "Pöytiintarjoilu",
    ACTION: "Toiminto",
    ARTICLE: "Artikkeli",
    ARTICLE_TEXT: "Artikkelin teksti",
    SEARCH_USERGROUP: "Hae ryhmää",
    COLLECT_IN_BAR: "Nouto baarista",
    DELIVERY: "Kotiinkuljetus",
    MESSAGE_WHEN_TAB_CLOSED: "Asiakkaalle näytettävä viesti, kun tämä välilehti on suljettu",
    SENDING_PUSH: "Lähetetään push-ilmoitusta",
    SHOW_YAMMER: "Näytä Yammer-kuvake aloitussivulla",
    SHOW_TIKTOK: "Näytä TikTok-kuvake aloitussivulla",
    PUSH_SENT: "Push-ilmoitus lähetetty!",
    GENERAL: "Yleiset",
    CURRENCY: "Valuutta",
    INVOICE: "Laskutus",
    ALLOW_USER_TO_ADD_ORGANIZATION_IN_APP: "Salli käyttäjien liittyä organisaatioon sovelluksessa",
    GENERAL_SETTINGS: "Yleiset asetukset",
    ADD_PRICE: "Lisää hinta",
    SUBCATEGORY: "Alakategoria",
    GENERATE_REPORT: "Luo raportti",
    PUSH_NOTIFICATIONS: "Push-ilmoitukset",
    SHORTCUTS: "Pikakuvakkeet",
    MANAGE_GENERAL_SETTINGS: "Hallitse yksikön yleisiä asetuksia",
    APP_SETTINGS: "Sovelluksen asetukset",
    OFFERS: "Tarjoukset",
    STAMP_CARDS: "Leimakortit",
    ADD_NEW_STAMP_CARD: "Luo uusi",
    STAMPS_REQUIRED: "Vaaditut leimat",
    REWARD: "Palkinto",
    NO_STAMP_CARDS: "Ei leimakortteja. Aloita lisäämällä kortti.",
    CREATE_STAMP_CARD: "Luo leimakortti",
    EDIT_STAMP_CARD: "Muokkaa leimakorttia",
    IMPORT: "Tuo",
    IMPORT_STAMP_CARD: "Tuo leimakortti",
    IMPORT_STAMP_CARD_DESCRIPTION: "Tuo leimakortteja kanta-asiakasryhmäsi muista yksiköistä, jolloin asiakkaat voivat kerätä ja käyttää leimoja kaikissa liitetyissä yksiköissä.",
    NO_STAMP_CARDS_TO_IMPORT: "Kanta-asiakasryhmästäsi ei ole tuotavia leimakortteja.",
    STAMP_CARD_IMPORTED: "Leimakortti tuotu",
    FAILED_TO_IMPORT: "Leimakortin tuominen epäonnistui",
    STAMP_CARD_NAME: "Leimakortin nimi",
    STAMP_CARD_DESCRIPTION: "Kuvaus",
    STAMP_CARD_DESCRIPTION_PLACEHOLDER: "Esim. Osta 10 lounasta ja saat 11. veloituksetta.",
    HOW_IT_WORKS: "Näin se toimii",
    HOW_IT_WORKS_PLACEHOLDER: "Valinnaiset säännöt tai ohjeet, jotka näytetään sovelluksessa",
    STAMPS_REQUIRED_FOR_FULL_CARD: "Täyteen korttiin vaadittavat leimat",
    REWARD_TYPE: "Palkinnon tyyppi",
    FULL_DISCOUNT: "100 % alennus",
    HALF_DISCOUNT: "50 % alennus",
    SALES_CHANNELS: "Myyntikanavat",
    CHANNEL_APP: "Sovellus",
    CHANNEL_KIOSK: "Kioski",
    CHANNEL_POS: "POS",
    CHANNEL_WEB: "Verkko",
    CUSTOMER_VISIBILITY: "Näkyvyys asiakkaille",
    ALL_CUSTOMERS: "Kaikki asiakkaat",
    LOGGED_IN_USERS_ONLY: "Vain kirjautuneet käyttäjät",
    DELETE_STAMP_CARD: "Poista leimakortti",
    DELETE_STAMP_CARD_CONFIRM: "Poistetaanko tämä leimakortti?\n\nKaikki tämän kortin leimat, käyttäjien edistyminen ja lokit poistetaan pysyvästi kaikilta.\n\nJos haluat säilyttää historian ja vain lopettaa kortin käytön, poista kortti käytöstä (aseta se ei-aktiiviseksi) poistamisen sijaan.",
    STAMP_CARD_DELIVERY_METHODS: "Toimitustavat",
    STAMP_CARD_DELIVERY_METHODS_HINT: "Kaikki tavat ovat oletuksena sallittuja; poista valinta rajoittaaksesi, millä toimitustavoilla leimoja voi kerätä ja käyttää.",
    STAMP_CARD_DM_EAT_IN: "Syödään paikan päällä",
    STAMP_CARD_DM_TAKEAWAY: "Noutoruoka",
    STAMP_CARD_DM_DELIVER_TO_WORKPLACE: "Toimitus työpaikalle",
    STAMP_CARD_DM_DELIVERY: "Kotiinkuljetus",
    STAMP_CARD_DM_TABLE_SERVING: "Pöytiintarjoilu",
    REWARD_ELIGIBLE: "Palkinto",
    STAMP_CARD_SEPARATE_REWARD_ITEMS: "Määritä erilliset palkintotuotteet",
    STAMP_CARD_SEPARATE_REWARD_ITEMS_HINT: "Ota tämä käyttöön, jos palkinnon tulee koskea muita tuotteita kuin niitä, joista kerätään leimoja.",
    SC_USERS_CARD_RECORDS: "Korttitiedot",
    SC_USERS_READY_TO_REDEEM: "Valmis lunastettavaksi",
    SC_USERS_AVG_STAMPS: "Leimoja keskimäärin per kortti",
    SC_USERS_SEARCH_PLACEHOLDER: "Hae käyttäjän nimellä, käyttäjätunnuksella tai kortilla...",
    SC_USERS_NO_RECORDS: "Käyttäjätietoja ei löytynyt.",
    SC_DEACTIVATED_BY_ADMIN: "Ylläpitäjän poistama käytöstä",
    SC_DEACTIVATED: "Poistettu käytöstä",
    SC_CARD_ACTIVE: "Kortti aktiivinen",
    SC_CARD_INACTIVE: "Kortti ei aktiivinen",
    SC_USER_DEACTIVATED: "Käyttäjä poistettu käytöstä",
    SC_USER_ACTIVE: "Käyttäjä aktiivinen",
    SC_DEACTIVATED_BANNER: "Tämä kortti on poistettu käytöstä tältä käyttäjältä — leimat säilyvät, mutta lunastus on estetty, kunnes kortti otetaan uudelleen käyttöön.",
    SC_STAMP_PROGRESS: "Leimojen edistyminen",
    SC_LAST_STAMP: "Viimeisin leima",
    SC_LAST_REDEEMED: "Viimeksi lunastettu",
    SC_LAST_USED_DATE: "Viimeisimmän toiminnan päivämäärä",
    SC_CARD_NAME: "Kortin nimi",
    SC_CARD_ID: "Kortin tunnus",
    SC_ADD_STAMP: "Lisää leima",
    SC_REMOVE_STAMP: "Poista leima",
    SC_NO_STAMPS_TO_REMOVE: "Ei poistettavia leimoja",
    SC_MAX_STAMPS_REACHED: "Leimojen enimmäismäärä saavutettu – merkitse lunastetuksi",
    SC_NOT_READY_TO_REDEEM: "Kortti ei ole vielä valmis lunastettavaksi",
    SC_MARK_REDEEMED: "Merkitse lunastetuksi",
    SC_DEACTIVATE: "Poista käytöstä",
    SC_REACTIVATE: "Ota uudelleen käyttöön",
    SC_LOADING_HISTORY: "Ladataan historiaa…",
    SC_NO_HISTORY: "Toimintaa ei ole vielä kirjattu.",
    SC_LOG_STAMP_ADDED: "Leima kerätty",
    SC_LOG_REDEEMED: "Lunastettu",
    SC_LOG_ADMIN_STAMP_ADDED: "Ylläpitäjä: Leima lisätty",
    SC_LOG_ADMIN_STAMP_REMOVED: "Ylläpitäjä: Leima poistettu",
    SC_LOG_ADMIN_REDEEMED: "Ylläpitäjä: Merkitty lunastetuksi",
    SC_LOG_ADMIN_DEACTIVATED: "Ylläpitäjä: Kortti poistettu käytöstä",
    SC_LOG_ADMIN_REACTIVATED: "Ylläpitäjä: Kortti otettu uudelleen käyttöön",
    SC_STAMP: "leima",
    SC_STAMPS: "leimaa",
    SC_REFRESH: "Päivitä",
    SC_USER_COL: "Käyttäjä",
    SC_STAMP_CARD_COL: "Leimakortti",
    SC_STAMPS_COL: "Leimat",
    SC_PROGRESS_COL: "Edistyminen",
    SC_NOT_READY: "Ei valmis",
    SC_ALL_CARDS: "Kaikki kortit",
    SC_STAMP_CARD_DETAILS: "Leimakortin tiedot",
    SC_FAILED_LOAD_PROGRESS: "Käyttäjän edistymisen lataaminen epäonnistui",
    ADD_ROUTE: "Lisää reitti",
    LOADING_ROUTES: "Ladataan reittejä...",
    EXPIRATION: "Voimassaolo päättyy",
    OFFER_TITLE: "Tarjouksen otsikko",
    RESTAURANT_ID: "Ravintolan tunnus",
    SERVING_OPTIONS: "Tarjoiluvaihtoehdot",
    PAYMENT_OPTIONS: "Maksuvaihtoehdot",
    MANUALLY_TOGGLE_TEXT: "Kytke myynti päälle tai pois manuaalisesti sovelluksessa, verkkotilauksissa ja pikakassalla",
    USE_SAVE_BUTTON: "Tämän sivun muutokset vaikuttavat mobiilisovellukseen, ja muutokset on vahvistettava Tallenna-painikkeella",
    OPEN_FOR_SALE: "Avoinna myynnille",
    MESSAGE_WHEN_CLOSED: "Ilmoitus asiakkaalle, kun myynti on suljettu",
    FOOD_TAB: "Ruokamyynti",
    DRINK_TAB: "Juomamyynti",
    NOTIFICATION_IN_APP: "Ilmoitusbanneri sovelluksessa",
    NOTIFICATION_EXPLANATION: "Viestisi sisältävä banneri näkyy sovelluksen aloitussivulla",
    SHOW_NOTIFICATION: "Näytä ilmoitus",
    NOTIFICATION_TEXT: "Ilmoituksen teksti",
    ALLERGY_INFO: "Allergeenitiedot",
    ALLERGEN_INFO_DESCRIPTION: "Julkaise allergeenitietosi sovelluksessa",
    PHONE_NUMBER: "Puhelinnumero",
    OPENING: "Avautuu",
    OPENING_HOURS: "Aukioloajat",
    CLOSING: "Sulkeutuu",
    TAKEAWAY_EAT_HERE: "Mukaan & syödään paikan päällä",
    SHOW_FACEBOOK: "Näytä Facebook-kuvake aloitussivulla",
    INSTAGRAM: "Instagram",
    SHOW_INSTAGRAM: "Näytä Instagram-kuvake aloitussivulla",
    WHICH_ACTIVE: "Mitkä otetaan käyttöön sovelluksessa?",
    ACTIVATED: "Käytössä",
    DEACTIVATED: "Poistettu käytöstä",
    SUBCATEGORY_DELETED: "Alakategoria poistettu",
    MENU_NAME_UPDATED: "Menun nimi päivitetty",
    SUBCATEGORY_UPDATED: "Alakategoria päivitetty.",
    SWISH: "Swish",
    SWISH_NUMBER: "Swish-numero",
    VIPPS: "Vipps",
    TAB: "Pöytätunniste",
    TABLENUMBER_FROM: "Pöytänumerosta",
    TABLENUMBER_TO: "Pöytänumeroon",
    AREA_1: "Alue 1",
    AREA_2: "Alue 2",
    AREA_3: "Alue 3",
    AREA_4: "Alue 4",
    DELIVERY_RADIUS: "Toimitussäde metreinä",
    DELIVERY_RADIUS_COST: "Toimitusmaksu",
    SERVING_OPTIONS_MENU: "Valitse menun toimitustavat",
    SERVING_OPTIONS_MENU_EXPLANATION: "Kun tämä menu on käytössä sovelluksessa, nämä toimitustavat ovat saatavilla",
    FOOD_OPEN: "Ruoka avoinna",
    FOOD_CLOSED: "Ruoka suljettu",
    DRINK_OPEN: "Juomat avoinna",
    DRINK_CLOSED: "Juomat suljettu",
    BONUSSYSTEM: "Bonusjärjestelmä",
    LEAST_AMOUNT_BONUS: "Pienin pistemäärä, jolla voi ostaa pisteillä",
    ACTIVE_OR_DEACTIVE_BONUS_SYSTEM: "Ota bonusjärjestelmä käyttöön tai poista se käytöstä",
    ACTIVE_OR_DEACTIVE_MAX_BONUS_POINTS: "Ota bonuspisteiden enimmäismäärä käyttöön tai poista se käytöstä",
    MAXIMUM_AMOUNT_BONUS: "Suurin pistemäärä, jolla voi ostaa pisteillä",
    OPEN_CLOSE_AUTOMATICALLY: "Avaa/sulje sovellus automaattisesti",
    OPEN_CLOSE_SETTINGS: "Avaa/sulje sovellus tilauksille",
    AUTO_OPENING_HOURS_TITLE: "Automaattiset aukioloajat",
    AUTO_OPENING_HOURS_DESCRIPTION: "Valitse tämä, jotta myyntikanavat avautuvat ja sulkeutuvat automaattisesti alla olevien aukioloaikojen ja poikkeusten mukaan. Jos valintaa ei ole tehty, aukioloajat näytetään vain tietona.",
    AUTO_OPENING_HOURS_ON: "Käytössä – myyntikanavat avautuvat ja sulkeutuvat automaattisesti alla olevien aikojen mukaan.",
    AUTO_OPENING_HOURS_OFF: "Ei käytössä – aukioloajat näytetään myyntikanavissa vain tietona eivätkä ne ohjaa avaamista tai sulkemista.",
    AUTO_OPENING_HOURS_TAG_ON: "Ohjaa avaamista/sulkemista",
    AUTO_OPENING_HOURS_TAG_OFF: "Vain tietona",
    BANNER_IN_APP: "Banneri sovelluksessa",
    SOCIAL_MEDIA: "Sosiaalinen media",
    ALLERGEN_INFORMATION: "Allergeenitiedot",
    GLOBAL_OFFERS: "Yleiset tarjoukset",
    APPLIES_TO_ALL: "Voimassa kaikille sovelluksessa",
    SELECTED: "Valittu",
    DESELECT: "Poista valinta",
    CONFIRM_BULK: "Vahvista",
    ONETIME: "Kertakäyttöinen",
    SET_SCHEDULE: "Aseta aikataulu",
    USER_GROUPS: "Käyttäjäryhmät",
    ADD_NEW_GROUP: "Lisää uusi ryhmä",
    SEARCH_USER_EMAIL_PHONE: "Hae käyttäjää sähköpostilla tai puhelinnumerolla",
    ADD_NEW: "Lisää uusi",
    BONUS_SYSTEM: "Bonusjärjestelmä",
    GROUP_NAME: "Ryhmän nimi",
    DISCOUNT_CODES: "Alennuskoodit ",
    ADD_SUBCATEGORY: "Lisää alakategoria",
    CREATE_MENU_SCHEDULE: "Luo menulle aikataulu, jonka mukaan se otetaan automaattisesti käyttöön",
    DISCOUNTPERCENT: "Alennusprosentti",
    APPLY_AUTOMATICALLY: "Käytä tätä koodia automaattisesti sovelluksen asiakkaille",
    APPLY_CODE_AUTOMATICALLY: "Käytä koodia automaattisesti",
    SINGLE_OFFER: "Kertatarjous",
    MULTIPLE_OFFER: "Monikäyttöinen tarjous",
    SEND_PUSH: "Push-ilmoitus",
    SEND_PUSH_TEXT: "Push-ilmoitus lähtee heti kaikille asiakkaille, jotka ovat sallineet tämän ravintolan ilmoitukset",
    SEND: "Lähetä",
    ADD_NEW_USERGROUP: "Uusi käyttäjäryhmä",
    ADD_NEW_USERGROUP_LABEL: "Anna uuden käyttäjäryhmän nimi",
    FRANCHISE_ID: "Ketjun tunnus",
    USER_GROUP_ID: "Käyttäjäryhmän tunnus",
    ARE_YOU_SURE_DELETE_OFFER: "Haluatko varmasti poistaa tämän tarjouksen?",
    DELETE_OFFER: "Poista tarjous",
    DELETE: "Poista",
    PRODUCT_LIST: "Tuoteluettelo",
    ALTERNATIVES: "Vaihtoehto",
    HEADER_EX: "Otsikko (esim. paistoaste)",
    OPTION_TYPE: "Lisäkkeen tyyppi",
    SEARCH_EMAIL_ORDER_CODE: "Hae sähköpostilla tai käyttäjätunnuksella",
    GUEST_INFORMATION: "Vieraan tiedot",
    SIGNED_IN: "Kirjautunut",
    CHECKBOX_OPTION: "Valinnainen lisäke",
    NAME_ADDON: "Lisäkkeen nimi",
    MULTIPLE: "Useita vaihtoehtoja",
    NEW_DELIVERY_LOCATION: "Uusi toimituspaikka",
    DELIVERY_LOCATIONS: "Toimituspaikat",
    NO_LOCATIONS_ADDED: "Paikkoja ei ole vielä lisätty",
    SELECT_CODE: "Valitse koodi",
    CONFIRM_ADJUSTMENTS: "Vahvista",
    PRICE: "Hinta",
    OPTIONS: "Lisäke",
    OPTIONS_NEWS: "Vaihtoehdot",
    COPY_FROM: "Kopioi kohteesta",
    USING_STEP_BY_STEP: "Käytetään vaiheittaista kulkua",
    HEADER: "Otsikko",
    SUBHEADER: "Alaotsikko",
    LINK_WITH: "Linkitetty",
    EDIT_EXCEPTION: "Muokkaa poikkeuksia",
    EDIT_LOCATIONS: "Muokkaa paikkoja",
    REASON: "Syy",
    REASON_DETAILS: "Syyn tarkemmat tiedot",
    ACCOUNTING: "Kirjanpito",
    SEARCH_PRODUCT: "Hae tuotetta",
    DELIVERY_TYPES: "Toimitustavat",
    REMOVE_EXCEPTION_CONFIRM: "Haluatko poistaa poikkeuksen?",
    REMOVE_EXCEPTION: "Poista poikkeus",
    SAVE_WITHOUT_ACCOUNTING: "Tuotetta ei voi tallentaa ilman kirjanpitotietoja ja tuotetyyppiä ",
    REMOVE_PRODUCT_RESTURANTS: "Haluatko poistaa tuotteen useammasta ravintolasta",
    PRODUCT_SHARED: "Tuote jaettu!",
    PRODUCT_SAVED: "Tuote tallennettu",
    PRODUCT_INFORMATION: "Tuotetiedot",
    ADDON_LIST: "Lisäkeluettelo",
    BASIC_INFO: "Perustiedot",
    EDIT_CATEGORY: "Muokkaa kategoriaa",
    NO_CRITERIA_ADDED: "Tarjoukselle ei ole lisätty ehtoja",
    ACTIVE: "Aktiivinen",
    SEARCH_USER: "Hae käyttäjää",
    CUSTOMER_INFORMATION: "Asiakastiedot",
    ALLOW_USER_TO_TRANSFER_MONEY_TO_WALLET_IN_APP: "Salli käyttäjien siirtää rahaa",
    ALLOW_USER_TO_TRANSFER_ANY_AMOUNT_TO_MOBILE_WALLET: "Salli käyttäjien siirtää mikä tahansa summa",
    PRODUCT_ACTIVE: "Tuote aktiivinen",
    PRICE_KR: "Hinta",
    WEIGHT_BASED_PRODUCT: "Painoon perustuva tuote",
    WEIGHT_BASED_HINT: "Asiakas valitsee painon sovelluksessa. Hinta lasketaan kaavalla paino grammoina / 100 × hinta per 100 g.",
    WEIGHT_BASED_APP_ONLY: "Tämä tuote on saatavilla vain sovelluksessa. Sitä ei voi näyttää pikakassalla tai verkkotilauksessa.",
    PRICE_PER_100G: "Hinta per 100 g",
    MIN_WEIGHT_G: "Vähimmäispaino (g)",
    MAX_WEIGHT_G: "Enimmäispaino (g)",
    WEIGHT_STEP_G: "Painon porrastus (g)",
    PER_100_G: "/ 100 g",
    WEIGHT_CONFIG_INVALID: "Virheelliset painoasetukset. Vähimmäispainon on oltava vähintään porrastuksen suuruinen, enimmäispainon on oltava suurempi kuin vähimmäispaino, ja erotuksen (enimmäis − vähimmäis) on oltava jaollinen porrastuksella.",
    WEIGHT_BASED_INCOMPATIBLE: "Painoon perustuvaa hinnoittelua ei voi yhdistää Build-a-Burger-toimintoon tai yhdistelmätuotteisiin.",
    BONUS_CONVERT: "Prosenttiosuus, joka muuttuu bonuspisteiksi tätä tuotetta ostettaessa",
    BONUS_CONVERT_WALLET: "Prosenttiosuus, joka muuttuu bonuspisteiksi mobiililompakkoa ladattaessa",
    NOT_ALLOWED_TO_BY_WITH_BONUS: "Ei voi ostaa bonuspisteillä",
    DESCRIPTION: "Kuvaus",
    BONUS_POINTS: "Bonuspisteet",
    TOP_UP: "Lataa saldoa",
    PAYMENT: "Maksu",
    BALANCE_ADJUSTED: "Saldoa muutettu",
    AMOUNT_EXCEEDS_BALANCE: " Summa ylittää saldon",
    ERROR_FETCHING_TRANSACTIONS: "Tapahtumia ei löytynyt. Yritä myöhemmin uudelleen.",
    SALDO: "Saldo",
    INVALID_DATE_RANGE: "Alkupäivän on oltava ennen loppupäivää.",
    TRANSACTIONS: "Tapahtumat",
    DESCRIPTION_SHORT: "Lyhyt kuvaus",
    DESCRIPTION_LONG: "Pitkä kuvaus",
    CATEGORY_BONG_INFO: "Kategoria-asetukset",
    LOYALTY: "Kanta-asiakkuus",
    NAME_ON_BONG: "Nimi keittiötulosteessa (valinnainen)",
    PRODUCT_TYPE: "Tuotetyyppi",
    PRODUCT_NAME: "Tuotteen nimi",
    PRODUCT_CATEGORY: "Tuotekategoria",
    PRICE_KR_STUDENT: "Opiskelijahinta",
    PRICE_KR_STUDENT_DEDUCTION: "Opiskelija-alennus",
    BONG_CATEGORY: "Keittiötulostuskategoria",
    ACCOUNTING_VAT: "Kirjanpito ja ALV",
    EXCEPTION: "Poikkeus",
    CONTAINS_ALCOHOL: "Sisältää alkoholia ",
    AGE_LIMIT: "Ikäraja 18+",
    PURCHASE: "Osto",
    COST: "Kustannus",
    MARGIN: "Kate",
    TAGS: "Tunnisteet",
    NEW_TAG: "Uusi tunniste",
    MOBILE_WALLET: "Mobiililompakko",
    EXTERNAL_ID: "Ulkoinen tunnus",
    STOCK_BALANCE: "Varastosaldo",
    COUNT: "Määrä",
    ACOUNTINGS: "Kirjanpitotilit",
    VAT_RATE: "ALV-kanta",
    VAT_RATES: "ALV-kannat",
    ACCOUNTING_ACCOUNT: "Tili",
    NO_ACCOUNT: "Ei tiliä",
    ACCOUNTING_CREATED: "Kirjanpitotili luotu",
    PAYMENT_TYPES: "Maksutapa",
    ACTIVATED_PAYMENT_TYPES: "Käytössä oleva maksutapa",
    ADITIONAL_PAYMENT_TYPES: "Lisää maksutapoja",
    NO_PAYMENT_TYPES: "ei ole ottanut käyttöön yhtään maksutapaa. Ota maksutapa käyttöön napauttamalla Lisää maksutapoja",
    ADDED: "Lisätty",
    PAYMENT_FEES: "Joihinkin maksutapoihin liittyy maksuja. Voit valita niille tässä kirjanpitotilit ",
    VAT: "ALV",
    HOME: "Etusivu",
    HOME_DELIVERY: "Kotiinkuljetus",
    RESTAURANT: "Ravintola",
    RESTAURANT_INFORMATION: "Ravintolan tiedot",
    COMPANY_INFORMATION: "Yrityksen tiedot",
    MENU: "Menu",
    REDEMPTION_AGREEMENT: "Lunastussopimus",
    MANAGE: "Hallinnoi",
    REPORTS: "Raportit",
    PREPARING_REPORT: "Valmistellaan raporttia...",
    REPORT_STATUS_QUEUED: "Jonossa...",
    REPORT_STATUS_RUNNING: "Luodaan raporttia...",
    REPORT_STATUS_DONE: "Valmis, haetaan tiedostoa...",
    REPORT_RUNS_IN_BACKGROUND: "Voit sulkea tämän ikkunan - raportin luonti jatkuu.",
    SCHEDULED_REPORTS: "Ajastetut raportit",
    SCHEDULED_REPORTS_DESCRIPTION: "Automaattisesti luotavat raportit, jotka lähetetään sähköpostitse CSV-liitteinä.",
    SCHEDULED_REPORTS_NO_ACCESS: "Sinulla ei ole pääsyä ajastettuihin raportteihin. Pyydä PubQ-ylläpitäjää lisäämään sinut.",
    SCHEDULED_REPORTS_EMPTY: "Ajastettuja raportteja ei vielä ole.",
    SCHEDULED_REPORT_ADD: "Uusi ajastettu raportti",
    SCHEDULED_REPORT_EDIT: "Muokkaa ajastettua raporttia",
    SCHEDULED_REPORT_SECTION_REPORT: "Raportti",
    SCHEDULED_REPORT_SECTION_SETTINGS: "Asetukset",
    SCHEDULED_REPORT_NAME_PLACEHOLDER: "esim. Laskutusperuste, kahdesti kuukaudessa",
    SCHEDULED_REPORT_TYPE: "Raportti",
    SCHEDULED_REPORT_TYPE_PLACEHOLDER: "Valitse raportti",
    SCHEDULED_REPORT_SCHEDULE: "Aikataulu",
    SCHEDULED_REPORT_UNITS: "Yksiköt",
    SCHEDULED_REPORT_UNITS_HINT: "Kaikkien valittujen yksiköiden on kuuluttava samaan ketjuun.",
    SCHEDULED_REPORT_FRANCHISE: "Ketju",
    SCHEDULED_REPORT_FRANCHISE_MIXED: "Valitut yksiköt kuuluvat eri ketjuihin.",
    SCHEDULED_REPORT_FRANCHISE_MISSING: "Valittujen yksiköiden ketjua ei löytynyt.",
    SCHEDULED_REPORT_RESOLVING_FRANCHISE: "Haetaan ketjua...",
    SCHEDULED_REPORT_RECIPIENTS: "Vastaanottajat",
    SCHEDULED_REPORT_RECIPIENTS_HINT: "Paina Enter tai pilkku jokaisen osoitteen jälkeen. Jokainen vastaanottaja saa oman sähköpostinsa.",
    SCHEDULED_REPORT_INVALID_EMAIL: "Virheellinen sähköpostiosoite",
    SCHEDULED_REPORT_TRIGGERS: "Lähetysajankohta",
    SCHEDULED_REPORT_TRIGGERS_HINT: "Jokainen raportti lähetetään heti keskiyön jälkeen (klo 00.30 Ruotsin aikaa) vastaavaa päivää seuraavana yönä, ja se kattaa valitun jakson kyseisen päivän loppuun asti.",
    SCHEDULED_REPORT_ADD_TRIGGER: "Lisää raporttipäivä",
    SCHEDULED_REPORT_PRESET_HALF_MONTH: "Kahdesti kuukaudessa (15. päivä ja viimeinen päivä)",
    SCHEDULED_REPORT_SEND_ON: "Raporttipäivä",
    SCHEDULED_REPORT_SENT_ON: "lähetetty",
    SCHEDULED_REPORT_COVERING: "Kattaa",
    SCHEDULED_REPORT_DAY: "Päivä",
    SCHEDULED_REPORT_WEEKDAY: "Viikonpäivä",
    SCHEDULED_REPORT_DAY_OF_MONTH: "Kuukauden päivä",
    SCHEDULED_REPORT_LAST_DAY_OF_MONTH: "Kuukauden viimeinen päivä",
    SCHEDULED_REPORT_DAY_OF_WEEK: "Viikonpäivä",
    SCHEDULED_REPORT_DAILY: "Joka päivä",
    SCHEDULED_REPORT_EVERY: "Joka",
    SCHEDULED_REPORT_RANGE_FIRST_HALF: "Kuukauden 1.–15. päivä",
    SCHEDULED_REPORT_RANGE_SECOND_HALF: "Kuukauden 16. päivästä viimeiseen päivään",
    SCHEDULED_REPORT_RANGE_PREVIOUS_MONTH: "Edellinen kuukausi",
    SCHEDULED_REPORT_RANGE_MONTH_TO_DATE: "Kuukauden alusta tähän päivään",
    SCHEDULED_REPORT_RANGE_LAST_7_DAYS: "Viimeiset 7 päivää",
    SCHEDULED_REPORT_RANGE_CUSTOM: "Mukautettu (päivät suhteessa raporttipäivään)",
    SCHEDULED_REPORT_RANGE_CUSTOM_SHORT: "Päivät",
    SCHEDULED_REPORT_FROM_DAY: "Alkupäivä",
    SCHEDULED_REPORT_TO_DAY: "Loppupäivä",
    SCHEDULED_REPORT_TIME_ZONE: "Aikavyöhyke",
    SCHEDULED_REPORT_ENABLED: "Käytössä",
    SCHEDULED_REPORT_LAST_RUN: "Viimeisin ajo",
    SCHEDULED_REPORT_NEXT_RUN: "Seuraava ajo",
    SCHEDULED_REPORT_NEXT_RUNS: "Seuraavat",
    SCHEDULED_REPORT_NEVER_RUN: "Ei vielä ajettu",
    SCHEDULED_REPORT_STATUS_QUEUED: "Jonossa",
    SCHEDULED_REPORT_STATUS_RUNNING: "Käynnissä",
    SCHEDULED_REPORT_STATUS_SENT: "Lähetetty",
    SCHEDULED_REPORT_STATUS_PARTIAL: "Osittain lähetetty",
    SCHEDULED_REPORT_STATUS_FAILED: "Epäonnistui",
    SCHEDULED_REPORT_STATUS_CANCELLED: "Peruttu",
    SCHEDULED_REPORT_STATUS_ENQUEUE_FAILED: "Jonoon lisääminen epäonnistui",
    SCHEDULED_REPORT_STATUS_INVALID: "Virheellinen aikataulu",
    SCHEDULED_REPORT_SAVED: "Ajastettu raportti tallennettu",
    SCHEDULED_REPORT_DELETED: "Ajastettu raportti poistettu",
    SCHEDULED_REPORT_DELETE_TITLE: "Poista ajastettu raportti",
    SCHEDULED_REPORT_DELETE_CONFIRM: "Poistetaanko tämä ajastettu raportti? Siitä ei lähetetä enää sähköposteja.",
    SCHEDULED_REPORT_SAVE_FAILED: "Ajastetun raportin tallentaminen epäonnistui.",
    SCHEDULED_REPORT_DELETE_FAILED: "Ajastetun raportin poistaminen epäonnistui.",
    SCHEDULED_REPORT_TYPES_FAILED: "Raporttityyppien lataaminen epäonnistui.",
    SCHEDULED_REPORT_TOGGLE_FAILED: "Aikataulun muuttaminen epäonnistui.",
    SCHEDULED_REPORT_FIX_ERRORS: "Korjaa seuraavat ennen tallentamista:",
    SCHEDULED_REPORT_ERR_REPORT_TYPE: "Valitse raportti",
    SCHEDULED_REPORT_ERR_UNITS: "Valitse vähintään yksi yksikkö",
    SCHEDULED_REPORT_ERR_PARAM: "Täytä",
    SCHEDULED_REPORT_ERR_RECIPIENTS: "Lisää 1–20 vastaanottajaa",
    SCHEDULED_REPORT_ERR_TRIGGERS: "Lisää 1–10 raporttipäivää",
    SCHEDULED_REPORT_ERR_CUSTOM_RANGE: "Mukautetun jakson on alettava viimeistään sen päättymispäivänä, ja sen on oltava enintään 400 päivää",
    SCHEDULED_REPORT_ERR_DAY: "Valitse kelvollinen päivä",
    DOWNLOAD_USER_GROUP_REPORT: "Lataa raportti",
    SELECT_DATE: "Valitse päivämäärä",
    WORKING_LATE_MEALS_REPORT: "Lataa ylityöaterioiden raportti",
    EMPLOYEE_TAG_MEAL_REPORT: "Lataa henkilöstön ateriatunnisteraportti",
    WALLET_BALANCES_REPORT: "Lataa lompakkosaldojen raportti",
    USR_GRP_ORDERS_RPT_TITLE: "Käyttäjäryhmien tilaukset",
    USR_GRP_ORDERS_RPT_DESC: "Yksityiskohtainen raportti eri käyttäjäryhmien tekemistä tilauksista.",
    WRK_LATE_MEALS_RPT_TITLE: "Ylityöateriat",
    WRK_LATE_MEALS_RPT_DESC: "Yleiskatsaus tavallisen työajan ulkopuolella tilatuista aterioista.",
    EMPLY_TAG_MEAL_RPT_TITLE: "Henkilöstön ateriatunnisteet",
    EMPLY_TAG_MEAL_RPT_DESC: "Raportti henkilöstön aterioista tunnisteiden perusteella.",
    WALLET_BAL_RPT_TITLE: "Lompakkosaldot",
    WALLET_BAL_RPT_DESC: "Käyttäjien digitaalisten lompakoiden nykyiset saldot.",
    ADMIN: "Hallinta",
    NEWS: "Uutisvirta",
    APP: "Sovellus",
    POS: "KASSA",
    ADDON_GROUP_NAME: "Lisäkeryhmän nimi",
    VISIBLE_IF_MENU_ACTIVE: "Näkyvissä, jos menu on käytössä",
    PICK_ONE_OPTION: "VALITSE YKSI",
    SINGLE_OPTION: "VALINNAINEN",
    ADD_ADDON: "Lisää uusi lisäke",
    STAFF_CARD: "Henkilökuntakortti",
    MISC: "Muut",
    PAYMENT_METHOD: "Maksutapa",
    PAYMENT_SOURCE: "Maksun lähde",
    ACCOUNTINGS: "Kirjanpitotilit",
    SETTINGS: "Asetukset",
    X_REPORT_STARTED: "Aloitettu",
    RESTURANT_INFO: "Ravintolan tiedot",
    USERS: "Käyttäjät",
    SEE_ALL: "Näytä kaikki…",
    STATISTICS: "Tilastot",
    DARK_MODE: "Tumma ulkoasu",
    SELECT_UNIT: "Valitse yksikkö",
    SELECT_PRODUCTS: "Valitse tuotteet",
    OFFER_CONFIGURATION: "Tarjouksen määritykset",
    OFFER_DETAILS: "Tarjouksen tiedot",
    OPENING_H_SAVED: "Aukioloajat tallennettu",
    OPENING_H: "Aukioloajat",
    CLOSED: "Suljettu",
    OPENS: "Avautuu",
    CLOSES: "Sulkeutuu",
    YAMMER_SAVED: "Yammer tallennettu",
    TIKTOK_SAVED: "TikTok tallennettu",
    DEVIATIONS: "Poikkeusajat",
    NEW_DEVIATION: "Uusi poikkeusaika",
    DEVIATION_EXAMPLE: "Esim. joulu",
    DEVIATION_INCOMPLETE: "Tilaisuus, alkupäivä ja loppupäivä ovat pakollisia",
    DEVIATION_START_DATE_IN_PAST: "Alkupäivä ei voi olla ennen tätä päivää",
    DEVIATION_END_DATE_IN_PAST: "Loppupäivä ei voi olla ennen tätä päivää",
    OVERLAPPING_DEVIATION_DATE_RANGE: "Tämä aikaväli on päällekkäinen toisen poikkeusajan kanssa",
    OCCASION: "Tilaisuus",
    DEVIATION_DATE: "Päivämäärä",
    AMOUNT: "Summa",
    EDITOR: "Muokkaaja",
    SELECT_LOGO: "Valitse logo…",
    ORG_NO: "Y-tunnus",
    ADRESS: "Osoite",
    ZIP_CODE: "Postinumero",
    SEARCH_KEYWORD: "Hakusana",
    CLEAR: "Tyhjennä",
    POST_ADR: "Postitoimipaikka",
    PHONE: "Puhelin",
    BONUS_TOOLTIP: "Tähän tuotteeseen voi käyttää bonuspisteitä",
    CREATE_PRODUCT: "Luo tuote",
    EXPORT: "Vie",
    INVITE_USER: "Kutsu käyttäjä",
    EMAIL: "Sähköposti",
    ABOUT_US: "Tietoa meistä",
    ADD_USER: "Lisää käyttäjiä",
    ADD_DOMAIN_AUTO: "Käyttäjät, joiden sähköpostiosoite kuuluu näihin verkkotunnuksiin, liitetään automaattisesti tähän käyttäjäryhmään tiliä luotaessa",
    JUST_PUBQSE: "Esim. pelkkä pubq.se, ei @pubq.se",
    DOMAIN_EXAMPLE: "(esim. pelkkä pubq.se, ei @pubq.se)",
    SELECT_BONG_CATEGORY: "Valitse keittiötulostuskategoria",
    SELECT_TAGS_CATEGORY: "Valitse tunnisteet",
    SELECT_ELLIPSES: "Valitse...",
    SELECT_PRODUCT_CATEGORY: "Valitse tuotekategoria",
    SELECT_TYPE: "Valitse tyyppi",
    SELECT_TAGS: "Valitse tunnisteet",
    OVERVIEW: "Yleiskatsaus",
    NEW_ORDER: "Uusi tilaus",
    PERSONAL_BANK_DETAILS: "Henkilö- ja pankkitiedot",
    CART_ITEMS: "Ostoskorin tuotteet",
    INACTIVE: "Ei aktiivinen",
    LATEST_ORDERS: "Viimeisimmät tilaukset",
    LOAD: "Lataa",
    LOGO_AND_IMAGES: "Logot ja kuvat",
    MESSAGE: "Viesti",
    FONTS: "Fontit",
    DANGER: "Vaara",
    SUCCESS: "Onnistui",
    SECONDARY: "Toissijainen",
    BASE: "Perus",
    FIXED_LOCATIONS: "Kiinteät sijainnit",
    EAT_IN: "Syödään paikan päällä",
    TABLE_SERVICE: "Pöytiintarjoilu",
    PRIMARY: "Ensisijainen",
    COLORS: "Värit",
    ENVIRONMENT_IMAGES: "Napsauta tästä vaihtaaksesi logon ja ympäristökuvat",
    HIDE_ADVANCE_SETTINGS: "Piilota lisäasetukset",
    SHOW_ADVANCE_SETTINGS: "Näytä lisäasetukset",
    NEW_THEME: "Uusi teema",
    THEME_MAIN_TEXT: "Muuta verkkokauppasi fontteja ja värejä",
    SELECTED_PRODUCTS: "Valitut tuotteet",
    BACK: "Takaisin",
    THEMING: "Teemat",
    SAVED_CARDS: "Tallennetut kortit",
    CHOOSE: "Valitse...",
    ADD_OPTION: "Lisää vaihtoehto",
    ADD_PRODUCTS_TO_GROUP: "Lisää tuotteita",
    COPY_MENU: "Kopioi menu",
    COPY_MENU_CONFIRMATION: "Haluatko varmasti kopioida menun",
    LINK_ADDON_TO_PRODUCT: "Linkitä lisäke tuotteeseen",
    LINK_TO_PRODUCT_OR_WEBSITE: "Linkki tuotteeseen tai verkkosivulle",
    LINK_TO_PRODUCT: "Linkki tuotteeseen",
    TYPE_OF_OFFER: "Tarjouksen tyyppi",
    START_WITH_HTTPS: "on alettava https://",
    WHERE_IS_PRODUCT: "Missä tuote on?",
    OFFER_INFO_PLACEHODLER: "Tietoa tarjouksesta...",
    OPTION_DESCRIPTION: "Tarjouksen kuvaus",
    SELECT: "Valitse",
    DISCOUNT_PERCENTAGE_PLACEHOLDER: "Alennus prosentteina",
    WRITE: "Kirjoita...",
    SEARCH_PRODUCT_OR_TAG: "Hae tuotetta tai tunnistetta",
    STEP_PLACEHOLDER: "Vaihe vaiheittaiselle tuotteelle",
    ABOUT_US_PLACEHOLDER: "Tietoa meistä",
    DOMAIN_EX: "Verkkotunnus, esim. pubq.se",
    TIME_CONTROL_MENU: "Aseta menulle aikataulu",
    SET: "Aseta",
    LANGUAGE: "Kieli",
    SCHEDULE: "Aikataulu",
    ANONYMOUS_ACCOUNT: "Anonyymi tili",
    INFORMATION: "Tiedot",
    ACTIVATION_TIME: "Aktivointiaika",
    ACTIVATE_MENU: "Aktivoi menu",
    STATUS: "Tila",
    PUBLISHED: "Julkaistu",
    UNPUBLISHED: "Julkaisematon",
    WEEK: "Viikko",
    SELECT_Z_REPORT: "Valitse Z-raportit",
    FROM_TO: "Alkaen - päättyen",
    PRODUCT_NEED_EXT_ID: "Sinun on täytettävä ulkoinen tunnus ennen kuin voit tallentaa tuotteen",
    EAT_IN_PRICE_WARNING: "Paikan päällä syötävän hinta ei voi olla normaalihintaa alempi",
    ACCOUNTING_WARNING: "Tuotteelle on lisättävä kirjanpitotiedot ennen kuin sen voi tallentaa",
    PRODUCT_TYPE_WARNING: "Sinun on valittava tuotetyyppi ennen kuin tuotteen voi tallentaa",
    PRODUCT_CATEGORY_WARNING: "Sinun on valittava tuotekategoria ennen kuin tuotteen voi tallentaa",
    PRODUCT_BONG_CATEGORY_WARNING: "Sinun on valittava keittiötulostuskategoria ennen kuin tuotteen voi tallentaa",
    SEND_END_TO_FORTNOX: "Lähetetäänkö päivän päätös Fortnoxiin?",
    IMPORT_SUCCESSFUL: "Tuonti onnistui",
    IMPORT_FAILED: "Tuonti epäonnistui",
    WHICH_EMAIL: "Mihin sähköpostiosoitteeseen lähetetään?",
    SUMD_Z_REPORTS: "Yhteenlasketut Z-raportit",
    Z_REPORT: "Z-raportit",
    MAIL: "Sähköposti",
    PREVIOUS_MONTH: "Edellinen kuukausi",
    COMPILATION: "Yhteenveto",
    JOURNALNR: "Lokinro",
    CREATED: "Luotu",
    RECEIPTNO_FROM_TO: "Kuitit alkaen - päättyen",
    CATEGORY_CREATED: "Kategoria luotu",
    SUM: "Summa",
    INTEGRATIONS_HEADER: "Integraatiot",
    BUY_REBUY: "Osto ja uusintaosto",
    WRONG_HIT: "Virhelyönti",
    CANCELD: "Peruttu",
    PROFORMA: "Proforma",
    CANCELED: "Peruttu",
    MOMS: "ALV",
    PURCHASE_REFUNDS: "Ostot ja palautukset",
    SKIPPED_RECEIPT: "Ohitettu",
    CREATING_ENDOFDAY: "Luodaan päivän päätöstä",
    NOT_ENOUGH: "Myyntiä ei ole ollut riittävästi",
    END_OF_DAY_100: "Päivän päätöksen myynnin piti olla yli 100.",
    Z_ENDOFDAY: "Päivän päätös",
    PREL_X_REPORT: "Alustava X-raportti",
    PAID: "Maksettu",
    SUM_PAYMENTS: "Maksut yhteensä",
    CHANGE_IN: "Vaihtoraha SISÄÄN",
    CHANGE_OUT: "Vaihtoraha ULOS",
    ACCOUNTING_REPORTS: "Kirjanpitoraportit",
    STARTED: "Aloitettu",
    SETTLED: "Tilitetty",
    FINISHED: "Päättynyt",
    ACCOUNTS: "Tilit",
    ROWS: "Rivit",
    SALES: "Myynti",
    NEWS_CAROUSEL: "Uutiskaruselli",
    TIMESLOTS: "Aikavälit",
    TEAM: "Tiimi",
    POS_TITLE: "POS",
    POS_BUTTONS: "POS-painikkeet",
    POS_V2_BUTTONS: "POS v2 -menut",
    POS_V2_MENUS: "POS v2 -menut",
    POS_V2_MENUS_TITLE: "POS-menut",
    POS_V2_MENUS_SUBTITLE: "Luo ja hallinnoi POS-menuja. Kassoillasi on aktiivisena vain yksi menu kerrallaan.",
    POS_V2_CREATE_MENU: "Luo menu",
    POS_V2_SEARCH_MENUS: "Hae menuja...",
    POS_V2_NO_MATCHING_MENUS: "Hakuasi vastaavia menuja ei löytynyt.",
    POS_V2_NEW_MENU_NAME: "Menun nimi",
    POS_V2_MENU_NAME_PLACEHOLDER: "esim. Lounas, Päivällinen, Baari",
    POS_V2_ACTIVE_MENU: "Aktiivinen",
    POS_V2_INACTIVE_MENU: "Ei aktiivinen",
    POS_V2_SET_ACTIVE: "Aseta aktiiviseksi",
    POS_V2_MENU_ACTIVE_SUCCESS: "Menu aktivoitu.",
    POS_V2_DUPLICATE_MENU: "Monista menu",
    POS_V2_DELETE_MENU: "Poista menu",
    POS_V2_DELETE_MENU_CONFIRM: "Haluatko varmasti poistaa menun \"{name}\"?",
    POS_V2_CANNOT_DELETE_ACTIVE_MENU: "Aktiivista menua ei voi poistaa. Aktivoi ensin toinen menu.",
    POS_V2_NO_MENUS_TITLE: "Ei vielä POS-menuja",
    POS_V2_NO_MENUS_HINT: "Luo ensimmäinen menusi aloittaaksesi kassojesi tasojen ja painikkeiden määrittämisen.",
    POS_V2_BACK_TO_MENUS: "Takaisin menuihin",
    POS_V2_EDIT_LAYERS: "Muokkaa tasoja",
    POS_V2_LAYERS_COUNT: "{count} tasoa",
    POS_V2_RENAME_MENU: "Nimeä menu uudelleen",
    POS_V2_LAYERS: "Tasot",
    POS_V2_LAYOUT_SAVED: "Asettelu tallennettu.",
    POS_V2_LAYOUT_SAVE_FAILED: "Asettelun tallennus epäonnistui. Yritä uudelleen.",
    POS_V2_UNSAVED_CHANGES_TITLE: "Tallentamattomia muutoksia",
    POS_V2_UNSAVED_CHANGES_CONFIRM: "Tässä menussa on tallentamattomia muutoksia. Haluatko hylätä ne ja palata menuihin?",
    POS_V2_DISCARD_AND_LEAVE: "Hylkää ja poistu",
    POS_V2_KEEP_EDITING: "Jatka muokkausta",
    POS_V2_CREATE_FAV_LAYER: "Luo suosikkitaso",
    POS_V2_FAV_LAYER: "Suosikit",
    POS_V2_TOGGLE_FAVORITE: "Lisää tai poista suosikeista",
    POS_V2_NO_LAYERS_TITLE: "Ei vielä tasoja",
    POS_V2_NO_LAYERS_HINT: "Luo ensimmäinen tasosi järjestääksesi kategoriat ja POS-painikkeet.",
    POS_V2_ADD_LAYER: "Lisää taso",
    POS_V2_ADD_CATEGORY: "Lisää kategoria",
    POS_V2_MENU_CATEGORIES: "Menun kategoriat",
    POS_V2_ALL_CATEGORIES_ADDED: "Kaikki menun kategoriat on lisätty tälle tasolle.",
    POS_V2_SEARCH_CATEGORIES: "Hae kategorioita...",
    POS_V2_SELECT_ALL_CATEGORIES: "Valitse kaikki",
    POS_V2_DESELECT_ALL_CATEGORIES: "Poista kaikki valinnat",
    POS_V2_CUSTOM_CATEGORY_NAME: "Kategorian nimi",
    POS_V2_CUSTOM_CATEGORY_PLACEHOLDER: "Anna kategorian nimi...",
    POS_V2_CUSTOM_CATEGORY_DESC: "Luo oma kategoria, johon voit lisätä tuotteita tai pikanäppäimiä käsin.",
    POS_V2_CREATE_CUSTOM_INSTEAD: "Luo sen sijaan oma kategoria",
    POS_V2_NO_MATCHING_CATEGORIES: "Hakua \"{query}\" vastaavia kategorioita ei löytynyt",
    POS_V2_ADD_MENU_CATEGORY: "Lisää olemassa oleva",
    POS_V2_ADD_CUSTOM_CATEGORY: "Lisää oma kategoria",
    POS_V2_RENAME_CUSTOM_CATEGORY: "Nimeä oma kategoria uudelleen",
    POS_V2_DRAG_CATEGORY: "Vedä järjestääksesi kategorian",
    POS_V2_CUSTOM_CATEGORY: "Oma",
    POS_V2_MENU_CATEGORY: "Menun kategoria",
    POS_V2_NO_PRODUCTS: "Ei tuotteita",
    POS_V2_CUSTOM_CATEGORY_HINT: "Lisää painikkeet tähän omaan kategoriaan käsin.",
    POS_V2_DELETE_LAYER: "Poista taso",
    POS_V2_DELETE_LAYER_CONFIRM: "Haluatko varmasti poistaa tason \"{name}\"?",
    POS_V2_DELETE_CATEGORY_CONFIRM: "Haluatko varmasti poistaa kategorian \"{name}\"?",
    POS_V2_DELETE_BUTTON: "Poista painike",
    POS_V2_DELETE_BUTTON_CONFIRM: "Haluatko varmasti poistaa painikkeen \"{name}\"?",
    POS_V2_BUTTON: "Painike",
    POS_V2_PAGE_SUBTITLE: "Määritä tasot, kategoriat ja POS-painikkeet.",
    POS_V2_SAVE_LAYOUT: "Tallenna asettelu",
    POS_V2_ADD_BUTTON: "Lisää painike",
    POS_V2_MANAGE_CATEGORY_PRODUCTS: "Hallinnoi tuotteita",
    POS_V2_ADD_PRODUCTS: "Lisää tuotteita",
    POS_V2_ADD_SELECTED: "Lisää valitut",
    POS_V2_SPECIAL_BUTTONS: "Erikoispainikkeet",
    POS_V2_IN_CATEGORY: "Kategoriassa",
    POS_V2_PRODUCT_CATALOG: "Tuoteluettelo",
    POS_V2_CUSTOM_LABEL: "Oma POS-nimi",
    POS_V2_CUSTOM_LABEL_PLACEHOLDER: "Painikkeen oma nimi...",
    POS_V2_ADD_FREE_TEXT_BTN: "Lisää vapaatekstipainike",
    POS_V2_ADD_STOCK_BTN: "Lisää alitasopainike",
    POS_V2_NO_PRODUCTS_IN_CATEGORY: "Tässä kategoriassa ei ole vielä painikkeita. Siirry tuoteluetteloon lisätäksesi tuotteita.",
    POS_V2_NO_PRODUCTS_FOUND: "Tuotteita ei löytynyt",
    POS_V2_SELECT_ALL: "Valitse kaikki",
    POS_V2_HIDE_ADDED: "Piilota jo lisätyt",
    POS_V2_FREE_TEXT_PREFILL_HINT: "Teksti, joka lisätään tuotteeseen painiketta painettaessa",
    POS_V2_LAYER_VISIBLE_IN_POS: "Näkyy POS:ssa",
    POS_V2_LAYER_HIDDEN: "Piilotettu POS:ssa",
    POS_V2_DRAG_LAYER: "Vedä järjestääksesi tason",
    POS_V2_LAYER_DISABLED_HINT: "Tämä taso on piilotettu POS v2 -kassasta, kunnes se otetaan käyttöön.",
    POS_V2_GENERATE_HINT: "Lisää painikkeet valitun kategorian menutuotteille. Korvaa tämän välilehden nykyiset painikkeet.",
    POS_V2_GENERATE_CONFIRM: "Luodaanko painikkeet valitun kategorian menutuotteista? Tämän välilehden nykyiset painikkeet korvataan.",
    POS_V2_GRID_EMPTY: "Ei vielä painikkeita. Lisää painike tai luo painikkeet menustasi.",
    POS_V2_NO_CATEGORIES_IN_LAYER: "Tällä tasolla ei ole kategorioita.",
    POS_V2_NO_BUTTONS_IN_CATEGORY: "Tässä kategoriassa ei ole painikkeita.",
    POS_V2_ALL_READONLY: "Vain luku. Valitse kategoria lisätäksesi tai muokataksesi painikkeita.",
    POS_V2_BUTTON_COLOR: "Väri",
    POS_V2_STOCK_EMPTY: "Lisää painikkeita tälle alitasolle +-ruudun avulla.",
    POS_V2_CUSTOM_NAME_TOGGLE: "Painikkeen oma nimi",
    POS_V2_CUSTOM_NAME_HINT: "Korvaa POS-painikkeessa näytettävä nimi",
    POS_V2_CUSTOM_NAME_LABEL: "Oma nimi",
    POS_V2_SYNCED_WITH_REGISTER: "Synkronoituu automaattisesti tuoterekisterin kanssa",
    GENERATE_POS_BUTTONS: "Luo painikkeet",
    POS_BUTTON_LINK_TYPE: "Mihin tämän painikkeen pitäisi linkittää?",
    PREFILLED_TEXT: "Esitäytetty teksti",
    POS_USERS: "POS-käyttäjät",
    POS_V2_USERS: "POS v2 -käyttäjät",
    STAFF_MENU: "Henkilökunta",
    STAFF_EMPLOYEES: "Työntekijät",
    STAFF_DEVICES: "Leimauskellot",
    STAFF_LEDGER: "Henkilöstöluettelo",
    STAFF_ACCESS_LOG: "Käyttöloki",
    STAFF_EMPLOYEES_SUBTITLE: "Henkilöt, jotka leimaavat sisään ja ulos sähköisessä henkilöstöluettelossa",
    STAFF_DEVICES_SUBTITLE: "Näihin toimitiloihin rekisteröidyt leimauskellot ja henkilökohtaiset puhelimet",
    STAFF_LEDGER_SUBTITLE: "Läsnäolo, työvuorot ja vienti tarkastuksia varten",
    STAFF_NOT_CONFIGURED: "Henkilöstöluetteloa ei ole määritetty tässä ympäristössä.",
    STAFF_ERROR: "Jokin meni pieleen",
    STAFF_SAVED: "Tallennettu",
    STAFF_RETRY: "Yritä uudelleen",
    STAFF_CANCEL: "Peruuta",
    STAFF_SAVE: "Tallenna",
    STAFF_DONE: "Valmis",
    STAFF_SEARCH: "Hae",
    STAFF_REQUIRED: "Pakollinen",
    STAFF_SETUP_TITLE: "Ota henkilöstöluettelo käyttöön",
    STAFF_SETUP_HINT: "Anna toimitilan tiedot. Yrityksen nimi ja Y-tunnus kirjataan jokaiseen luettelotapahtumaan.",
    STAFF_SETUP_REQUIRED: "Henkilöstöluetteloa ei ole vielä otettu käyttöön näissä toimitiloissa. Aloita kohdasta Työntekijät.",
    STAFF_DISPLAY_NAME: "Toimitilan nimi",
    STAFF_COMPANY_NAME: "Yrityksen nimi",
    STAFF_ORG_NO: "Y-tunnus",
    STAFF_ADDRESS: "Osoite",
    STAFF_SETUP_SAVE: "Aloita",
    STAFF_ADD_EMPLOYEE: "Lisää työntekijä",
    STAFF_EDIT_EMPLOYEE: "Muokkaa työntekijää",
    STAFF_FORM_HINT: "Käytetään henkilöstöluettelossa. Aiemmat tapahtumat säilyttävät tuolloin voimassa olleet tiedot.",
    STAFF_SECTION_PERSON: "Henkilö",
    STAFF_SECTION_EMPLOYMENT: "Työsuhde",
    STAFF_SECTION_CONTACT: "Yhteystiedot",
    STAFF_FIRST_NAME: "Etunimi",
    STAFF_LAST_NAME: "Sukunimi",
    STAFF_NATIONAL_ID: "Henkilötunnus (personnummer tai samordningsnummer)",
    STAFF_NATIONAL_ID_HINT: "Tallennetaan suojattuna ja näytetään aina vain peitettynä. Ei voi muuttaa myöhemmin.",
    STAFF_ROLES: "Roolit",
    STAFF_ROLES_HINT: "Pilkuilla eroteltuna, esim. kokki, tarjoilija",
    STAFF_EMPLOYMENT_FORM: "Työsuhteen tyyppi",
    STAFF_START_DATE: "Aloituspäivä",
    STAFF_EMAIL: "Sähköposti",
    STAFF_PHONE: "Puhelin",
    STAFF_PIN: "PIN (4 numeroa)",
    STAFF_PIN_HINT: "Käytetään sisään- ja uloskirjautumiseen leimauksessa. Yksilöllinen ravintolan sisällä. Voidaan jättää tyhjäksi ja asettaa myöhemmin.",
    STAFF_PIN_INVALID: "4 numeroa, ei samaa numeroa toistettuna",
    STAFF_SET_PIN: "Aseta uusi PIN",
    STAFF_SET_PIN_HINT: "Vanha PIN lakkaa toimimasta heti verkossa ja leimauskelloissa niiden seuraavan synkronoinnin yhteydessä.",
    STAFF_PIN_SET_FOR: "Uusi PIN asetettu: {name}",
    STAFF_NO_PIN: "Ei PIN-koodia",
    STAFF_DEACTIVATE: "Päätä työsuhde",
    STAFF_DEACTIVATE_HINT: "Henkilö ei voi enää leimata. Hänen historiansa henkilöstöluettelossa säilyy.",
    STAFF_END_DATE: "Päättymispäivä",
    STAFF_SHOW_INACTIVE: "Näytä päättyneet",
    STAFF_EMPLOYEE: "Työntekijä",
    STAFF_IDENTITY: "Henkilöllisyys",
    STAFF_STATUS: "Tila",
    STAFF_STATUS_ACTIVE: "Aktiivinen",
    STAFF_STATUS_INACTIVE: "Päättynyt",
    STAFF_NO_EMPLOYEES: "Ei vielä työntekijöitä",
    STAFF_NO_EMPLOYEES_HINT: "Lisää henkilöt, jotka leimaavat näissä toimitiloissa.",
    STAFF_ENROL_DEVICE: "Rekisteröi laite",
    STAFF_SCOPE: "Tyyppi",
    STAFF_SCOPE_WORKPLACE: "Yhteinen leimauskello",
    STAFF_SCOPE_EMPLOYEE: "Henkilökohtainen puhelin",
    STAFF_SCOPE_EMPLOYEE_HINT: "Henkilökohtaisella puhelimella voi leimata vain yhdelle henkilölle, ja siihen tallennetaan vain kyseisen henkilön PIN.",
    STAFF_DEVICE_NAME: "Laitteen nimi",
    STAFF_CODE_VALID_MINUTES: "Koodi voimassa",
    STAFF_CREATE_CODE: "Luo koodi",
    STAFF_NEW_CODE: "Uusi koodi",
    STAFF_CODE_HINT: "Skannaa QR-koodi laitteella, avaa linkki tai kirjoita koodi. Sitä voi käyttää kerran.",
    STAFF_CODE_EXPIRES: "Vanhenee: {time}",
    STAFF_CODE_EXPIRED: "Koodi on vanhentunut. Luo uusi.",
    STAFF_COPY_LINK: "Kopioi linkki",
    STAFF_LINK_COPIED: "Linkki kopioitu",
    STAFF_OPEN_LINK: "Avaa",
    STAFF_DEVICE: "Laite",
    STAFF_ENROLLED: "Rekisteröity",
    STAFF_LAST_SEEN: "Viimeksi nähty",
    STAFF_NEVER: "Ei koskaan",
    STAFF_JUST_NOW: "Juuri nyt",
    STAFF_MINUTES_AGO: "{n} min sitten",
    STAFF_REVOKE: "Peru käyttöoikeus",
    STAFF_REVOKED: "Käyttöoikeus peruttu",
    STAFF_REVOKE_HINT: "Laite lakkaa toimimasta seuraavassa pyynnössään. Leimaukset, joita se ei ole synkronoinut, jäävät laitteeseen, kunnes se rekisteröidään uudelleen.",
    STAFF_REASON: "Syy",
    STAFF_NO_DEVICES: "Ei rekisteröityjä laitteita",
    STAFF_NO_DEVICES_HINT: "Rekisteröi henkilökunnan sisäänkäynnin leimauskello kertakäyttöisellä koodilla.",
    STAFF_PRESENT_NOW: "Paikalla nyt",
    STAFF_NOBODY_PRESENT: "Kukaan ei ole paikalla.",
    STAFF_SINCE: "Alkaen",
    STAFF_PERIOD: "Jakso",
    STAFF_SHIFTS: "Työvuorot",
    STAFF_EVENTS: "Tapahtumat",
    STAFF_START: "Alku",
    STAFF_END: "Loppu",
    STAFF_DURATION: "Kesto",
    STAFF_NOTES: "Muistiinpanot",
    STAFF_NO_SHIFTS: "Ei työvuoroja tällä jaksolla.",
    STAFF_ANOMALY_OPEN: "Ei uloskirjausta",
    STAFF_ANOMALY_DUPLICATE_IN: "Kaksoissisäänkirjaus",
    STAFF_ANOMALY_ORPHAN_OUT: "Uloskirjaus ilman sisäänkirjausta",
    STAFF_OFFLINE_CAPTURED: "Tallennettu offline-tilassa",
    STAFF_INTEGRITY_OK: "Ketju vahvistettu",
    STAFF_INTEGRITY_BROKEN: "Ketju on katkennut",
    STAFF_EXPORT: "Vie",
    STAFF_EXPORT_JSON: "JSON",
    STAFF_EXPORT_SHIFTS_CSV: "Työvuorot (CSV)",
    STAFF_EXPORT_EVENTS_CSV: "Kirjausketju (CSV)",
    STAFF_EXPORT_WITH_IDS: "Vie henkilötunnusten kanssa",
    STAFF_EXPORT_WITH_IDS_HINT: "Henkilötunnukset luovutetaan vain ilmoitetusta syystä. Syy ja paljastettujen tunnusten määrä kirjataan lokiin.",
    STAFF_EXPORT_FORMAT: "Muoto",
    STAFF_EXPORT_REASON_PLACEHOLDER: "esim. Verohallinnon tarkastus",
    STAFF_EXPORT_DONE: "Vienti ladattu",
    STAFF_TIME: "Aika",
    STAFF_TYPE: "Tyyppi",
    STAFF_IDENTIFICATION: "Tunnistus",
    STAFF_RECORDED_BY: "Kirjannut",
    STAFF_SUPERSEDED: "Korvattu",
    STAFF_TYPE_PUNCH_IN: "Sisäänkirjaus",
    STAFF_TYPE_PUNCH_OUT: "Uloskirjaus",
    STAFF_TYPE_PUNCH_CORRECTION: "Korjaus",
    STAFF_TYPE_PUNCH_VOID: "Mitätöinti",
    STAFF_VERIFIED_SERVER: "PIN (palvelimen tarkistama)",
    STAFF_VERIFIED_DEVICE: "PIN (tarkistettu offline-tilassa laitteella)",
    STAFF_VERIFIED_NONE: "Ei vahvistettu",
    STAFF_BY_MANAGER: "Esihenkilö",
    STAFF_CORRECT: "Korjaa",
    STAFF_VOID: "Mitätöi",
    STAFF_CORRECT_HINT: "Korjaus lisätään uutena tapahtumana. Alkuperäinen säilyy ja näkyy edelleen kirjausketjussa.",
    STAFF_VOID_HINT: "Mitätöinti lisätään uutena tapahtumana ja poistaa leimauksen työvuoroista. Alkuperäinen säilyy kirjausketjussa.",
    STAFF_CORRECTED_TYPE: "Pitäisi olla",
    STAFF_CORRECTED_TIME: "Oikea aika",
    STAFF_ACCESS_LOG_SUBTITLE: "Kuka teki mitä: viennit ja paljastetut henkilötunnukset, PIN-koodit, laitteet ja työntekijämuutokset",
    STAFF_ACTION: "Toiminto",
    STAFF_ACTOR: "Suorittaja",
    STAFF_TARGET: "Kohde",
    STAFF_IDS_REVEALED: "Henkilötunnukset",
    STAFF_NO_LOG: "Ei merkintöjä tällä jaksolla.",
    STAFF_ACTION_LEDGER_EXPORT: "Henkilöstöluettelon vienti",
    STAFF_ACTION_LEDGER_READ: "Henkilöstöluettelo luettu",
    STAFF_ADD_TILL_INTRO_NO_STAFF: "Luo uusi kassa ja anna sille nimi. Syötä sitten sen laitetunnus POS-järjestelmään ottaaksesi sen käyttöön.",
    STAFF_TILL_NAME_REQUIRED: "Anna kassalle nimi.",
    STAFF_TILL_CREATE_FAILED: "Kassan luominen epäonnistui. Yritä uudelleen.",
    STAFF_TILL_NEW_CODE_TITLE: "Uusi kertakäyttökoodi kassalle",
    STAFF_TILL_NEW_CODE_INTRO: "Luo kertakäyttökoodi, joka yhdistää henkilökunnan PIN-kirjautumisen tähän kassaan.",
    STAFF_TILL_DEVICE_ID: "Kassan laitetunnus",
    STAFF_TILL_STEP_SETUP_ID: "Syötä laitetunnus kohtaan \"Ota tämä kassa käyttöön\" ja paina Rekisteröi.",
    STAFF_ADD_TILL: "Lisää kassa",
    STAFF_ADD_TILL_INTRO: "Luo uusi kassa ja anna sille nimi. Saat kertakäyttökoodin juuri tälle kassalle: kun syötät sen POS-järjestelmään, kassa otetaan käyttöön ja henkilökunnan PIN-kirjautuminen yhdistetään samalla.",
    STAFF_TILL_NAME: "Kassan nimi",
    STAFF_TILL_NAME_PLACEHOLDER: "esim. Kassa 2",
    STAFF_TILL_NAME_HINT: "Nimi asetetaan vain täällä — POS hakee sen täältä.",
    STAFF_TILL_CREATE_CODE: "Luo koodi",
    STAFF_TILL_CODE_LABEL: "Kassan kertakäyttökoodi",
    STAFF_TILL_STEP_OPEN: "Avaa POS uudella laitteella ja kirjaudu yksikköön.",
    STAFF_TILL_STEP_SETUP: "Syötä kertakäyttökoodi kohtaan \"Ota tämä kassa käyttöön\" ja paina Rekisteröi.",
    STAFF_TILL_STEP_DONE: "Valmis. Kassa näkyy kohdassa POS → Laitteet, ja henkilökunta kirjautuu PIN-koodillaan.",
    STAFF_TILL_CODE_UNAVAILABLE: "Henkilöstömoduuli ei ole käytössä tässä yksikössä, tai sinulla ei ole siihen käyttöoikeutta. Ilman sitä uusi kassa rekisteröidään itse kassalla pelkällä nimellä.",
    STAFF_KIND_TILL: "Kassa",
    STAFF_KIND_KIOSK: "Leimauskello",
    STAFF_ACTION_EMPLOYEE_POS_ACCESS: "Kassan käyttöoikeus muutettu",
    STAFF_POS_ACCESS: "Kassan käyttöoikeus",
    STAFF_POS_ENABLED: "Saa käyttää kassaa",
    STAFF_POS_ENABLED_HINT: "Kirjautuminen kassalle tapahtuu samalla 4-numeroisella PIN-koodilla kuin leimauskellossa. Nimi tulostuu kuittiin ja kirjautuu sähköiseen päiväkirjaan.",
    STAFF_POS_PERMISSIONS: "Kassan oikeudet",
    STAFF_POS_MAX_DISCOUNT: "Enimmäisalennus",
    STAFF_POS_PERM_REFUND: "Saa tehdä palautuksia",
    STAFF_POS_PERM_REMOVE_FROM_TAB: "Saa poistaa tuotteita avoimelta laskulta",
    STAFF_POS_PERM_SPLIT_TAB: "Saa jakaa avoimen laskun",
    STAFF_POS_PERM_VIEW_SETTINGS: "Saa avata kassan asetukset",
    STAFF_POS_PERM_VIEW_JOURNAL: "Saa lukea kassan sähköistä päiväkirjaa",
    STAFF_POS_PERM_VIEW_JOURNAL_HINT: "POS näyttää omat päiväkirjamerkintänsä (journalminne). Koko päiväkirjaa luetaan admin-näkymässä.",
    STAFF_POS_PERM_MOVE_BOOKING: "Saa siirtää varauksia",
    STAFF_POS_PERM_EDIT_BOOKING_TIME: "Saa muuttaa varausten aikoja",
    STAFF_POS_PERM_EDIT_TABLE_MAP: "Saa muokata pöytäkarttaa",
    STAFF_POS_NEEDS_PIN: "Aseta ensin PIN — ilman sitä kassalle ei voi kirjautua.",
    STAFF_POS_HANDLE: "Kassatunnus",
    STAFF_POS_HANDLE_HINT: "Numero, joka tulostuu kuitteihin ja kirjataan päiväkirjaan. Se ei koskaan muutu.",
    STAFF_PUNCH_ONLY: "Vain leimauskello",
    STAFF_POS_GRANTED: "{name} voi nyt käyttää kassaa (kassatunnus #{id}).",
    STAFF_POS_WITHDRAWN: "Käyttäjällä {name} ei ole enää kassan käyttöoikeutta.",
    STAFF_REQUIRE_PUNCH_TO_SELL: "Vaadi sisäänleimaus ennen kassan käyttöä",
    STAFF_REQUIRE_PUNCH_TO_SELL_HINT: "Kun tämä on päällä, kukaan ei voi kirjautua kassalle, ellei ole leimannut sisään henkilöstöluetteloon.",
    STAFF_ACTION_LEDGER_MANUAL_PUNCH: "Manuaalinen leimaus lisätty",
    STAFF_ACTION_LEDGER_CORRECT: "Leimaus korjattu",
    STAFF_ACTION_LEDGER_VOID: "Leimaus mitätöity",
    STAFF_ACTIONS: "Toiminnot",
    STAFF_MANUAL_ENTRY: "Manuaalinen",
    STAFF_CLOSE_SHIFT: "Päätä työvuoro",
    STAFF_ADD_PUNCH: "Lisää leimaus",
    STAFF_MANUAL_HINT: "Lisää leimaus, jota leimauskello ei koskaan tallentanut. Se merkitään henkilöstöluetteloon manuaaliseksi syyn, nimesi ja kirjausajan kera.",
    STAFF_MANUAL_TIME: "Milloin työvuoro todellisuudessa alkoi tai päättyi",
    STAFF_MANUAL_AFTER: "Oltava jälkeen {time}.",
    STAFF_MANUAL_BEFORE: "Oltava ennen {time}.",
    STAFF_MANUAL_REASON_HINT: "Esim. Unohti leimata ulos, tarkistettu työvuorolistasta",
    STAFF_WHICH_PUNCH: "Koskee",
    STAFF_ACTION_IDENTITY_RESOLVE: "Henkilötunnus haettu",
    STAFF_ACTION_PIN_CREDENTIALS_ISSUE: "PIN-tunnistetiedot lähetetty laitteelle",
    STAFF_ACTION_WORKPLACE_UPSERT: "Toimitila tallennettu",
    STAFF_ACTION_EMPLOYEE_CREATE: "Työntekijä luotu",
    STAFF_ACTION_EMPLOYEE_UPDATE: "Työntekijä päivitetty",
    STAFF_ACTION_EMPLOYEE_PIN: "PIN asetettu",
    STAFF_ACTION_EMPLOYEE_DEACTIVATE: "Työsuhde päätetty",
    STAFF_ACTION_DEVICE_ENROLMENT_CODE: "Rekisteröintikoodi luotu",
    STAFF_ACTION_DEVICE_ENROL: "Laite rekisteröity",
    STAFF_ACTION_DEVICE_REVOKE: "Laitteen käyttöoikeus peruttu",
    STAFF_ACTION_PAYROLL_RATE_SET: "Palkka lisätty",
    STAFF_ACTION_PAYROLL_RATE_READ: "Palkkoja tarkasteltu",
    STAFF_ACTION_PAYROLL_REPORT: "Henkilöstökuluraporttia tarkasteltu",
    STAFF_PAYROLL: "Palkat",
    STAFF_PAYROLL_SUBTITLE: "Tunti- tai kuukausipalkka työntekijäkohtaisesti tietystä päivästä alkaen",
    STAFF_PAYROLL_SENSITIVE: "Palkkatiedot ovat arkaluonteisia. Jokainen tarkastelu ja muutos kirjataan käyttölokiin.",
    STAFF_LABOUR_COST: "Henkilöstökulut",
    STAFF_LABOUR_COST_SUBTITLE: "Henkilöstökulut verrattuna myyntiin päivittäin ja työntekijöittäin",
    STAFF_CURRENT_RATE: "Nykyinen palkka",
    STAFF_UPCOMING_RATE: "Tuleva",
    STAFF_NO_RATE: "Ei palkkaa",
    STAFF_NEW_RATE: "Uusi palkka",
    STAFF_NEW_RATE_HINT: "Uusi palkka lisätään tietystä päivästä alkaen. Aiempia palkkoja ei koskaan muuteta, joten jo lasketut henkilöstökulut pysyvät ennallaan.",
    STAFF_RATE_HISTORY: "Palkkahistoria",
    STAFF_RATE: "Palkka",
    STAFF_RATE_TYPE: "Palkkatyyppi",
    STAFF_RATE_HOURLY: "Tuntipalkka",
    STAFF_RATE_MONTHLY: "Kuukausipalkka",
    STAFF_VALID_FROM: "Voimassa alkaen",
    STAFF_OVERHEAD: "Työnantajamaksut / sivukulut (%)",
    STAFF_OVERHEAD_HINT: "Lisätään palkan päälle henkilöstökuluissa, esim. Ruotsin 31,42 %:n työnantajamaksut.",
    STAFF_PER_HOUR: "SEK/h",
    STAFF_PER_MONTH: "SEK/kk",
    STAFF_SET_BY: "Asettanut",
    STAFF_NO_HISTORY: "Palkkatasoa ei ole vielä kirjattu.",
    STAFF_SALES_NET: "Myynti ilman ALV:tä",
    STAFF_SALES_GROSS: "sis. ALV",
    STAFF_LABOUR_PCT: "Henkilöstökulut %",
    STAFF_HOURS: "Tunnit",
    STAFF_COSTED_HOURS: "palkkatasolla",
    STAFF_BY_DAY: "Päivittäin",
    STAFF_BY_EMPLOYEE: "Työntekijöittäin",
    STAFF_DATE: "Päivämäärä",
    STAFF_RATE_MISSING: "Palkkataso puuttuu",
    STAFF_WARNING_NO_RATE: "{n} työntekijää työskenteli ilman palkkatasoa — näitä tunteja ei ole laskettu kuluihin.",
    STAFF_WARNING_OPEN_SHIFTS: "{n} vuoroa on leimaamatta ulos, eikä niitä ole laskettu kuluihin.",
    STAFF_SALES_UNAVAILABLE: "Ei myyntiä tällä jaksolla — henkilöstökulut näytetään silti.",
    STAFF_SALES_SOURCE: "Myynti POS-kuiteista",
    STAFF_ASSUMPTIONS: "Näin se lasketaan",
    STAFF_GO_TO_PAYROLL: "Aseta palkkatasot",
    POS_V2_DEVICES: "POS v2 -laitteet",
    POS_JOURNAL_TITLE: "Kassapäiväkirja",
    POS_JOURNAL_INTRO: "Yksikön päiväkirjamuisti: kaikki kassat yhdessä sarjassa, uusimmat ensin.",
    POS_JOURNAL_REGISTER: "Kassa",
    POS_JOURNAL_SCOPE_UNIT: "kaikki kassat",
    POS_JOURNAL_SCOPE_DEVICE: "yksi kassa",
    POS_JOURNAL_DEVICE: "Kassa",
    POS_JOURNAL_ALL_DEVICES: "Kaikki kassat",
    POS_JOURNAL_NO_DEVICE: "Palvelin",
    POS_JOURNAL_SEQ: "Nro",
    POS_JOURNAL_TIME: "Aika",
    POS_JOURNAL_TYPE: "Tyyppi",
    POS_JOURNAL_RECEIPT: "Kuitti",
    POS_JOURNAL_AMOUNT: "Summa",
    POS_JOURNAL_CASHIER: "Kassahenkilö",
    POS_JOURNAL_OLDER: "Näytä vanhemmat",
    POS_JOURNAL_PERIOD: "Jakso",
    POS_JOURNAL_EMPTY_RANGE: "Valitulla jaksolla ei ole päiväkirjamerkintöjä.",
    POS_JOURNAL_RANGE_CAPPED: "Päiväkirja luetaan uusimmasta alkaen, joten vanhemmat jaksot ladataan vaiheittain. Siirry kauemmas taaksepäin valitsemalla Näytä vanhemmat.",
    POS_JOURNAL_COUNT_LOADED: "näytetty ladatuista merkinnöistä",
    POS_JOURNAL_RELOAD: "Lataa uudelleen",
    POS_JOURNAL_LOADING: "Ladataan päiväkirjaa…",
    POS_JOURNAL_EMPTY: "Tällä yksiköllä ei ole vielä päiväkirjamerkintöjä.",
    POS_JOURNAL_LOAD_FAILED: "Päiväkirjan lataaminen epäonnistui.",
    POS_JOURNAL_NO_PERMISSION: "Sinulla ei ole oikeutta lukea päiväkirjaa.",
    POS_JOURNAL_UNAVAILABLE: "Päiväkirja ei ole vielä käytettävissä tässä ympäristössä.",
    POS_JOURNAL_TYPE_SALE: "Myynti",
    POS_JOURNAL_TYPE_RETURN: "Palautus",
    POS_JOURNAL_TYPE_COPY: "Kuittikopio",
    POS_JOURNAL_TYPE_CORRECTION: "Korjaus",
    POS_JOURNAL_TYPE_PROFORMA: "Pro forma",
    POS_JOURNAL_TYPE_INTERRUPTED: "Keskeytetty",
    POS_JOURNAL_TYPE_X_REPORT: "X-raportti",
    POS_JOURNAL_TYPE_Z_REPORT: "Z-raportti",
    POS_JOURNAL_TYPE_LOGIN: "Kirjautuminen",
    POS_JOURNAL_TYPE_LOGOUT: "Uloskirjautuminen",
    POS_JOURNAL_TYPE_MODE_CHANGE: "Tilan vaihto",
    POS_JOURNAL_TYPE_CLOCK_CHANGE: "Kellonajan muutos",
    POS_JOURNAL_TYPE_PRICE_CHANGE: "Hinnanmuutos",
    POS_LOG_MEMORY_TITLE: "POS-tapahtumaloki",
    POS_LOG_MEMORY_INTRO: "Mitä kassoilla tehtiin: laskut, tuotteet, varaukset, keittiölähetykset ja maksut, uusimmat ensin.",
    POS_LOG_MEMORY_PERIOD: "Jakso",
    POS_LOG_MEMORY_TILL: "Kassa",
    POS_LOG_MEMORY_ALL_TILLS: "Kaikki kassat",
    POS_LOG_MEMORY_UNKNOWN_TILL: "Tuntematon kassa",
    POS_LOG_MEMORY_CASHIER: "Kassahenkilö",
    POS_LOG_MEMORY_ALL_CASHIERS: "Kaikki kassahenkilöt",
    POS_LOG_MEMORY_NO_CASHIER: "Ei kassahenkilöä",
    POS_LOG_MEMORY_RELOAD: "Lataa uudelleen",
    POS_LOG_MEMORY_TIME: "Aika",
    POS_LOG_MEMORY_TYPE: "Tapahtuma",
    POS_LOG_MEMORY_ORDER: "Tilaus",
    POS_LOG_MEMORY_DETAIL: "Tiedot",
    POS_LOG_MEMORY_LOADING: "Ladataan tapahtumalokia…",
    POS_LOG_MEMORY_EMPTY: "Tälle yksikölle ei ole kirjattu POS-tapahtumia valitulla jaksolla.",
    POS_LOG_MEMORY_EMPTY_FILTER: "Valitulle kassalle ja kassahenkilölle ei löydy tapahtumia.",
    POS_LOG_MEMORY_CAPPED: "Jaksolta luettiin vain uusimmat tapahtumat. Rajaa jaksoa nähdäksesi loput.",
    POS_LOG_MEMORY_COUNT_LOADED: "näytetty ladatuista tapahtumista",
    POS_LOG_MEMORY_LOAD_FAILED: "Tapahtumalokin lataaminen epäonnistui.",
    POS_LOG_MEMORY_NO_PERMISSION: "Sinulla ei ole oikeutta lukea tapahtumalokia.",
    POS_LOG_MEMORY_TYPE_CUSTOMER_TAB: "Lasku",
    POS_LOG_MEMORY_TYPE_TRANSACTION_FAILED: "Maksu epäonnistui",
    POS_LOG_MEMORY_TYPE_CREATE_RECEIPT: "Kuitti luotu",
    POS_LOG_MEMORY_TYPE_CORRECT_RECEIPT: "Kuitti korjattu",
    POS_LOG_MEMORY_TYPE_REFUND_RECEIPT: "Hyvitys",
    POS_LOG_MEMORY_TYPE_MOVE_BOOKING: "Varaus siirretty",
    POS_LOG_MEMORY_TYPE_COPY_BOOKING: "Varaus kopioitu",
    POS_LOG_MEMORY_TYPE_UPDATE_BOOKING: "Varausta muutettu",
    POS_LOG_MEMORY_TYPE_UPDATE_TAB: "Laskua muutettu",
    POS_LOG_MEMORY_TYPE_ADD_ITEM: "Tuote lisätty",
    POS_LOG_MEMORY_TYPE_REMOVE_ITEM: "Tuote poistettu",
    POS_LOG_MEMORY_TYPE_UPDATE_ITEM: "Tuotetta muutettu",
    POS_LOG_MEMORY_TYPE_TO_KITCHEN: "Lähetys keittiöön",
    POS_DEVICES_SUBTITLE: "Kassat, jotka ovat määrittäneet itsensä tälle yksikölle. Tallennetut muutokset tulevat kassalla voimaan heti.",
    POS_DEVICES_TABLE_TITLE: "Laitteet",
    POS_DEVICES_EMPTY: "Tälle yksikölle ei ole rekisteröity POS-laitteita",
    POS_DEVICES_EMPTY_HINT: "Avaa POSv2 kassalla. Se kysyy laitteen nimeä ensimmäisellä käynnistyskerralla.",
    POS_DEVICES_NAME: "Laitteen nimi",
    POS_DEVICES_ID: "Laitetunnus",
    POS_DEVICES_LAST_SEEN: "Viimeksi nähty",
    POS_DEVICES_NEVER_SEEN: "Ei koskaan",
    POS_DEVICES_EDIT: "Muokkaa laitetta",
    POS_DEVICES_FORM_HINT: "Tallennetut asetukset lähetetään kassalle välittömästi.",
    POS_DEVICES_SECTION_IDENTITY: "Tunnistetiedot",
    POS_DEVICES_SECTION_HARDWARE: "Laitteisto",
    POS_DEVICES_UNIT_HINT: "Reitin vaihtaminen siirtää tämän kassan toiseen yksikköön.",
    POS_DEVICES_NAME_REQUIRED: "Anna laitteen nimi",
    POS_DEVICES_ROUTE_REQUIRED: "Anna reitti",
    POS_DEVICES_SAVED: "Laiteasetukset tallennettu",
    POS_DEVICES_NEW_STAFF_CODE: "Uusi henkilökunnan kirjautumiskoodi",
    POS_DEVICES_REMOVE: "Poista kassa",
    POS_DEVICES_REMOVE_CONFIRM: "Kassa poistetaan yksiköstä ja henkilökunnan kirjautuminen siihen perutaan. Kassaa käyttävää POSia pyydetään valitsemaan toinen kassa.",
    POS_DEVICES_REMOVED: "Kassa poistettu.",
    POS_DEVICES_REMOVE_FAILED: "Kassan poistaminen epäonnistui.",
    POS_DEVICES_ADD_TILL: "Lisää kassa",
    POS_DEVICES_ADD_WITHOUT_STAFF: "Uusi kassa: avaa POS uudella laitteella ja anna sille nimi, niin se näkyy täällä. Jos henkilöstömoduuli on käytössä, lisää kassa sen sijaan täällä kertakäyttöisellä koodilla, jotta henkilökunta voi kirjautua PIN-koodillaan.",
    POS_DEVICES_STAFF_SIGNIN: "Henkilökunnan kirjautuminen",
    POS_DEVICES_STAFF_CONNECTED: "Yhdistetty",
    POS_DEVICES_STAFF_REVOKED_TAG: "Peruttu",
    POS_DEVICES_STAFF_REVOKE: "Peru henkilökunnan kirjautuminen",
    POS_DEVICES_STAFF_REVOKE_HINT: "Henkilökunta ei voi enää kirjautua tälle kassalle ennen kuin se rekisteröidään uudelleen uudella koodilla. Kassa säilyttää asetuksensa (tulostin, maksupääte, kieli).",
    POS_DEVICES_STAFF_REVOKE_REASON: "Syy",
    POS_DEVICES_STAFF_REVOKED: "Henkilökunnan kirjautuminen tälle kassalle peruttu.",
    POS_DEVICES_STAFF_REVOKE_FAILED: "Henkilökunnan kirjautumisen peruminen epäonnistui.",
    POS_DEVICES_SAVE_ERROR: "Laiteasetusten tallentaminen epäonnistui",
    POS_DEVICES_LOAD_ERROR: "POS-laitteiden lataaminen epäonnistui",
    POS_DEVICES_SURFBOARD: "Surfboard",
    POS_DEVICES_SECTION_SURFBOARD: "Surfboard",
    POS_DEVICES_SURFBOARD_MODE: "Maksutila",
    POS_DEVICES_SURFBOARD_APPSWITCH: "Sovellusvaihto (CheckoutX)",
    POS_DEVICES_SURFBOARD_TERMINAL_MODE: "Ulkoinen maksupääte",
    POS_DEVICES_SURFBOARD_MODE_HINT: "Ei asetettu: kassahenkilön valitsema Surfboard-maksutapa ratkaisee.",
    POS_DEVICES_SURFBOARD_TERMINAL: "Surfboard-maksupääte",
    POS_DEVICES_SURFBOARD_TERMINAL_HINT: "Käytetään ulkoisen maksupäätteen tilassa. Sovellusvaihdossa maksetaan itse kassalle rekisteröidyllä CheckoutX:llä.",
    POS_DEVICES_SURFBOARD_NOT_CONFIGURED: "Surfboardia ei ole määritetty tälle yksikölle",
    POS_DEVICES_SURFBOARD_TERMINAL_NONE: "Ei mitään (valitse maksupääte jokaisen maksun yhteydessä)",
    USERS_SUBTITLE: "Hallitse POS V2 -käyttäjiä, käyttöoikeuksia ja kassalle kirjautumista",
    USERS_ADD: "Luo käyttäjä",
    USERS_EDIT: "Muokkaa käyttäjää",
    USERS_USE_LOGIN: "Käytä kirjautumista POSissa",
    USERS_USE_LOGIN_HINT: "Vaatii PIN-koodin kirjauduttaessa",
    USERS_TIMEOUT_MINUTES: "Aikakatkaisu (minuuttia)",
    USERS_LOGOUT_TYPE: "Uloskirjautumisen tapa",
    USERS_AUTO_LOGOUT: "Automaattinen uloskirjautuminen käyttämättömyyden jälkeen",
    USERS_MANUAL_LOGOUT: "Kirjaudu ulos manuaalisesti",
    USERS_SETTINGS_SAVED: "Kirjautumisasetukset tallennettu",
    USERS_SETTINGS_SAVE_ERROR: "Kirjautumisasetusten tallentaminen epäonnistui",
    USERS_FIRST_NAME: "Etunimi",
    USERS_LAST_NAME: "Sukunimi",
    USERS_EMPLOYEE_ID: "Työntekijätunnus",
    USERS_PIN: "PIN-koodi",
    USERS_REFUND: "Voi tehdä hyvityksiä",
    USERS_REMOVE_FROM_TAB: "Voi poistaa tuotteita laskulta",
    USERS_MAX_DISCOUNT: "Enimmäisalennus %",
    USERS_EMPTY: "Ei vielä käyttäjiä",
    USERS_EMPTY_HINT: "Luo ensimmäinen POS V2 -käyttäjäsi",
    USERS_FORM_HINT: "Anna käyttäjän tiedot ja käyttöoikeudet",
    USERS_FIRST_NAME_REQUIRED: "Etunimi on pakollinen",
    USERS_LAST_NAME_REQUIRED: "Sukunimi on pakollinen",
    USERS_EMPLOYEE_ID_REQUIRED: "Työntekijätunnus on pakollinen",
    USERS_EMAIL_REQUIRED: "Sähköposti on pakollinen",
    USERS_PIN_REQUIRED: "PIN-koodi on pakollinen",
    USERS_PIN_INVALID: "PIN-koodin on oltava 4–8 numeroa",
    USERS_EMAIL_INVALID: "Virheellinen sähköpostiosoite",
    USERS_CREATED: "Käyttäjä luotu",
    USERS_UPDATED: "Käyttäjä päivitetty",
    USERS_DELETED: "Käyttäjä poistettu",
    USERS_LOAD_ERROR: "Käyttäjien lataaminen epäonnistui",
    USERS_SAVE_ERROR: "Käyttäjän tallentaminen epäonnistui",
    USERS_DELETE_ERROR: "Käyttäjän poistaminen epäonnistui",
    USERS_DELETE_HEADER: "Poista käyttäjä",
    USERS_DELETE_CONFIRM: "Haluatko varmasti poistaa tämän käyttäjän?",
    USERS_TABLE_TITLE: "Käyttäjät",
    USERS_SECTION_PERSONAL: "Henkilötiedot",
    USERS_SECTION_ACCESS: "Pääsy",
    USERS_SECTION_PERMISSIONS: "Käyttöoikeudet",
    USERS_TOGGLE_PIN: "Näytä tai piilota PIN-koodi",
    USERS_ACTIVE_HINT: "Passiiviset käyttäjät eivät voi kirjautua POSiin",
    // Sidebar labels for the POS section (the screens keep their own titles)
    NAV_POS_BUTTON_LAYER: 'POS-painiketaso',
    NAV_POS_DEVICES: 'Laitteet',
    NAV_POS_ACTIVITY_LOG: 'Toimintaloki',
    POS_SETTINGS: "Asetukset",
    POS_SETTINGS_SUBTITLE: "Määritä tämän yksikön POS-asetukset.",
    POS_QUICK_RAIL: "Pikapalkki",
    POS_QUICK_RAIL_SUBTITLE: "Määritä Avoin tuote -painike, joka näkyy ostoskorin vieressä POS V2:ssa.",
    POS_QUICK_RAIL_OPEN_PRODUCTS_ENABLED: "Ota Avoin tuote -painike käyttöön",
    POS_QUICK_RAIL_OPEN_PRODUCTS_ENABLED_HINT: "Näytä Avoin tuote -painike POSin pikapalkissa.",
    POS_QUICK_RAIL_OPEN_PRODUCTS: "Avoimet tuotteet",
    POS_QUICK_RAIL_OPEN_PRODUCTS_HINT: "Valitse tuoterekisteristä tuotteet, joiden hinnan henkilökunta voi syöttää käsin.",
    POS_QUICK_RAIL_OPEN_PRODUCTS_EMPTY: "Avoimia tuotteita ei ole vielä valittu. Lisää tuotteita yllä.",
    POS_QUICK_RAIL_ADD_PRODUCTS: "Lisää tuotteita",
    POS_QUICK_RAIL_DELETE_CONFIRM: "Haluatko varmasti poistaa kohteen \"{name}\"?",
    POS_QUICK_RAIL_SAVED: "Pikapalkin asetukset tallennettu.",
    POS_QUICK_RAIL_SAVE_ERROR: "Pikapalkin asetusten tallentaminen epäonnistui. Yritä uudelleen.",
    POS_QUICK_RAIL_LOAD_ERROR: "Pikapalkin asetusten lataaminen epäonnistui. Yritä uudelleen.",
    POS_QUICK_MESSAGES: "Pikaviestit",
    POS_QUICK_MESSAGES_SUBTITLE: "Hallitse POS-kassalla näytettäviä pikaviestejä.",
    POS_QUICK_MESSAGES_PLACEHOLDER: "Kirjoita pikaviesti",
    POS_QUICK_MESSAGES_EMPTY: "Ei vielä pikaviestejä. Lisää viesti yllä.",
    POS_QUICK_MESSAGES_SAVED: "Pikaviestit tallennettu.",
    POS_QUICK_MESSAGES_SAVE_ERROR: "Pikaviestien tallentaminen epäonnistui. Yritä uudelleen.",
    POS_QUICK_MESSAGES_LOAD_ERROR: "Pikaviestien lataaminen epäonnistui. Yritä uudelleen.",
    POS_QUICK_MESSAGES_DELETE_CONFIRM: "Haluatko varmasti poistaa viestin \"{message}\"?",
    POS_ORDER_MESSAGES: "Tilauskommenttiviestit",
    POS_ORDER_MESSAGES_SUBTITLE: "Valmiit viestit, jotka henkilökunta voi valita POSin tilauskommenttiin koko tilaukselle.",
    POS_ORDER_MESSAGES_PLACEHOLDER: "Kirjoita tilauskommenttiviesti",
    POS_ORDER_MESSAGES_EMPTY: "Ei vielä tilauskommenttiviestejä. Lisää viesti yllä.",
    POS_ORDER_MESSAGES_SAVED: "Tilauskommenttiviestit tallennettu.",
    POS_ORDER_MESSAGES_SAVE_ERROR: "Tilauskommenttiviestien tallentaminen epäonnistui. Yritä uudelleen.",
    POS_ORDER_MESSAGES_LOAD_ERROR: "Tilauskommenttiviestien lataaminen epäonnistui. Yritä uudelleen.",
    POS_SIGN_IN: "Kirjautuminen",
    POS_DAY_CLOSE: "Päivän sulkeminen",
    POS_Z_CLOSE_TIME: "Z-raportin sulkemisaika",
    POS_Z_CLOSE_TIME_HINT: "Aika (Ruotsin aikaa), jolloin liiketoimintapäivä päättyy ja kukin kassa saa Z-raporttinsa.",
    POS_Z_CLOSE_TIME_DEFAULT: "Ei asetettu - päivä päättyy klo 00:00.",
    POS_Z_CLOSE_TIME_INVALID: "Anna aika muodossa HH:MM, esim. 05:00.",
    POS_Z_CLOSE_TIME_SAVED: "Z-raportin sulkemisaika tallennettu",
    POS_Z_CLOSE_TIME_SAVE_ERROR: "Z-raportin sulkemisajan tallentaminen epäonnistui",
    POS_TIPPING: "Juomarahat",
    POS_TIPPING_SUBTITLE: "Määritä juomarahat asiakkaan itsepalvelumaksua varten.",
    POS_TIPPING_ENABLED: "Ota juomarahat käyttöön",
    POS_TIPPING_ENABLED_HINT: "Näytä juomarahavaihtoehdot itsepalvelumaksusovelluksessa.",
    POS_TIPPING_THRESHOLD: "Vähimmäissumma",
    POS_TIPPING_THRESHOLD_HINT: "Juomaraha näytetään, kun maksettava summa on vähintään tämä arvo.",
    POS_TIPPING_SAVED: "Juomaraha-asetukset tallennettu.",
    POS_TIPPING_SAVE_ERROR: "Juomaraha-asetusten tallentaminen epäonnistui. Yritä uudelleen.",
    POS_TIPPING_LOAD_ERROR: "Juomaraha-asetusten lataaminen epäonnistui. Yritä uudelleen.",
    ORG_SALES: "Myynti",
    TOTALS: "Yhteensä",
    POS_REPORTS: "Tilitysraportti",
    PAYMENTS: "Maksut",
    FINANCE: "Talous",
    APP_BUTTONS: "Sovelluksen painikkeet",
    MFA: "MFA",
    RECEIPTS: "Kuitit",
    ACCOUNTING_ACCOUNTS: "Kirjanpitotilit",
    TODAY: "Tänään",
    YESTERDAY: "Eilen",
    LAST_WEEK: "Viime viikko",
    APP_OPEN: "Sovellus auki",
    APP_CLOSED: "Sovellus suljettu",
    THIS_MONTH: "Tämä kuukausi",
    LAST_MONTH: "Viime kuukausi",
    USER: "Käyttäjä",
    ORDERS: "Tilaukset",
    OPEN: "Avoinna",
    END_OF_DAY: "Päivän päätös",
    ADD_DOMAINS: "Lisää verkkotunnuksia",
    DELETE_USER_GROUP: "Poista käyttäjäryhmä",
    USER_GROUP_DELETED: "Käyttäjäryhmä poistettu",
    USER_GROUP_UPDATED: "Käyttäjäryhmä päivitetty",
    HISTORY: "Historia",
    DELETED: "Poistettu",
    EDIT_CATEGORY_ON_PRODUCTS: "Muokkaa tuotteiden kategoriaa",
    DELETE_GROUP: "Poista ryhmä",
    ERROR: "Virhe",
    CATEGORY_DELETED: "Kategoria poistettu",
    TIP_REPORT: "Juomaraharaportti",
    DESC_GENERATE_REPORT: "Raportti luodaan PDF-tiedostoksi, joka ladataan automaattisesti.",
    GENERATING_REPORT: "Luodaan raporttia",
    ERROR_TIP_REPORT: "Juomaraharaportin luomisessa tapahtui virhe! Yritä uudelleen.",
    COMPANY_NAME: "Yrityksen nimi",
    EMAIL_NOT_VALID: "Sähköpostiosoite ei ole kelvollinen",
    BANKINFO_HEADER: "Henkilö- ja pankkitiedot",
    BANKINFO_SUB_HEADER: "Täytä lomake",
    BANKINFO_FIRST_NAME: "Etunimi",
    BANKINFO_LAST_NAME: "Sukunimi",
    BANKINFO_BUSINESS_NAME: "Yrityksen nimi",
    BANKINFO_PHONE_NUMBER: "Toimitusjohtajan puhelinnumero",
    BANKINFO_EMAIL: "Toimitusjohtajan sähköposti",
    BANKINFO_TAX_ID: "Y-tunnus",
    BANKINFO_LIST_OF_OWNERS: "Omistajaluettelo",
    BANKINFO_UPLOAD_IDENTIFCATION: "Lataa henkilöllisyystodistus",
    BANKINFO_ADD_OWNER: "Lisää omistajia",
    BANKINFO_BANK_NAME: "Pankin nimi",
    BANKINFO_BANK_ACCOUNT_NUMBER: "Pankkitilin numero",
    BANKINFO_BANK_PROOF: "Lataa kuvakaappaus pankista",
    BANKINFO_SEND_VERIFICTION: "Lähetä vahvistettavaksi",
    MIN_LENGTH: "vähimmäispituus",
    ZERO_NOTIFICATION: "Ei uusia ilmoituksia",
    PDF_HEADER: "PDF-näkymä",
    PDF_DOWNLOAD: "Lataa PDF",
    PDF_FORMAT: "Valitse sivukoko",
    PDF_TEXT: "Kirjoita teksti",
    PDF_TEXT_COLOR: "Tekstin väri",
    PDF_BACKGROUND_COLOR: "Taustaväri",
    GRIN_HEADER: "Uudelleenkäytettävät pakkaukset",
    TAG: "Tunniste",
    GRIN_PACKAGES: "Pakkaukset",
    GRIN_NONE: "Ei mitään",
    CAN_ORDER: "Voi tilata",
    SHOW_IN_APP: "Näytä sovelluksessa",
    SHOW_IN_KIOSK: "Näytä pikakioskissa",
    SHOW_IN_WEB: "Näytä verkkotilauksessa",
    SHOW_IN_TAKEAWAY: "Näytä noutoruoalle",
    SHOW_IN_EATHERE: "Näytä tiskiltä noudolle",
    SHOW_IN_TABLEORDER: "Näytä pöytätilaukselle",
    SHOW_IN_DRIVEDELIVERY: "Näytä kotiinkuljetukselle",
    SHOW_IN_FIXEDLOCATION: "Näytä kiinteään toimituspaikkaan",
    DELIVERY_PRICE: "Toimitushinta",
    DELIVERY_TO_LOCATION_PRICE: "Hinta toimitukselle paikkaan",
    STANDARD: "Vakio",
    ADVANCED: "Lisäasetukset",
    ADVANCED_SETTINGS: "Lisäasetukset",
    ADD_DESCRIPTION_SHORT: "Lisää lyhyt kuvaus...",
    ADD_DESCRIPTION_LONG: "Lisää pitkä kuvaus...",
    FILTER_NAME_ID: "Suodata nimen tai tunnuksen mukaan",
    VAT_ID: "ALV-tunniste",
    LAST_30_DAYS: "Viimeiset 30 päivää",
    DAYS: "Päivät",
    WEEKS: "Viikot",
    MONTHS: "Kuukaudet",
    THIS_WEEK: "Tämä viikko",
    TOTAL_SALES: "Kokonaismyynti",
    EDIT_GROUP: "Muokkaa ryhmää",
    ADDON_GROUPS: "Lisäkeryhmät",
    TOTAL_SALES_DAY_BY_DAY: "Myynti päivittäin",
    BAR_CHART_SHORT: "Pylväs",
    LINE_CHART_SHORT: "Viiva",
    SALES_BY_HOUR: "Myynti tunneittain",
    Z_REPORTS: "Z-raportit",
    X_REPORT: "X-raportti",
    CREATE_CATEGORY: "Luo kategoria",
    SETTLEMENTNO: "Tilitysnro",
    TIMESTAMP: "Aikaleima",
    RECEIPTNOSTART: "Ensimmäinen kuittinro",
    RECEIPTNOSTOP: "Viimeinen kuittinro",
    TOTALAMOUNT: "Kokonaissumma",
    SALES_INFO: "Myynti",
    NO_DATA_PERIOD: "Tietoja ei löytynyt",
    FETCH_DATA_ERROR: "Virhe tietojen haussa.",
    LOADING_DATA: "Ladataan tietoja. Odota hetki",
    DATA: "Tiedot",
    OCLOCK: "Tunti",
    TOTAL_SALES_HOURLY: "Kokonaismyynti tunneittain",
    TOTAL_SALES_BY: "Kokonaismyynti jaoteltuna",
    PAYMENT_METHODS: "Maksutavat",
    DATE_LOWER: "Päivämäärä",
    DAY_LOWER: "päivä",
    WEEK_LOWER: "viikko",
    MONTH_LOWER: "kuukausi",
    NET: "Netto",
    MEDIAN_RECEIPT: "Mediaanikuitti",
    HIGHEST_PURCHASE_RECEIPT: "Suurin ostokuitti",
    HIGHEST_DISCOUNT_RECEIPT: "Suurimman alennuksen kuitti",
    PRODUCTS_SOLD: "Myydyt tuotteet",
    PRICE_OPTIONS: "Hintavaihtoehdot",
    LARGEST_ORDER: "Suurin tilaus",
    SOURCES: "Kanavat",
    EAT_IN_PRICE: "Hinta paikan päällä",
    TAKEAWAY_PRICE: "Noutoruoan hinta",
    QR_FOR_SCANNING: "Skannattava QR-koodi",
    BONUS_BUY: "Ostettavissa bonuksella",
    BONUS: "Bonus %",
    LOAD_ALL_USERS: "Näytä kaikki käyttäjät",
    SHOW_USERS: "Näytä käyttäjät",
    INVITED_USERS: "Kutsutut käyttäjät",
    USER_NOT_FOUND: "Käyttäjää ei löytynyt",
    CONFIRM_USERGROUP: "Vahvista",
    LINK_EXISTING_OFFER: "Linkitä olemassa oleva tarjous",
    CREATE_OFFER: "Luo tarjous",
    EDIT_OFFER: "Muokkaa tarjousta",
    EDIT: "Muokkaa",
    LINK: "Linkitä",
    GUESTS: "Vieraat",
    ORDER_PRINTING: "Tilaussäännöt",
    EDIT_USER_GROUP: "Muokkaa käyttäjäryhmää",
    EDIT_USER: "Muokkaa käyttäjää",
    EDIT_INVOICE: "Muokkaa laskua",
    ADD_TO_ALL_USERS: "Lisää kaikille käyttäjille",
    INVOICE_DETAILS: "Laskun tiedot",
    UNIT_SETTINGS: "Yksikön asetukset",
    INVALID_EMAIL_OR_PASSWORD: "Virheellinen sähköposti tai salasana",
    INVALID_EMAIL: "Virheellinen sähköposti",
    ENTER_VALID_EMAIL: "Anna kelvollinen sähköpostiosoite.",
    TEAM_MEMBERS: "Tiimin jäsenet",
    PRODUCT_DETAILS: "Tuotteen tiedot",
    ADDONS: "Lisäkkeet",
    ADD_UNIQUE_ADDONS: "Lisää yksilöllinen lisäke",
    ADDONS_HEADER: "Lisäkkeet",
    NO_ADDONS: "Tällä tuotteella ei ole vielä lisäkkeitä",
    APP_INFORMATION: "Sovelluksen tiedot",
    NAME_IN_APP: "Nimi sovelluksessa",
    DESCRIPTION_IN_APP: "Kuvaus sovelluksessa",
    LOGO_IN_APP: "Logo sovelluksessa",
    NAME_OF_APP: "Julkaistu sovelluksessa",
    OPEN_AND_CLOSE_APP: "Avaa / sulje sovellus tilauksille",
    RESTRICT_ITEM: "Rajoita tämä tuote yhteen ostoon päivässä",
    DELETE_PRODUCTS: "Poista tuotteet",
    DISCARD: "Hylkää",
    WEB_ORDER_HEADER: "Verkkotilaus",
    COLOR_HEADER: "Värit",
    PRIMARY_COLOR_HEADER: "Päävärit",
    SECONDARY_COLOR_HEADER: "Toissijaiset värit",
    SUCCESS_COLOR_HEADER: "Onnistumisvärit",
    DANGER_COLOR_HEADER: "Varoitusvärit",
    RESTAURANT_INFO: "Ravintolan tiedot",
    OPEN_HEADER: "Avoinna",
    CLOSED_HEADER: "Suljettu",
    CANCEL_HEADER: "Peruuta muutokset",
    PUBLISH_HEADER: "Julkaise",
    WEBORDER_SETTINGS: "Verkkotilaus",
    FAVICON: "Favicon (selainvälilehden ja hakutuloksen kuvake)",
    FAVICON_CHANGE: "Vaihda favicon",
    FAVICON_REMOVE: "Poista favicon",
    FAVICON_NOTE: "Neliön muotoinen PNG, vähintään 48x48 px (suositus 192x192 tai suurempi). Käytä yksinkertaista merkkiä, kuten ravintolan symbolia, älä leveää logoa. Näytetään selaimen välilehdillä ja ravintolan vieressä Googlen hakutuloksissa.",
    FAVICON_TOO_SMALL: "Kuva on {width}x{height} px. Faviconin on oltava vähintään {min}x{min} px.",
    FAVICON_NOT_SQUARE: "Tämä kuva on {width}x{height} px eikä neliön muotoinen, joten se näyttää faviconina litistyneeltä. Logomerkin neliönmuotoinen versio toimii parhaiten. Käytetäänkö silti?",
    FAVICON_LOAD_FAILED: "Valitun kuvan lataaminen epäonnistui.",
    CUSTOM_ORDER_TICKET_MESSAGE: "Mukautettu tilauslipun viesti",
    CUSTOM_ORDER_SHOW_TICKET_MESSAGE: "Tämä teksti korvaa tilauslipun tavalliset tiedot kaikissa toimitusvaihtoehdoissa",
    QR_VALIDATION_MESSAGE: "QR-koodi tilauslipussa",
    CLOSE_ORDER_TICKET_CONFIRMATION_MESSAGE: "Tilauslipun sulkemisen vahvistus",
    SHOW_COMMENT_ON_ORDER_MESSAGE: "Näytä kommenttikenttä tilauksessa",
    SHOW_COMMENT_ON_PRODUCT_MESSAGE: "Näytä kommenttikenttä tuotteessa",
    ADVANCE_SETTINGS_SAVED: "Lisäasetukset tallennettu",
    MENU_STYLE_TEXT: "Menun tyyli",
    SEND_AGAIN: "Lähetä uudelleen",
    MENU_NAV_HOME: "Etusivu",
    MENU_NAV_APP: "Sovellus",
    MENU_NAV_COMMUNICATION: "Viestintä",
    MENU_NAV_OPENCLOSE: "Avaa & sulje",
    FINANCE_EXPORTS_API: "Talousviennin asetukset",
    TCPOS_CREDENTIALS: "Tcpos-tunnukset",
    TOKEN: "Tunnus",
    UNIT_ID: "Yksikön tunnus",
    CATEGORY_TEXT_DESCRIPTION: "Nämä alakategoriat ja tuotteet näkyvät tässä sovelluksessa, kun menu on aktiivinen.",
    SUBCATEGORYGROUPS_HEADER: "Alakategoriat",
    SUBCATEGORYGROUPS_TEXT_DESCRIPTION: "Liitä olemassa olevia alakategoriaryhmiä menuun tai luo uusi.",
    ADD_SUBCATEGORYGROUP: "Luo",
    ADD_TO_MENUS: "Lisää menuihin",
    MINIMUM_VALUE_REQUIRED: "Vähimmäisarvo vaaditaan",
    MAXIMUM_VALUE_REQUIRED: "Enimmäisarvo vaaditaan",
    MINIMUM_CANNOT_BE_GREATER_THAN_MAXIMUM: "Vähimmäisarvo ei voi olla suurempi kuin enimmäisarvo",
    MAXIMUM_CANNOT_BE_LESS_THAN_MINIMUM: "Enimmäisarvo ei voi olla pienempi kuin vähimmäisarvo",
    BONUS_POINTS_UPDATED: "Bonuspisteet päivitetty",
    EDIT_PRODUCT: "Muokkaa tuotetta",
    EDIT_SELECTED_PRODUCTS: "Muokkaa valittuja tuotteita",
    RENAME: "Nimeä uudelleen",
    MINIMUM_BONUS_REQUIRED: "Vähimmäisbonus vaaditaan",
    SHOW_MORE: "Näytä lisää",
    ADJUST_AMOUNT: "Säädä summaa",
    CARD_DETAILS: "Kortin tiedot",
    APPLY_FILTER: "Käytä suodatinta",
    TOTAL_SAVED_CARDS: "Tallennettuja kortteja yhteensä",
    FILTER_RESULT: "Suodata tuloksia",
    START_DATE: "Alkupäivä",
    END_DATE: "Loppupäivä",
    ADJUST: "Säädä",
    RECEIPT_DETAILS: "Kuitin tiedot",
    ORDER_TEXT: "Tilaus",
    INVOICE_TEXT: "Lasku",
    INVOICE_DATE: "Laskun päivämäärä",
    RECEIPT_NO: "Kuittinro",
    PHONE_NO: "Puhelinnro",
    QTY: "Kpl",
    RATE: "Hinta",
    LINE_TOTAL: "Rivin summa",
    CODE_TEXT: "Koodi",
    CONNECT_SOCIAL_MEDIA: "Linkitä sovellukseen sosiaalisen median profiilisi",
    ALLERGEN_INFORMATION_DESCRIPTION: "Syötä yksikkösi yhteystiedot, jotka näytetään sovelluksessa asiakkaille allergiakysymyksiä varten",
    MANAGE_ADVANCED_SETTINGS: "Hallitse yksikön lisäasetuksia",
    KUNIT_TEXT: "Ohj.yks.",
    SUBTOTAL: "Välisumma",
    DELIVERY_FEE: "Toimitusmaksu",
    COUPON_CODE_INPUT_FIELD: "Ota kuponkikoodikenttä käyttöön",
    CLOSE_ORDER_TICKET_CONFIRMATION_DESCRIPTION: "Pyydä asiakkaalta lisävahvistus ennen tilauslipukkeen lunastamista",
    MENU_STYLE_DESCRIPTION: "Valitse yksikön sovelluksen menun asettelu",
    SHOW_COMMENT_ON_ORDER_DESCRIPTION: "Salli kommentti koko tilaukselle",
    SHOW_COMMENT_ON_PRODUCT_DESCRIPTION: "Salli kommentti tuotekohtaisesti",
    COUPON_CODE_DESCRIPTION: "Näytä kuponkikoodikenttä sovelluksessa, jotta asiakkaat voivat käyttää kuponkikoodeja",
    DISCOUNT: "Alennus",
    SEARCH_NAME_OR_TAG: "Hae nimellä tai tagilla",
    GROSS: "Brutto",
    CARD_IN_APP: "Kortti sovelluksessa",
    TOTAL_SAVED_RECEIPTS: "Tallennettuja kuitteja yhteensä",
    TOTAL_SAVED_BONUS_POINTS: "Tallennettuja pisteitä yhteensä",
    TOTAL_SAVED_WALLETS: "Lompakkotapahtumia yhteensä",
    TRANSACTIONS_NOT_FOUND: "Tapahtumia ei löytynyt",
    AMOUNT_TO_ADJUST: "Säädettävä summa",
    POINTS: "Pisteet",
    ADJUST_WALLET: "Säädä saldoa",
    ADJUST_BONUS: "Säädä bonusta",
    ADJUST_BONUS_ERROR: "Bonuksen säätäminen epäonnistui. Yritä myöhemmin uudelleen.",
    ADJUST_WALLET_ERROR: "Saldon säätäminen epäonnistui. Yritä myöhemmin uudelleen.",
    FEATURED_PRODUCT: "Nostotuote",
    FEATURED_PRODUCT_DESC: "Tämä tuote nostetaan esiin yksikön aloitussivulla sovelluksessa, ja sen voi ostaa vain tarjoilutavalla \"Syödään paikan päällä\". Haluatko jatkaa?",
    FIELDS_MISSING_ERROR: "Täytä kaikki pakolliset kentät.",
    SHOW_ALL: "Näytä kaikki",
    UNIT_SWITCHER_SEARCH_UNITS: "Hae yksiköitä nimellä tai tunnuksella",
    UNIT_SWITCHER_SELECT: "valitse",
    UNIT_SWITCHER_OPEN: "avaa",
    UNIT_SWITCHER_CLOSE: "sulje",
    UNIT_SWITCHER_NO_RESULTS: "Yksiköitä ei löytynyt",
    CHOOSE_UNIT: "Valitse yksikkö",
    UNIT_NAME: "Yksikön nimi",
    COMPANY: "Yritys",
    TOTAL_DISCOUNT: "Alennus yhteensä",
    MISSING_TEXT: "Joiltakin tuoterekisterin tuotteilta puuttuu keittiötulostus- tai tuotekategoria. Tämän vuoksi ne eivät välttämättä toimi sovelluksessa odotetulla tavalla. Tarkista ja päivitä tiedot sujuvan toiminnan varmistamiseksi.",
    NOT_SELECTED: "Ei valittu",
    EDIT_ALL: "Massamuokkaus",
    PERCENT: "Korota tai laske hintaa prosentuaalisesti",
    SEARCH_BY_EMAIL: "Hae sähköpostilla",
    ADD_USER_TO_USERGROUP: "Lisää uusi jäsen",
    SEARCH_MEMBER: "Hae jäsentä",
    ADD_MEMBER: "Lisää jäsen",
    NO_USER_WITH_EMAIL: "Tällä sähköpostiosoitteella ei löytynyt käyttäjää",
    SELF_SERVICE_KIOSK: "Itsepalvelukioski",
    DEFAULT_LANGUAGE: "Oletuskieli",
    START_SCREEN_IMAGE: "Aloitusnäytön kuva",
    ADDED_TO_MENU: "Lisätty menuun",
    NOT_ADDED_TO_ANY_MENU: "Ei lisätty mihinkään menuun",
    APP_MENUS: "Sovelluksen menut",
    NOT_IN_ANY_APP_MENU: "Ei missään sovelluksen menussa",
    NOT_IN_ANY_POS_MENU: "Ei missään POS-menussa",
    BANNER_IN_KIOSK: "Banneri kioskissa",
    SHOW_MEMBERSHIP_REGISTRATION_KIOSK: "Jäseneksi rekisteröityminen",
    SHOW_MEMBERSHIP_REGISTRATION_KIOSK_DESCRIPTION: "Näytä jäsenrekisteröitymisen painike kioskissa",
    SHOW_MEMBERSHIP_REGISTRATION_KIOSK_HELP: "Kun tämä on käytössä, asiakkaat voivat rekisteröidä jäsenyytensä (leimakortti) kioskissa QR-koodia skannaamalla. Poista käytöstä piilottaaksesi tämän vaihtoehdon.",
    KIOSK_FONTS: "Fontit",
    KIOSK_FONTS_DESCRIPTION: "Valitse yksi fontti otsikoille ja yksi leipätekstille. Molemmat ladataan Google Fontsista.",
    FONT_HEADING: "Otsikoiden fontti",
    FONT_BODY: "Leipätekstin fontti",
    FONT_PREVIEW: "Esikatselu",
    FONT_PREVIEW_HEADING: "Tervetuloa",
    FONT_PREVIEW_BODY: "Nopea ruskea kettu hyppää laiskan koiran yli.",
    FONT_PREVIEW_HEADING_LABEL: "Otsikko",
    FONT_PREVIEW_BODY_LABEL: "Leipäteksti",
    FONT_USE_SAME_AS_HEADING: "Käytä samaa kuin otsikossa",
    FONT_FILTER_PLACEHOLDER: "Hae fontteja...",
    SELECT_FONT: "Valitse fontti",
    SLIDER_INTERVAL: "Kuvien vaihtoväli (sekuntia)",
    SLIDER_INTERVAL_PLACEHOLDER: "Syötä väli sekunteina",
    SLIDER_INTERVAL_DESCRIPTION: "Aika ennen siirtymistä seuraavaan kuvaan (1–60 sekuntia)",
    IMAGE_NUMBER: "Kuva",
    MOVE_UP: "Siirrä ylös",
    MOVE_DOWN: "Siirrä alas",
    PREVIEW_IMAGE: "Esikatselukuva",
    SELECT_START_SCREEN_IMAGE: "Valitse aloitusnäytön kuva",
    SELECT_HEADER_IMAGE: "Valitse otsikkokuva",
    SELECT_LANGUAGE: "Valitse kieli",
    SELECT_TEXT_ALIGN: "Valitse tekstin tasaus",
    SELECT_COLOR: "Valitse väri",
    KIOSK_NOT_CONFIGURED: "Et voi vaihtaa itsepalvelukioskin aloitusnäytön kuvaa tässä yksikössä",
    KIOSK_DEVICE_CONFIG: "Kioskilaitteen määritys",
    USE_CUSTOM_START_SCREEN_IMAGES: "Käytä tälle laitteelle omia aloitusnäytön kuvia",
    KIOSK_NO_DEVICE_REGISTERED: "Tälle yksikölle ei ole rekisteröity kioskilaitetta. Rekisteröi laite ensin kioskisovelluksesta (syötä reitti ja yksikön nimi).",
    ROUTE: "Reitti",
    ROUTE_PLACEHOLDER: "Syötä reitin nimi",
    MULTIPLE_ROUTES: "Useita reittejä",
    MULTIPLE_ROUTES_PLACEHOLDER: "Pilkuilla erotetut reitit",
    NAME_PLACEHOLDER: "Nimi",
    MODEL: "Malli",
    MODEL_PLACEHOLDER: "Malli",
    MENU_CODE: "Menun koodi",
    CODE_PLACEHOLDER: "Koodi",
    SOFTPOS: "SoftPOS",
    SOFTPOS_CURRENCY: "SoftPOS-valuutta",
    SOFTPOS_INTEGRATION_ID: "SoftPOS-integraation tunnus",
    SOFTPOS_INTEGRATION_PASSWORD: "SoftPOS-integraation salasana",
    SAVE_DEVICE_CONFIG: "Tallenna laitteen määritys",
    SELECT_DEVICE: "Valitse laite",
    PRINTER: "Tulostin",
    CARD_TERMINAL: "Maksupääte",
    AVAILABLE_TERMINALS: "Käytettävissä olevat maksupäätteet",
    NO_TERMINALS_FOUND: "Maksupäätteitä ei löytynyt",
    LOADING: "ladataan",
    BANNER_TITLE: "Otsikko",
    BANNER_MESSAGE: "Viesti",
    TEXT_ALIGN_TEXT: "Tekstin tasaus",
    COLOR_THEME_TEXT: "Väriteema",
    ROLE: "Rooli",
    ADMINISTRATOR: "Ylläpitäjä",
    TCPOS_PORT: "TCPOS-portti",
    RESETPASSWORD: "Nollaa salasana",
    TITLE_TEXT_COLOR: "Otsikon ja tekstin väri",
    FEATURED_PRODUCTS: "Nostotuotteet",
    EMAIL_REPORT: "Lähetä raportti sähköpostilla",
    HAS_BACKGROUND_TEXT: "Taustallinen",
    SHOW_BADGE_TEXT: "Näytä merkki",
    ADD_COLOR: "Lisää väri...",
    EDIT_ACCOUNT: "Muokkaa kirjanpitoa",
    ADD_ADDONS: "Lisää lisäkkeitä",
    NO_ADDONS_GROUP: "Ei lisäkeryhmää",
    ADD_ADDONS_GROUP_TO_PRODUCT: "Lisää lisäkeryhmä tuotteeseen",
    NO_ADDONS_IN_GROUP: "Lisäkkeitä ei ole vielä luotu",
    SELECT_ONE: "Valitse yksi",
    SELECT_MULTIPLE: "Valitse useita",
    DELETE_ADDON: "Poista lisäke",
    EDIT_MENU_NAME: "Muokkaa menun nimeä",
    PASSWORD_UPDATED: "Salasana päivitetty",
    PENDING_REFUNDS: "Odottavat hyvitykset",
    DOWNLOAD_AS_PDF: "Lataa PDF-muodossa",
    ADD_TO_UNITS: "Lisää yksiköihin",
    APPLY_DEFAULT_ROLE: "Käytä oletusroolia",
    SELECT_MORE_UNITS: "Valitse lisää yksiköitä",
    SELECT_UNITS: "Valitse yksiköt",
    CHOOSE_ORGANIZATION_UNITS: "Valitse organisaation yksiköt",
    RECEIPT_NUMBER: "Kuitti",
    RECEIPT_TYPE: "Tyyppi",
    SALES_CHANNEL: "Myyntikanava",
    CUSTOMER_NAME: "Asiakas",
    ORDER_NUMBER: "Tilaus",
    TRANSACTIONS_MENU: "Tapahtumat",
    SEARCH_RECEIPT: "Hae kuittinumerolla",
    RECEIPT_PURCHASE: "Osto",
    RECEIPT_REFUND: "Hyvitys",
    EMAIL_RECEIPT: "Lähetä kuitti sähköpostilla",
    PURCHASE_AT: "Ostopaikka",
    SUMMARY: "Yhteenveto",
    EXTRA: "Lisä",
    REFUND: "Hyvitä",
    REFUND_SELECTED_ROW: "Hyvitä valittu rivi",
    REFUND_PAYMENT: "Hyvitä maksu",
    PRODUCTS_TO_REFUND: "Hyvitettävät tuotteet",
    SELECT_REASON: "Valitse syy",
    NOTE: "Huomautus",
    ADD_NOTE_DETAILS: "Lisää tarkempia tietoja tästä hyvityksestä.",
    REFUND_REASON_DUPLICATE: "Kaksoisveloitus",
    REFUND_REASON_FRAUDULENT: "Petollinen",
    REFUND_REASON_CUSTOMER_REQUEST: "Asiakkaan pyyntö",
    REFUND_REASON_OTHER: "Muu",
    REFUND_BONUS_POINTS: "Hyvitä bonuspisteet",
    BONUS_POINTS_REFUND: "Bonuspisteiden hyvitys",
    BONUS_SUMMARY: "Bonusten yhteenveto",
    AMOUNT_TO_REFUND: "Hyvitettävä summa",
    ENTER_BONUS_AMOUNT: "Syötä hyvitettävä bonusmäärä",
    BONUS_REFUND_AMOUNT: "Hyvitettävä bonusmäärä",
    NO_BONUS_REMAINING: "Hyvitettäviä bonuspisteitä ei ole jäljellä",
    ENTER_BONUS_POINTS_TO_REFUND: "Syötä hyvitettävien bonuspisteiden määrä (tarvittaessa).",
    REASON_MUST_BE_SELECTED: "Valitse hyvityksen syy",
    NOTE_REQUIRED_FOR_OTHER: "Huomautus on pakollinen, kun syyksi on valittu \"Muu\"",
    REFUND_AMOUNT_INVALID: "Hyvityssumman on oltava suurempi kuin 0",
    REFUND_AMOUNT_EXCEEDS_TOTAL: "Hyvityssumma ei voi ylittää alkuperäisen kuitin summaa",
    BONUS_REFUND_EXCEEDS_ORIGINAL: "Bonuspisteiden hyvitys ei voi ylittää alkuperäistä bonusmaksua",
    BONUS_REFUND_EXCEEDS_REMAINING: "Bonuspisteiden hyvitys ei voi ylittää jäljellä olevaa bonusmäärää",
    ORIGINAL_BONUS: "Alkuperäinen bonus",
    ALREADY_REFUNDED: "Jo hyvitetty",
    REMAINING: "Jäljellä",
    TWO_FACTOR_AUTHENTICATION: "Kaksivaiheinen tunnistautuminen",
    TWO_FACTOR_AUTHENTICATION_ACTIVE: "2FA käytössä",
    TWO_FACTOR_AUTHENTICATION_INACTIVE: "2FA ei käytössä",
    TWO_FACTOR_AUTHENTICATION_SETUP: "Määritä TOTP-2FA",
    TWO_FACTOR_AUTHENTICATION_REMOVE: "Poista 2FA",
    SECURE_YOUR_ACCOUNT: "Suojaa tilisi",
    ENABLE_TWO_FACTOR_AUTHENTICATION: "Ota kaksivaiheinen tunnistautuminen käyttöön lisätäksesi tilillesi ylimääräisen suojakerroksen",
    PROTECT_YOUR_ACCOUNT: "Suojaa tilisi, vaikka salasanasi vuotaisi",
    ENHANCED_SECURITY: "Parannettu tietoturva",
    MULTIPLE_OPTIONS: "Useita vaihtoehtoja",
    QUICK_SETUP: "Nopea käyttöönotto",
    GET_STARTED_IN_JUST_A_FEW_MINUTES_WITH_OUR_GUIDED_SETUP: "Pääset alkuun muutamassa minuutissa ohjatun käyttöönoton avulla",
    CHOOSE_YOUR_SETUP_METHOD: "Valitse käyttöönottotapa",
    RECOMMENDED: "Suositeltu",
    SMS_AUTHENTICATION: "Tekstiviestitunnistautuminen",
    AUTHENTICATOR_APP: "Todennussovellus",
    CURRENT_STATUS: "Nykyinen tila",
    ACTIVE_METHODS: "Käytössä olevat menetelmät",
    PRIMARY_METHOD: "Ensisijainen menetelmä",
    RECEIVE_VERIFICATION_CODES_VIA_TEXT_MESSAGE: "Vastaanota vahvistuskoodit tekstiviestillä. Nopea ja kätevä useimmille käyttäjille.",
    USE_APPS_LIKE_GOOGLE_AUTHENTICATOR_OR_AUTHY_FOR_ENHANCED_SECURITY: "Käytä parempaa tietoturvaa varten sovelluksia, kuten Google Authenticator tai Authy.",
    WORKS_OFFLINE: "Toimii ilman verkkoyhteyttä",
    INDUSTRY_STANDARD: "Alan standardi",
    SETUP_SMS_2FA: "Määritä tekstiviesti-2FA",
    SETUP_TOTP_2FA: "Määritä TOTP-2FA",
    SET_AS_PRIMARY: "Aseta ensisijaiseksi",
    NOTICE: "Huomio",
    SECURITY_NOTICE_DESCRIPTION: "Sinulla on oltava aina vähintään yksi 2FA-menetelmä käytössä. Jos käytössä on vain yksi menetelmä, et voi poistaa sitä käytöstä ennen kuin lisäät toisen menetelmän.",
    SECURITY_NOTICE_DESCRIPTION2: "Jotta voit hallita vaihtoehtoista 2FA-menetelmää tai poistaa sen käytöstä, sinun on ensin tunnistauduttava uudelleen kirjautumalla sisään kyseisellä menetelmällä.",
    ADD_CHANGE_PHONE_NUMBER: "Lisää/vaihda puhelinnumero",
    ENTER_PHONE_NUMBER_WITH_COUNTRY_CODE: "Syötä puhelinnumerosi maatunnuksen kanssa (esim. +358 Suomi, +46 Ruotsi)",
    SENDING_VERIFICATION_CODE: "Lähetetään vahvistuskoodia...",
    SET_UP_AUTHENTICATOR_APP: "Määritä todennussovellus",
    SCAN_QR_CODE_WITH_GOOGLE_AUTHENTICATOR_OR_ANOTHER_TOTP_APP: "Skannaa tämä QR-koodi Google Authenticatorilla tai muulla TOTP-sovelluksella:",
    MISSING_2FA_TEXT: "2FA-koodi puuttuu. Syötä koodi jatkaaksesi.",
    MANAGE_YOUR_2FA_METHODS: "Hallitse 2FA-menetelmiäsi",
    REMOVE_2FA: "Poista 2FA",
    ENABLED: "Käytössä",
    DISABLED: "Ei käytössä",
    RECEIVE_VERIFICATION_CODES_VIA_TEXT_MESSAGE_FAST_AND_CONVENIENT_FOR_MOST_USERS: "Vastaanota vahvistuskoodit tekstiviestillä. Nopea ja kätevä useimmille käyttäjille.",
    CHOOSE_FROM_SMS_AUTHENTICATOR_APPS_OR_EMAIL_VERIFICATION: "Valitse tekstiviesti, todennussovellus tai sähköpostivahvistus",
    HIGHEST_SECURITY: "Korkein tietoturva",
    NO_APP_INSTALLATION: "Ei sovelluksen asennusta",
    WORKS_ON_ANY_PHONE: "Toimii kaikissa puhelimissa",
    AUTHENTICATION: "Tunnistautuminen",
    ENTER_VERIFICATION_CODE: "Syötä vahvistuskoodi",
    SENT_6_DIGIT_VERIFICATION_CODE: "Lähetimme 6-numeroisen vahvistuskoodin puhelinnumeroosi",
    VERIFICATION_CODE: "Vahvistuskoodi",
    DIDNT_RECEIVE_THE_CODE: "Etkö saanut koodia?",
    HAVING_TROUBLE: "Onko ongelmia?",
    SWITCH_TO: "Vaihda:",
    REMEMBER_THIS_DEVICE_FOR_30_DAYS: "Muista tämä laite 30 päivän ajan",
    VERIFYING_CODE: "Vahvistetaan koodia...",
    VERIFY: "Vahvista",
    ENTER_6_DIGIT_CODE_FROM_AUTHENTICATOR_APP: "Syötä 6-numeroinen koodi todennussovelluksestasi",
    TWO_FACTOR_AUTHENTICATION_MUST_BE_ENABLED_BY: "Kaksivaiheinen tunnistautuminen (2FA) on otettava käyttöön viimeistään",
    SETUP_2FA: "Määritä 2FA",
    SETUP_AUTHENTICATOR: "Määritä todennussovellus",
    ADD_PHONE: "Lisää puhelin",
    RECONFIGURE: "Määritä uudelleen",
    RESEND_CODE: "Lähetä koodi uudelleen",
    RESENDING: "Lähetetään uudelleen",
    MESSAGE_REQUIRED: "Viesti on pakollinen ",
    TITLE_REQUIRED: "Otsikko on pakollinen",
    MIN_3_CHARS: "Vähintään 3 merkkiä vaaditaan",
    SELECT_ROLE: "Valitse rooli",
    NO_ADDONS_YET: "Lisäkkeitä ei ole vielä luotu",
    PRINT_ONE_BY_ONE: "Tulosta tuotteet yksitellen",
    PRINTERS: "Tulostimet",
    PRINTER_MANAGEMENT: "Tulostinten hallinta",
    UPDATE_PRINTER_LIST: "Päivitä tulostinluettelo",
    TOTAL_PRINTERS: "Tulostimia yhteensä",
    DEFAULT_PRINTER: "Oletustulostin",
    NETWORK_STATUS: "Verkon tila",
    CONNECTED: "Yhdistetty",
    LOADING_PRINTERS: "Ladataan tulostimia...",
    AVAILABLE_PRINTERS: "Käytettävissä olevat tulostimet",
    DEFAULT: "Oletus",
    ONLINE: "Verkossa",
    SHOW_OPTIONS: "Näytä vaihtoehdot",
    NO_PRINTERS_FOUND: "Tulostimia ei löytynyt",
    ADD_FIRST_PRINTER_MESSAGE: "Aloita lisäämällä ensimmäinen tulostimesi.",
    ADD_PRINTER: "Lisää tulostin",
    ADD_NEW_PRINTER: "Lisää uusi tulostin",
    SET_AS_DEFAULT: "Aseta oletukseksi",
    DEACTIVATE: "Poista käytöstä",
    PRINTER_ADDED: "Tulostin lisätty",
    PRINTER_NAME: "Tulostimen nimi",
    ENTER_PRINTER_NAME: "Syötä tulostimen nimi",
    MAC_ADDRESS: "MAC-osoite",
    ENTER_MAC_ADDRESS: "Syötä MAC-osoite",
    DELETE_PRINTER: "Poista tulostin",
    DELETE_PRINTER_QUESTION: "Haluatko varmasti poistaa tämän tulostimen?",
    PRINTER_TEXT: "Määritä ja hallitse kuittitulostimia",
    MEMBER_ADDED: "Jäsen lisätty",
    DO_YOU_REALLY_WANT_TO_DELETE_USER_GROUP: "Haluatko varmasti poistaa tämän käyttäjäryhmän?",
    AT_LEAST_ONE_SERVING_METHOD_REQUIRED: "vähintään yksi tarjoilutapa vaaditaan",
    AT_LEAST_ONE_CRITERIA_REQUIRED: "vähintään yksi ehto vaaditaan",
    DISCOUNT_TYPE: "Alennuksen tyyppi",
    DESCRIPTION_REQUIRED: "Kuvaus vaaditaan",
    DISCOUNT_PERCENT_REQUIRED: "Alennusprosentti vaaditaan",
    DISCOUNT_AMOUNT_REQUIRED: "Alennuksen määrä vaaditaan",
    DISCOUNT_AMOUNT: "Alennuksen määrä",
    EMAIL_REQUIRED: "Sähköposti on pakollinen",
    USER_ALREADY_INVITED_INVITE_AGAIN: "Käyttäjä on jo kutsuttu. Haluatko kutsua uudelleen?",
    MANUAL_EMPLOYEE_ID: "Työntekijätunnus",
    MANUAL_TAG_ID: "Tagin tunnus",
    ENTER_MANUAL_TAG_ID: "Syötä tagin tunnus",
    ENTER_MANUAL_EMPLOYEE_ID: "Syötä työntekijätunnus",
    ADD_MANUAL_USER: "Lisää käyttäjä",
    MANUAL_ENTRY: "Manuaalinen syöttö",
    LAST_EDITED: "Viimeksi muokattu",
    SOMETHING_WENT_WRONG_WHILE_ADDING_DOMAIN: "Verkkotunnuksen lisäämisessä tapahtui virhe",
    USER_INVITED: "Käyttäjä kutsuttu",
    COULD_NOT_INVITE_USER: "Käyttäjän kutsuminen epäonnistui",
    USER_INVITED_AGAIN: "Käyttäjä kutsuttu uudelleen",
    ADD_CRITERIA: "Lisää ehto",
    ALREADY_MEMBER: "On jo jäsen",
    DOMAIN_ALREADY_ADDED: "Verkkotunnus on jo lisätty",
    INVALID_DOMAIN_FORM: "Virheellinen verkkotunnuksen muoto",
    ONE_CATEGORY_MINIMUM: "Sinulla on oltava vähintään yksi kategoria",
    ALERT: "Huomio",
    CLOSE: "Sulje",
    CATEGORIES_DESCRIPTION: "Luo tuotteillesi tuote- ja keittiötulostuskategoriat.",
    CATEGORY: "Kategoria",
    TABLE: "Pöytä",
    SERVING_OPTIONS_DESCRIPTION: "Valitse, mitkä tarjoilutavat ovat käytettävissä myyntikanavissa",
    ENABLE_SERVING_METHOD: "Hallitse tarjoilutapoja",
    ENABLE_SERVING_METHOD_DESCRIPTION: "Kun tarjoilutapa on käytössä, asiakkaat voivat valita sen myyntikanavissasi tilausta tehdessään.",
    DELIVERY_OPTIONS: "Toimitusvaihtoehdot",
    DELIVERY_OPTIONS_DESCRIPTION: "Toimitusvaihtoehtoja on kahdenlaisia. Toisella voit määrittää kiinteitä toimituspaikkoja (esimerkiksi tietyn rakennuksen tai paikan), ja toisella voit toimittaa suoraan asiakkaiden omiin osoitteisiin.",
    EATIN_DESCRIPTION: "Salli asiakkaiden tilata paikan päällä syötäväksi",
    TAKEAWAY_DESCRIPTION: "Salli asiakkaiden tilata noudettavaksi ravintolasta",
    TABLE_SERVING_DESCRIPTION: "Salli asiakkaiden tilata suoraan pöytään",
    SEAT_SERVING_DESCRIPTION: "Salli asiakkaiden tilata suoraan istumapaikalle",
    WORKPLACE_DELIVERY_DESCRIPTION: "Toimitus kiinteisiin paikkoihin, esim. rakennuksiin tai toimiston osastoille",
    HOME_DELIVERY_DESCRIPTION: "Toimitus asiakkaiden osoitteisiin",
    UNABLE_TO_SAVE: "Muutosten tallentaminen epäonnistui",
    THIS_MENU_DELETED: "Tämä menu on poistettu",
    QR_ON_TICKET_TEXT: "Lisää asiakkaan tilauslipukkeeseen QR-koodi, jotta tilauksen voi tarkistaa skannerilla",
    PUBLISH_BANNER_TEXT: "Julkaise viesti yksikön aloitusnäytöllä sovelluksessa jakaaksesi tietoa asiakkaille.",
    TYPE_MESSAGE: "Kirjoita viesti",
    TEAM_MEMBERS_DESCRIPTION: "Hallitse tiimin jäsenten rooleja ja käyttöoikeuksia",
    EAN_CODE: "EAN-koodi",
    EAN: "EAN",
    RECEIPT: "Kuitti",
    CONTROL_UNIT: "Valvontayksikkö",
    MARK_AS_WRONG_HIT: "Haluatko merkitä tämän kuitin virhelyönniksi?",
    RECEIPT_DOWNLOADED: "Kuitti ladattu",
    RECEIPT_DOWNLOAD_FAIL: "Kuitin lataaminen epäonnistui",
    RECEIPT_UPDATED: "Kuitti päivitetty",
    FAILED_TO_EMAIL_RECEIPT: "Kuitin lähettäminen sähköpostilla epäonnistui: ",
    RECEIPT_EMAILED_TO: "Kuitti lähetetty osoitteeseen ",
    PREPARING_EXPORT: "Valmistellaan vientiä",
    HOW_MANY: "Kuinka monta?",
    HOW_MANY_REFUND: "Kuinka monta haluat hyvittää?",
    REFUND_IN_PROGRESS: "Hyvitys käynnissä",
    ENTER_PIN: "Syötä PIN-koodi",
    DOWNLOAD_QR: "Lataa QR-koodi",
    INVITATION_SENT: "Kutsu lähetetty",
    SENT: "Lähetetty",
    SENT_AT: "Lähetysaika",
    READERS_LIST: "Lukijaluettelo",
    READ: "Luettu",
    TOTAL_READS: "Lukukertoja yhteensä",
    TOTAL_SEND: "Lähetetty yhteensä",
    ANONYMOUS_READERS: "Anonyymit lukijat",
    PIN_CODE: "PIN-koodi",
    ADD_PIN_CODE: "Lisää PIN-koodi",
    REMOVE_ADDON_OPTIONS_APPROVAL: "Haluatko poistaa tämän vaihtoehdon ryhmästä?",
    DEL_CONFIRMATION: "Poiston vahvistus",
    OPT_GROUP_UPDATED: "Vaihtoehtoryhmä on päivitetty.",
    WARN_ONE_ADDON_OPTION: "Vähintään yksi lisäkevaihtoehto on pakollinen.",
    REMOVE_ADDON_OPTIONS_GROUP_APPROVAL: "Haluatko varmasti poistaa tämän vaihtoehtoryhmän?",
    OPT_GROUP_REMOVED: "Vaihtoehtoryhmä on poistettu.",
    OPT_GROUP_CREATED: "Vaihtoehtoryhmä on luotu.",
    ARE_YOU_SURE_REMOVE_USER_FROM_GROUP: "Haluatko varmasti poistaa tämän käyttäjän ryhmästä?",
    YES_REMOVE: "Kyllä, poista",
    ADDED_TO_GROUP: "Lisätty käyttäjäryhmiin.",
    REMOVED_USER_FROM_GROUP: "Käyttäjä poistettu ryhmästä.",
    FAILED_TO_REMOVE_USER_FROM_GROUP: "Käyttäjän poistaminen ryhmästä epäonnistui.",
    FAILED_TO_ADD_USER_TO_GROUP: "Käyttäjän lisääminen ryhmään epäonnistui.",
    EDIT_INFORMATION: "Muokkaa tietoja",
    PROFILE_UPDATED: "Profiili päivitetty.",
    PRODUCT_REGISTER: "Tuoterekisteri",
    NO_PRODUCTS_FOUND: "Tuotteita ei löytynyt",
    NAME_AND_TAGS: "Nimi ja tagit",
    IMAGE: "Kuva",
    SUBCATEGORIES: "Alakategoriat",
    TIME_SCHEDULED: "Ajastettu",
    EDIT_NAME: "Muokkaa nimeä",
    PRODUCT_ADDED_TITLE: "Lisätty",
    PRODUCT_REMOVED_TITLE: "Poistettu",
    HANDLE_MENUS: "Hallitse menuja",
    HANDLE_MENUS_TEXT: "Hallitse menujasi ja alakategorioitasi täällä – luo uusia tai muokkaa olemassa olevia",
    MENU_LIST: "Menut",
    MENU_LIST_TEXT: "Luo ja muokkaa menujasi",
    DELETE_SUBCATEGORY_Q: "Yleisen alakategorian poistaminen poistaa sen kaikista menuista, joihin se kuuluu. Haluatko varmasti poistaa?",
    MANAGE_SUBCATEGORIES: "Hallitse alakategorioita",
    CREATE_DRINK_CATEGORY: "Luo alakategoria juomille",
    CREATE_FOOD_CATEGORY: "Luo alakategoria ruoalle",
    ADD_DRINK_CATEGORY: "Lisää alakategoria juomiin",
    ADD_FOOD_CATEGORY: "Lisää alakategoria ruokiin",
    CATEGORY_TYPE: "Kategoria",
    SELECT_SUBCATEGORY: "Valitse alakategoria",
    CREATE_NEW: "Luo uusi",
    ADD_EXISTING: "Lisää olemassa oleva",
    EDIT_SUBCATEGORY: "Muokkaa alakategoriaa",
    VISIBLE_IN_KIOSK: "(näkyy kioskissa)",
    IMAGE_REQUIRED: "Kuva vaaditaan",
    PRODUCTS_REMOVED: "Tuotteet poistettu",
    INVITE_USER_ERROR: "Käyttäjän kutsumisessa tapahtui virhe.",
    DELIVERY_OPTIONS_MENU: "Valitse menun tarjoilutapa",
    DELIVERY_OPTIONS_MENU_EXPLANATION: "Kun tämä menu näkyy sovelluksessa, nämä tarjoilutavat ovat käytössä.",
    NO_DRINK_CATEGORIES: "Juomakategorioita ei ole vielä luotu.",
    NO_FOOD_CATEGORIES: "Ruokakategorioita ei ole vielä luotu.",
    ADD_CATEGORY: "Lisää kategoria",
    NO_SUB_NO_PRODS: "ei sisällä tuotteita. Poista alakategoria tai lisää tuotteita.",
    MENU_ACTIVATE_ERROR: "Hups! Jokin meni vikaan, eikä menua aktivoitu.",
    PIN_CODE_ADDED: "Menun PIN-koodi lisätty",
    FEATURED_LIST_REORDERED: "Menun nostettujen tuotteiden järjestys päivitetty.",
    WRONG_PIN: "Väärä PIN, yritä uudelleen",
    REFUNDED: "Hyvitetty",
    REFUNDED_RECEIPT: "Hyvitetty kuitti",
    RECEIPT_ALREADY_REFUNDED: "Kuitti on jo hyvitetty",
    RECEIPT_ALREADY_PARTIALLY_REFUNDED: "Kuitti on jo osittain hyvitetty",
    USERS_NOT_ALLOWED_TO_REPURCHASE: "Käyttäjillä ei ole oikeutta tehdä takaisinostoja",
    RECEIPT_LINE_ALREADY_REFUNDED: "Kuittirivi on jo hyvitetty",
    CONTACT_SUPPORT: "Ota yhteyttä tukeen tällä kuittinumerolla",
    USERS_NOT_ALLOWED_TO_MARK_AS_CORRECTION: "Käyttäjillä ei ole oikeutta merkitä virhelyöntejä",
    REMAINING_ATTEMPTS: "Yrityksiä jäljellä",
    CONFIRM_PIN_SUBMIT: "Vahvista PIN tehdäksesi täyden hyvityksen",
    CONFIRM_PIN_PARTIAL_REFUND: "Vahvista PIN hyvittääksesi valitut tuotteet",
    REFUNDS: "Hyvitykset",
    REASON_FOR_REFUND: "Hyvityksen syy",
    PROCEED: "Jatka",
    NO_REFUND_RECEIPT_FOUND: "Hyvityskuittia ei löytynyt",
    NO_RECEIPT_FOUND: "Kuittia ei löytynyt",
    REPURCHASE: "Kuitille on tehty takaisinosto",
    RECEIPT_NOT_FOUND: "Kuittia ei löytynyt numerolla",
    FAILED_TO_REFUND_RECEIPT: "Kuitin hyvitys epäonnistui",
    COLLECTIVE_DISCOUNT: "Yhteisalennus",
    SMOOTHING: "Pyöristys",
    REASON_MUST_BE_FILLED_IN: "Syy on täytettävä",
    REFUNDED_BY: "Hyvittäjä",
    ERROR_RECEIPT: "Kuittien hakemisessa tapahtui virhe. Yritä myöhemmin uudelleen.",
    NO_PRODUCT_EXTERNAL_ID: "Tuotteelle on lisättävä ulkoinen tunnus ennen kuin sen voi lisätä menuun. Siirry tuoteluetteloon ja päivitä tuote.",
    NO_EXTERNAL_ID_HEADER: "Ulkoinen tunnus puuttuu",
    INVALID_EAN: "EAN-koodin tulee sisältää vain numeroita ja olla 8–14 merkkiä pitkä.",
    ASSIGN_TO_STEP: "Liitä vaiheeseen",
    ENABLE_STEP_BY_STEP_FLOW: "Liitetyt lisäkkeet poistetaan. Haluatko silti ottaa vaiheittaisen valinnan käyttöön?",
    DISABLE_STEP_BY_STEP_FLOW: "Liitetyt lisäkkeet poistetaan. Haluatko silti poistaa vaiheittaisen valinnan käytöstä?",
    STEP_HEADER: "Otsikko",
    STEP_SUB_HEADER: "Alaotsikko",
    ADD_TITLE: "Lisää otsikko...",
    ADD_DESCRIPTION: "Lisää kuvaus...",
    NO_ADDONS_IN_STEP: "Tällä tuotteella ei ole lisäkkeitä tässä vaiheessa.",
    DELETE_STEP: "Poista vaihe",
    LIST_VIEW_TEXT: "Listanäkymä on oletustila, ja se näyttää lisäkkeet järjestettynä listana tuotesivulla.",
    STEP_BY_STEP_VIEW_TEXT: "Vaiheittainen tila esittää lisäkkeet vaihe vaiheelta tuotesivulla.",
    DISABLE_NAME_PRODUCT: "Poista käytöstä \"Nimeä tuotteesi\" -vaihe",
    DISABLE_NAME_PRODUCT_TEXT: "Viimeinen nimeämisvaihe ohitetaan tämän tuotteen osalta kaikissa kanavissa.",
    ADD_STEP: "Lisää vaihe",
    SERVING_METHODS: "Tarjoilutavat",
    SERVING_METHOD_EAT_IN: "Syödään paikan päällä",
    SERVING_METHOD_TAKEAWAY: "Noutoruoka",
    SERVING_METHOD_TABLE: "Pöytiintarjoilu",
    SERVING_METHOD_HOME_DELIVERY: "Kotiinkuljetus",
    SERVING_METHOD_FIXED_LOCATION: "Kiinteä toimituspaikka",
    UNASSIGN: "Poista liitos",
    REFUND_REASON_LABEL: "Kirjoita hyvityksen syy, enintään 200 merkkiä",
    CATERING: "Catering",
    CATERING_PRODUCT_LIST: "Catering-tuoteluettelo",
    CATERING_PRODUCT_LIST_DESCRIPTION: "Hallitse, päivitä ja järjestä catering-tuotteitasi.",
    CATERING_SETTINGS_TITLE: "Catering-asetukset",
    CATERING_SETTINGS_SUBTITLE: "Hallitse yksikön catering-asetuksia",
    CATERING_PICKUP_TAB: "Nouto",
    CATERING_DELIVERY_TAB: "Toimitus",
    CATERING_ADDITIONAL_SETTINGS_TAB: "Lisäasetukset",
    CATERING_PICKUP_INSTRUCTIONS_TITLE: "Nouto-ohjeet",
    CATERING_PICKUP_INSTRUCTIONS_DESCRIPTION: "Nämä ovat ohjeet, joita asiakkaiden tulee noudattaa noutaessaan catering-tilauksensa. Ne näkyvät sekä catering-verkkosivulla että vahvistussähköpostissa.",
    CATERING_PICKUP_INSTRUCTIONS_PLACEHOLDER: "Nouto pääaulan vastaanotosta",
    CATERING_PICKUP_INSTRUCTIONS_MAX_LENGTH: "Nouto-ohjeet saavat olla enintään 100 merkkiä.",
    CATERING_PICKUP_INSTRUCTIONS_SAVED: "Noutotiedot tallennettu.",
    CATERING_PICKUP_INSTRUCTIONS_SAVE_ERROR: "Noutotietojen tallennus epäonnistui.",
    CATERING_PICKUP_INSTRUCTIONS_LOAD_ERROR: "Nouto-ohjeiden lataus epäonnistui.",
    CATERING_SETTINGS_TAB_PLACEHOLDER: "Catering-lisäasetukset tulevat näkyviin tähän pian.",
    PRODUCT_CREATED: "Tuote luotu.",
    CATERING_ORDERS_DESCRIPTION: "Hallitse ja seuraa kaikkia catering-verkkosovelluksen tilauksia",
    PRINT_EXPORT: "Tulosta/vie",
    DELIVERY_METHOD: "Toimitustapa",
    SELECT_DATE_RANGE: "Valitse aikaväli",
    SELECT_DATE_TIME: "Valitse päivämäärä ja aika",
    SEARCH_ORDERS: "Hae tilauksia...",
    CATERING_CUSTOMER_NAME: "Asiakkaan nimi",
    COMPLETION_DATE: "Valmistumispäivä",
    PICKUP: "Nouto",
    COMMENT: "Kommentti",
    CREATION_DATE: "Luontipäivä",
    VIEW_DETAILS: "Näytä tiedot",
    CHOOSE_COLUMNS: "Valitse sarakkeet",
    ORDER_INFORMATION: "Tilauksen tiedot",
    ORDER_DATE: "Tilauspäivä",
    METHOD: "Tapa",
    DELIVERY_TIME: "Toimitusaika",
    PICKUP_TIME: "Noutoaika",
    FULL_NAME: "Koko nimi",
    PAYMENT_STATUS: "Maksun tila",
    DELIVERY_STATUS: "Toimituksen tila",
    CATERING_UNPAID: "Maksamatta",
    CATERING_PENDING: "Odottaa",
    CATERING_DELIVERED: "Toimitettu",
    APPROVE_ORDER: "Hyväksy tilaus",
    DECLINE_ORDER: "Hylkää tilaus",
    MARK_AS_DONE: "Merkitse valmiiksi",
    MARK_AS_PENDING: "Merkitse odottavaksi",
    PRINT_EXPORT_ORDERS: "Tulosta/vie tilaukset",
    DATE_RANGE_ORDER_CREATION: "Aikaväli (tilauksen luontipäivän mukaan)",
    DATE_RANGE_COMPLETION: "Aikaväli (valmistumispäivän mukaan)",
    SELECT_DELIVERY_METHOD: "Valitse toimitustapa",
    ONLY_APPROVED_ORDERS: "Tulosteeseen/vientiin sisällytetään vain hyväksytyt tilaukset.",
    PRINT: "Tulosta",
    EXPORT_PDF: "Vie pdf",
    EXPORT_PRODUCTION_TASKS: "Vie tuotantotehtävät",
    PRODUCTION_TASKS_INFO: "Raportti sisältää kaikki hyväksytyt tilaukset, jotka valmistuvat valitulla aikavälillä. Tuotteet ryhmitellään päivittäin ja määrät lasketaan yhteen.",
    DATE_RANGE: "Aikaväli",
    CONTACT_CUSTOMER: "Ota yhteyttä asiakkaaseen",
    DOWNLOAD_PDF: "Lataa PDF",
    APPROVED: "Hyväksytty",
    COMPLETED: "Valmis",
    DONE: "Valmis",
    DECLINED: "Hylätty",
    QUANTITY: "Määrä",
    EACH: "kpl",
    MOBILE_PAY: "Mobile Pay",
    REGISTERED: "Rekisteröity",
    TAGS_CATEGORIES: "Tunnisteet ja kategoriat",
    CATERING_MENUS: "Catering-menut",
    MANAGE_PRIORITIZE_MENUS: "Hallitse ja priorisoi catering-menujasi",
    CREATE_MENU: "Luo menu",
    TOTAL_MENUS: "Menuja yhteensä",
    MENU_STATUS: "Menun tila",
    NO_ACTIVE_MENU: "Ei aktiivista menua",
    INACTIVE_MENUS: "Passiiviset menut",
    VIEW_MANAGE_MENUS: "Tarkastele ja hallitse kaikkia catering-menujasi",
    DEACTIVATE_MENU: "Poista menu käytöstä",
    EDIT_MENU: "Muokkaa menua",
    NO_MENUS_FOUND: "Menuja ei löytynyt",
    CREATE_FIRST_MENU_DESC: "Aloita luomalla ensimmäinen catering-menusi. Järjestä tarjontasi ja tuo se asiakkaiden saataville.",
    CREATE_FIRST_MENU: "Luo ensimmäinen menu",
    EDIT_MENU_DIALOG: "Muokkaa menua",
    MENU_NAME: "Menun nimi",
    MENU_NAME_PLACEHOLDER: "esim. Häämenu, Yrityslounas",
    CREATE_CAMPAIGN_MENU: "Luodaanko kampanjamenu?",
    USE_FIXED_DATES: "Käytä kiinteitä toimitus-/noutopäiviä",
    CAMPAIGN_TYPE: "Kampanjatyyppi",
    SELECTED_TYPE: "Valittu tyyppi",
    ADD_PICKUP_DATE: "Lisää noutopäivä",
    ADD_DELIVERY_DATE: "Lisää toimituspäivä",
    PICKUP_DATES: "Noutopäivät",
    DELIVERY_DATES: "Toimituspäivät",
    PICKUP_TIME_SLOTS: "Noutoajat",
    DELIVERY_TIME_SLOTS: "Toimitusajat",
    ADD_TIME_SLOT: "Lisää aikaikkuna",
    START_TIME_MUST_BE_LESS_THAN_END_TIME: "Alkamisajan on oltava ennen päättymisaikaa",
    START_AND_END_TIME_CANNOT_BE_SAME: "Alkamis- ja päättymisaika eivät voi olla samat",
    TIME_SLOT_OVERLAPS_WITH_ANOTHER: "Tämä aikaikkuna menee päällekkäin toisen aikaikkunan kanssa",
    ACTIVE_MENUS_VISIBLE: "Aktiiviset menut näkyvät asiakkaille",
    UPDATE_MENU: "Päivitä menu",
    NO_ACTIVE_MENU_WARNING: "Ei aktiivista menua: asiakkaat eivät voi tehdä tilauksia ennen kuin menu aktivoidaan.",
    LONG_DESCRIPTION: "Pitkä kuvaus",
    SERVINGS_PER_PRODUCT: "Annoksia per tuote",
    MINIMUM_ORDER_QUANTITY: "Vähimmäistilausmäärä",
    CATERING_DIETARY_TAGS: "Ruokavaliotunnisteet",
    CATERING_ECO_TAGS: "Ympäristötunnisteet",
    FULFILLMENT_OPTIONS: "Toimitusvaihtoehdot",
    PICK_UP: "Nouto",
    DELIVERY_OPTION: "Toimitus",
    BOTH: "Molemmat",
    SERVING: "Tarjoilu",
    ECONOMICS: "Talous",
    MINIMUM_ORDER_LEAD_DAYS: "Tilauksen vähimmäisennakko (päivää)",
    MAXIMUM_ORDER_QUANTITY: "Enimmäistilausmäärä",
    SELECT_UP_TO_4: "Valitse enintään 4",
    DETAILS: "Tiedot",
    BACK_TO_MENUS: "Takaisin menuihin",
    TOTAL_CATEGORIES: "Kategorioita yhteensä",
    TOTAL_PRODUCTS: "Tuotteita yhteensä",
    WITH_PRODUCTS: "Sisältää tuotteita",
    NO_CATEGORIES_FOUND: "Kategorioita ei löytynyt",
    CREATE_FIRST_CATEGORY_DESC: "Luo ensimmäinen kategoria järjestääksesi tämän menun tuotteet.",
    CREATE_FIRST_CATEGORY: "Luo ensimmäinen kategoria",
    HERO_IMAGE_TEXT_COLOR_CAMPAIGN: "Pääkuvan tekstin väri",
    HERO_IMAGE_TEXT_COLOR_CAMPAIGN_PLACEHOLDER: "esim. #000000 tai #FFFFFF",
    HERO_IMAGE_TEXT_COLOR_REGULAR: "Tekstin väri",
    HERO_IMAGE_TEXT_COLOR_REGULAR_PLACEHOLDER: "esim. #000000 tai #FFFFFF",
    CATEGORIES_MANAGEMENT: "Kategorioiden hallinta",
    ORGANIZE_PRODUCTS_CATEGORIES: "Järjestä tuotteesi omilla kategorioilla",
    CATEGORIES_WITH_PRODUCTS: "Kategoriat, joissa on tuotteita",
    DIETARY_TAGS_MANAGEMENT: "Ruokavaliotunnisteiden hallinta",
    ORGANIZE_DIETARY_TAGS: "Hallitse tuotteidesi ruokavaliotunnisteita",
    ECO_TAGS_MANAGEMENT: "Ympäristötunnisteiden hallinta",
    ORGANIZE_ECO_TAGS: "Hallitse tuotteidesi ympäristötunnisteita",
    ADD_DIETARY_TAG: "Lisää ruokavaliotunniste",
    ADD_ECO_TAG: "Lisää ympäristötunniste",
    TOTAL_DIETARY_TAGS: "Ruokavaliotunnisteita yhteensä",
    TOTAL_ECO_TAGS: "Ympäristötunnisteita yhteensä",
    DIETARY_TAGS_WITH_PRODUCTS: "Ruokavaliotunnisteet, joissa on tuotteita",
    ECO_TAGS_WITH_PRODUCTS: "Ympäristötunnisteet, joissa on tuotteita",
    LINKED_PRODUCTS: "Linkitetyt tuotteet",
    AVAILABLE_PRODUCTS: "Saatavilla olevat tuotteet",
    PRODUCTS_LINKED: "Tuotteita linkitetty",
    PRODUCT_LINKED: "Tuote linkitetty",
    SEARCH_LINKED_PRODUCTS: "Hae linkitettyjä tuotteita...",
    NO_PRODUCTS_LINKED: "Ei linkitettyjä tuotteita",
    TRY_DIFFERENT_SEARCH: "Kokeile toista hakusanaa",
    ADD_PRODUCTS_FROM_AVAILABLE: "Lisää tuotteita \"Saatavilla olevat tuotteet\" -välilehdeltä",
    NO_DESCRIPTION: "Ei kuvausta",
    SEARCH_AVAILABLE_PRODUCTS: "Hae saatavilla olevia tuotteita...",
    NO_AVAILABLE_PRODUCTS: "Ei saatavilla olevia tuotteita",
    ALL_PRODUCTS_ADDED: "Kaikki tuotteet on lisätty tähän kategoriaan",
    ADD_TO_CATEGORY: "Lisää kategoriaan",
    ENABLE_STOCK_BALANCE_TRACKING: "Ota varastosaldon seuranta käyttöön",
    STOCK_BALANCE_DISABLED: "(Pois käytöstä)",
    SERVINGS: "Annokset",
    MIN_ORDER: "Vähimmäistilaus",
    ON: "pvm",
    ORGANIZE_MENU_CATEGORIES: "Järjestä menun tuotteet kategorioihin",
    NO_DESCRIPTION_PROVIDED: "Kuvausta ei ole annettu",
    LAST_MODIFIED_DATE: "Viimeksi muokattu",
    MANAGE_PRODUCTS: "Hallitse tuotteita",
    NO_CATEGORIES_YET: "Ei vielä kategorioita",
    CREATE_FIRST_CATEGORY_TEXT: "Luo ensimmäinen kategoria aloittaaksesi menun tuotteiden järjestämisen. Kategoriat jäsentävät menua ja helpottavat asiakkaiden selaamista.",
    CATEGORY_NAME: "Kategorian nimi",
    CATEGORY_DESCRIPTION: "Kategorian kuvaus",
    CATEGORY_NAME_PLACEHOLDER: "esim. Alkuruoat, Pääruoat, Jälkiruoat",
    CATEGORY_DESCRIPTION_PLACEHOLDER: "Kirjoita lyhyt kuvaus tästä kategoriasta...",
    OPTIONAL_CATEGORY_DETAILS: "Valinnainen: lisää tietoja, jotka auttavat asiakkaita ymmärtämään tämän kategorian",
    UPDATE_CATEGORY: "Päivitä kategoria",
    DELETE_CATEGORY: "Poista kategoria",
    CREATE_NEW_CATEGORY: "Luo uusi kategoria",
    SEARCH_CATEGORIES: "Hae kategorioita...",
    SEARCH_DIETARY_TAGS: "Hae ruokavaliotunnisteita...",
    SEARCH_ECO_TAGS: "Hae ympäristötunnisteita...",
    SORT_BY: "Lajittele",
    TAGS_WITH_PRODUCTS: "Tunnisteet, joissa on tuotteita",
    TRY_ADJUSTING_SEARCH: "Muuta hakuehtoja tai luo uusi kategoria.",
    NO_DIETARY_TAGS_FOUND: "Ruokavaliotunnisteita ei löytynyt",
    NO_ECO_TAGS_FOUND: "Ympäristötunnisteita ei löytynyt",
    ORGANIZE_DIETARY_INFO: "Järjestä tuotteesi ruokavaliotunnisteilla",
    ORGANIZE_ECO_INFO: "Järjestä tuotteesi ympäristötunnisteilla",
    CREATE_FIRST_DIETARY_TAG: "Luo ensimmäinen ruokavaliotunniste",
    CREATE_FIRST_ECO_TAG: "Luo ensimmäinen ympäristötunniste",
    ADD_NEW_CATEGORY: "Lisää uusi kategoria",
    ENTER_CATEGORY_NAME: "Anna kategorian nimi",
    DESCRIPTION_OPTIONAL: "Kuvaus (valinnainen)",
    ENTER_CATEGORY_DESCRIPTION: "Anna kategorian kuvaus",
    ENTER_DIETARY_TAG_NAME: "Anna ruokavaliotunnisteen nimi",
    ENTER_DIETARY_TAG_DESCRIPTION: "Anna ruokavaliotunnisteen kuvaus",
    DIETARY_TAG_NAME: "Ruokavaliotunnisteen nimi",
    ECO_TAG_NAME: "Ympäristötunnisteen nimi",
    ENTER_ECO_TAG_NAME: "Anna ympäristötunnisteen nimi",
    ENTER_ECO_TAG_DESCRIPTION: "Anna ympäristötunnisteen kuvaus",
    ADD_NEW_DIETARY_TAG: "Lisää uusi ruokavaliotunniste",
    ADD_NEW_ECO_TAG: "Lisää uusi ympäristötunniste",
    EDIT_DIETARY_TAG: "Muokkaa ruokavaliotunnistetta",
    EDIT_ECO_TAG: "Muokkaa ympäristötunnistetta",
    CREATE_DIETARY_TAG: "Luo ruokavaliotunniste",
    UPDATE_DIETARY_TAG: "Päivitä ruokavaliotunniste",
    CREATE_ECO_TAG: "Luo ympäristötunniste",
    UPDATE_ECO_TAG: "Päivitä ympäristötunniste",
    LINKED: "linkitetty",
    SELECT_CATEGORY: "Valitse kategoria",
    DATE_CREATED: "Luontipäivä",
    SEARCH_TITLE_OR_TEXT: "Hae...",
    PUSH_NOTIFICATIONS_INTRO: "Voit luoda ja lähettää uuden ilmoituksen tai lähettää aiemman ilmoituksen uudelleen historiasta",
    ALL_NEWS: "Kaikki uutiset",
    CREATE_NEW_NOTIFICATION: "Luo ilmoitus",
    PUSH_NOTIFICATION: "Push-ilmoitus",
    NO_PUSH_NOTIFICATIONS_FOUND: "Push-ilmoituksia ei löytynyt",
    NO_NEWS_FOUND: "Uutiskaruselleja ei löytynyt",
    RECIPIENT: "Vastaanottaja",
    SEND_TO_ALL: "Lähetä kaikille",
    SEND_TO_GROUP: "Lähetä ryhmälle",
    SELECT_GROUP: "Tämä ilmoitus lähetetään",
    REACH_STATMENT: "Push-ilmoitus tavoittaa:",
    GROUPS: "Ryhmä(t)",
    NO_GROUPS: "Ei ryhmiä",
    ALL_USERS: "Kaikki käyttäjät",
    SELECT_USER_GROUPS: "Valitse käyttäjäryhmä",
    PRODUCT_NOT_FOUND: "Tuotetta ei löytynyt",
    NOT_FOUND: "Ei löytynyt",
    FAILED_TO_DELETE_PRODUCT: "Tuotteen poisto epäonnistui",
    FAILED_TO_BULK_UPDATE_PRODUCTS: "Tuotteiden joukkopäivitys epäonnistui",
    SHARED: "Jaettu",
    PRODUCTS_BULK_UPDATED: "Tuotteet päivitetty joukkona",
    UPDATED: "Päivitetty",
    DISCARDED: "Hylätty",
    CHANGES_DISCARDED: "Muutokset hylätty",
    PRODUCT_UPDATED: "Tuote päivitetty",
    FAILED_TO_SAVE_PRODUCT: "Tuotteen tallennus epäonnistui",
    PRODUCTION_TASKS_REPORT_GENERATED_SUCCESSFULLY: "Tuotantotehtäväraportti luotu",
    FAILED_TO_LOAD_ORDERS: "Tilausten lataus epäonnistui",
    FAILED_TO_UPDATE_ORDER_STATUS: "Tilauksen tilan päivitys epäonnistui",
    INVALID_MENU_IDENTIFIER: "Virheellinen menun tunniste",
    MENU_NOT_FOUND: "Menua ei löytynyt",
    FAILED_TO_LOAD_MENU_DETAILS: "Menun tietojen lataus epäonnistui",
    FAILED_TO_LOAD_CATEGORIES: "Kategorioiden lataus epäonnistui",
    CATEGORY_NAME_REQUIRED: "Kategorian nimi on pakollinen",
    CATEGORY_CREATED_SUCCESSFULLY: "Kategoria luotu",
    FAILED_TO_CREATE_CATEGORY: "Kategorian luonti epäonnistui",
    CATEGORY_UPDATED_SUCCESSFULLY: "Kategoria päivitetty",
    FAILED_TO_UPDATE_CATEGORY: "Kategorian päivitys epäonnistui",
    CATEGORY_DELETED_SUCCESSFULLY: "Kategoria poistettu",
    FAILED_TO_DELETE_CATEGORY: "Kategorian poisto epäonnistui",
    FAILED_TO_UPDATE_PRODUCT_ORDER: "Tuotejärjestyksen päivitys epäonnistui",
    FAILED_TO_LOAD_PRODUCTS: "Tuotteiden lataus epäonnistui",
    FAILED_TO_ADD_PRODUCT_TO_CATEGORY: "Tuotteen lisääminen kategoriaan epäonnistui",
    FAILED_TO_REMOVE_PRODUCT_FROM_CATEGORY: "Tuotteen poistaminen kategoriasta epäonnistui",
    PRODUCT_ORDER_UPDATED: "Tuotejärjestys päivitetty",
    FAILED_TO_LOAD_CATERING_MENUS: "Catering-menujen lataus epäonnistui",
    MENU_CREATED_SUCCESSFULLY: "Menu luotu",
    FAILED_TO_CREATE_MENU: "Menun luonti epäonnistui",
    MENU_UPDATED_SUCCESSFULLY: "Menu päivitetty",
    FAILED_TO_UPDATE_MENU: "Menun päivitys epäonnistui",
    MENU_DELETED_SUCCESSFULLY: "Menu poistettu",
    FAILED_TO_DELETE_MENU: "Menun poisto epäonnistui",
    MENU_DEACTIVATED: "Menu poistettu käytöstä",
    FAILED_TO_UPDATE_MENU_STATUS: "Menun tilan päivitys epäonnistui",
    NAME_ASC: "Nimi (A–Ö)",
    NAME_DESC: "Nimi (Ö–A)",
    DATE_CREATED_NEWEST: "Luontipäivä (uusin ensin)",
    DATE_CREATED_OLDEST: "Luontipäivä (vanhin ensin)",
    DELETE_ECO_TAG: "Poista ympäristötunniste",
    DELETE_DIETARY_TAG: "Poista ruokavaliotunniste",
    CONFIRM_STATUS_UPDATE: "Vahvista tilan päivitys",
    REMOVE_PRODUCT: "Poista tuote",
    BASIC_INFORMATION: "Perustiedot",
    CAMPAIGN_SETTINGS: "Kampanja-asetukset",
    ENABLE_PICKUP_DELIVERY_DATES: "Ota käyttöön määrittääksesi tietyt nouto-/toimituspäivät ja -ajat",
    REMOVE_DATE: "Poista päivämäärä",
    START_DATE_REQUIRED_FOR_CAMPAIGN_MENU: "Kampanjamenulle on annettava alkamispäivä",
    END_DATE_AFTER_START_DATE: "Päättymispäivän on oltava alkamispäivän jälkeen",
    BOTH_DATES_PASSED_WARNING: "Sekä alkamis- että päättymispäivä ovat menneet. Päivitä päivämäärät ennen tämän menun aktivointia.",
    PAST_DATE_RANGE_EDIT_WARNING: "Molemmat valitut päivämäärät ovat menneisyydessä. Päivitä päättymispäivä tähän päivään tai myöhemmäksi, jotta voit muokata alkamispäivää.",
    PAST_SCHEDULE_DATES_WARNING: "Yksi tai useampi nouto-/toimituspäivä on menneisyydessä. Päivitä tai poista menneet päivät tallentaaksesi muutokset.",
    AT_LEAST_ONE_PICKUP_SCHEDULE_REQUIRED: "Vähintään yksi noutoaikataulu vaaditaan",
    AT_LEAST_ONE_DELIVERY_SCHEDULE_REQUIRED: "Vähintään yksi toimitusaikataulu vaaditaan",
    AT_LEAST_ONE_PICKUP_OR_DELIVERY_SCHEDULE_REQUIRED: "Vähintään yksi nouto- tai toimitusaikataulu vaaditaan",
    MENU_NAME_REQUIRED: "Menun nimi on pakollinen",
    ALLERGEN_CATEGORIES: "Allergeeniryhmät",
    REMOVE_ALLERGEN_CATEGORY: "Poista allergeeniryhmä",
    MILK: "🥛 Maito",
    MILK_PROTEIN: "🥛 Maitoproteiini",
    GLUTEN: "🌾 Gluteeni",
    NUTS: "🥜 Pähkinät",
    CRUSTACEANS: "🦞 Äyriäiset",
    EGG: "🥚 Kananmuna",
    MOLLUSCS: "🦪 Nilviäiset",
    FISH: "🐟 Kala",
    PORK: "🥓 Sianliha",
    PEANUTS: "🥜 Maapähkinä",
    SESAME_SEEDS: "Seesaminsiemenet",
    SULPHUR: "Sulfiitit",
    SOYBEANS: "🫘 Soija",
    CELERY: "🥬 Selleri",
    MUSTARD: "Sinappi",
    LUPIN: "Lupiini",
    GARLIC: "🧄 Valkosipuli",
    MUSHROOM: "🍄‍🟫 Sieni",
    ALMOND: "🥜 Manteli",
    HAZELNUT: "🥜 Hasselpähkinä",
    WALNUT: "🥜 Saksanpähkinä",
    CASHEW: "🥜 Cashewpähkinä",
    PECAN: "🥜 Pekaanipähkinä",
    BRAZIL_NUT: "🥜 Parapähkinä",
    PISTACHIO: "🥜 Pistaasipähkinä",
    MACADAMIA: "🥜 Macadamiapähkinä",
    CATERING_DELIVERY_AVAILABILITY_DESC: "Määritä, mitä päiviä ja aikaikkunoita asiakkaat voivat valita toimitukselle. Ota kukin päivä käyttöön tai pois käytöstä ja lisää tarkat aikaikkunat.",
    CATERING_DELIVERY_AVAILABILITY: "Toimitusten saatavuus",
    MENUDISPLAY_SETTINGS_TITLE: "Menunäytön asetukset",
    MENUDISPLAY_SETTINGS_SUBTITLE: "Määritä menunäyttösi",
    MENUDISPLAY_GENERAL_SETTINGS_TAB: "Yleiset asetukset",
    MENUDISPLAY_GENERAL_SETTINGS_SUBTITLE: "Yksikön laajuiset menunäytön asetukset, jotka koskevat kaikkia näyttöjä ja dioja.",
    MENUDISPLAY_DEFAULT_LANGUAGE_SUBTITLE: "Oletuskieli, joka näytetään tämän yksikön menunäytöillä.",
    MENUDISPLAY_MENU_DISPLAY_CONFIG_SUBTITLE: "Määritä logo, tausta, fontin väri ja tuotekuvien näkyvyys.",
    MENUDISPLAY_PRODUCT_IMAGE: "Tuotekuva",
    MENUDISPLAY_PRODUCT_IMAGE_SUBTITLE: "Näytä tuotekuvan pikkukuva",
    MENUDISPLAY_TOGGLE_ON: "Päällä",
    MENUDISPLAY_TOGGLE_OFF: "Pois",
    MENUDISPLAY_FONT_COLOR: "Fontin väri",
    MENUDISPLAY_FONT_FAMILY_TITLE: "Fonttiperhe",
    MENUDISPLAY_FONT_FAMILY_SUBTITLE: "Valitse Google-fontti menunäytön tekstille.",
    MENUDISPLAY_FONT_PREVIEW_SAMPLE: "Esimerkki: Aa Bb Cc 0123456789",
    MENUDISPLAY_FONT_COLOR_SUBTITLE: "Valitse fontin väri",
    MENUDISPLAY_FONT_COLOR_HEX_PLACEHOLDER: "#000000",
    MENUDISPLAY_LOGO_SUBTITLE: "Lisää tai poista logo",
    MENUDISPLAY_LOGO_TITLE: "Logo",
    CHANGE_LOGO: "Vaihda logo",
    MENUDISPLAY_UPLOADED: "Ladattu",
    MENUDISPLAY_NOT_SET: "Ei asetettu",
    MENUDISPLAY_LOGO_PREVIEW_ALT: "Logon esikatselu",
    MENUDISPLAY_REPLACE_IMAGE: "Korvaa kuva",
    MENUDISPLAY_CLICK_TO_UPLOAD_LOGO: "Lataa napsauttamalla",
    MENUDISPLAY_LOGO_UPLOAD_HINT: "PNG, JPG, SVG · Suositus 400×400px",
    MENUDISPLAY_CUSTOM_MENU_DISPLAY_TITLE: "Mukautettu menunäyttö",
    MENUDISPLAY_CUSTOM_MENU_DISPLAY_SUBTITLE: "Luo ja hallitse uudelleenkäytettäviä tuoteryhmiä menunäytön dioihin.",
    MENUDISPLAY_BACKGROUND_TITLE: "Tausta",
    MENUDISPLAY_BACKGROUND_SUBTITLE: "Taustan resoluution on oltava 1080x1920",
    MENUDISPLAY_BACKGROUND_PREVIEW_ALT: "Taustan esikatselu",
    MENUDISPLAY_CLICK_TO_UPLOAD_BACKGROUND: "Lataa tausta napsauttamalla",
    MENUDISPLAY_BACKGROUND_UPLOAD_HINT: "PNG, JPG · Suositus 1920×1080px",
    MENUDISPLAY_CHANGE_IMAGE: "Vaihda kuva",
    MENUDISPLAY_REMOVE_LOGO_WARN: "Logon poistaminen vaikuttaa menunäytön asetteluun",
    MENUDISPLAY_DELETE: "Poista",
    MENUDISPLAY_ABORT: "Peruuta",
    MENUDISPLAY_FAILED_UPDATE: "Päivitys epäonnistui",
    MENUDISPLAY_THEME_SAVED: "Teema tallennettu",
    MENUDISPLAY_NO_LOGO: "Ei poistettavaa logoa",
    MENUDISPLAY_REMOVE_LOGO_HEADER: "Poistetaanko logo?",
    MENUDISPLAY_SELECT_FILE: "Valitse tiedosto",
    MENUDISPLAY_UNSAVED_CHANGES_HINT: "Sinulla on tallentamattomia muutoksia",
    MENUDISPLAY_LOADING_ARIA_LABEL: "ladataan",
    MENUDISPLAY_LOADING_THEME_SETTINGS_TEXT: "Ladataan teema-asetuksia…",
    SCREEN_SETTINGS_TITLE: "Näyttöasetukset",
    SCREEN_SETTINGS_SUBTITLE: "Määritä näyttösi",
    SCREEN_ADD_SCREEN: "Luo näyttö",
    SCREEN_ADD_FIRST_SCREEN: "Luo ensimmäinen näyttösi",
    SCREEN_SCREEN_STATUS: "Näytön tila",
    SCREEN_EDIT_SCREEN: "Muokkaa näyttöä",
    SCREEN_SCREEN_NAME: "Näytön nimi",
    SCREEN_SELECT_COLLECTION: "Valitse diakokoelma",
    SCREEN_REMOVE_SCREEN: "Poista näyttö",
    SCREEN_REMOVE_SCREEN_HEADER: "Poista näyttö",
    SCREEN_REMOVE_SCREEN_WARN: "Haluatko varmasti poistaa tämän näytön?",
    SCREEN_SCREENS: "Näytöt",
    SCREEN_PUBLISH_ACTIVATED: "Näyttö \"{name}\" on aktivoitu.",
    SCREEN_PUBLISH_DEACTIVATED: "Näyttö \"{name}\" on poistettu käytöstä.",
    SCREEN_STATUS_UPDATE_ERROR: "Näytön tilaa ei voitu tallentaa. Yritä uudelleen.",
    SCREEN_SCHEDULES: "Aikataulut",
    SCREEN_SCHEDULE: "Aikataulu",
    SCREEN_ADD_SCHEDULE: "Lisää aikataulu",
    SCREEN_SCHEDULES_HINT: "Liitä diakokoelmat viikonpäiviin ja aikaväleihin. Soitin näyttää kokoelman, joka vastaa nykyistä aikaa.",
    SCREEN_SCHEDULE_DAYS: "Päivät",
    SCREEN_SCHEDULE_DAYS_PLACEHOLDER: "Valitse päivät",
    SCREEN_SCHEDULE_START: "Alkamisaika",
    SCREEN_SCHEDULE_END: "Päättymisaika",
    SCREEN_SCHEDULE_COUNT: "{count} aikataulua",
    SCREEN_SCHEDULE_REQUIRED: "Lisää vähintään yksi aikataulu.",
    SCREEN_SCHEDULE_COLLECTION_REQUIRED: "Valitse diakokoelma jokaiselle aikataululle.",
    SCREEN_SCHEDULE_DAYS_REQUIRED: "Valitse vähintään yksi päivä jokaiselle aikataululle.",
    SCREEN_SCHEDULE_INVALID_TIME: "Päättymisajan on oltava alkamisajan jälkeen jokaisessa aikataulussa.",
    COLLECTION_SETTINGS_TITLE: "Diakokoelmat",
    COLLECTION_SETTINGS_SUBTITLE: "Määritä diakokoelmasi",
    COLLECTION_COLLECTIONS: "Kokoelmat",
    COLLECTION_ADD_FIRST_COLLECTION: "Lisää ensimmäinen kokoelmasi",
    COLLECTION_CREATED: "Kokoelma luotu:",
    COLLECTION_CREATE_COLLECTION: "Luo kokoelma",
    COLLECTION_EDIT_COLLECTION: "Muokkaa kokoelmaa",
    COLLECTION_NAME: "Kokoelman nimi",
    SLIDE_COLLECTION: "Diakokoelma",
    SLIDE_CREATE_FIRST: "Aloita luomalla ensimmäinen dia",
    SLIDE_CREATE_SLIDE: "Luo dia",
    SLIDE_CREATE_SUBTITLE: "Lisää uusi dia infonäyttöön",
    SLIDE_DELETE_SLIDE: "Poista dia",
    SLIDE_DELETE_COLLECTION: "Poista kokoelma",
    SLIDE_DELAY_SECONDS: "Näyttöaika sekunteina",
    SLIDE_DELAY_HINT: "Kuinka kauan tätä diaa näytetään",
    SLIDE_DELAY_WARNING: "Näyttöajan on oltava vähintään 5 sekuntia",
    SLIDE_NAME: "Dian nimi",
    SLIDE_NAME_WARNING: "Nimi on pakollinen",
    SLIDE_IMAGE: "Dian kuva",
    SLIDE_IMAGE_ALT: "dian kuva",
    SLIDE_TYPE_SELECT: "Valitse dian tyyppi",
    SLIDE_ACTIVE_MENU: "Aktiivinen menu",
    SLIDE_IMAGE_TYPE: "Kuva",
    SLIDE_VIDEO_TYPE: "Video",
    SLIDE_VIDEO: "Dian video",
    SLIDE_VIDEO_FILE: "Videotiedosto",
    SLIDE_VIDEO_ALT: "dian video",
    SLIDE_FILE_UPLOADED: "Tiedosto ladattu",
    SLIDE_VIDEO_FORMATS_HINT: "Tuetut muodot: MP4. Enimmäiskoko: 50 MB.",
    SLIDE_VIDEO_DURATION_HINT: "Tunnistettu ladatusta videotiedostosta",
    SLIDE_DELAY_REQUIRED: "Dian näyttöaika on pakollinen",
    UPLOAD_VIDEO: "Lataa video",
    VIDEO_GALLERY: "Videogalleria",
    VIDEO_URL: "Videon URL",
    VIDEO_DURATION: "Kesto (sekuntia)",
    SLIDE_EDIT_SLIDE: "Muokkaa diaa",
    SLIDE_EDIT_SUBTITLE: "Päivitä tämä infonäytön dia",
    SLIDE_NAME_MINLENGTH: "Nimessä on oltava vähintään 3 merkkiä",
    SLIDE_DELAY_SECONDS_SUFFIX: "s",
    SIGNAGE_MIN_3_CHARACTERS: "Vähintään 3 merkkiä",
    SLIDE_CREATED: "Dia luotu",
    SLIDE_UPDATED: "Dia päivitetty",
    SLIDE_PUBLISHED: "Dia julkaistu",
    SLIDE_UNPUBLISHED: "Dian julkaisu peruttu",
    SLIDE_DELETED: "Dia poistettu",
    REMOVE_SLIDE_HEADER: "Poista dia",
    REMOVE_SLIDE_MESSAGE: "Haluatko varmasti poistaa dian?",
    REMOVE_SLIDE: "Poista dia",
    REMOVE_COLLECTION_HEADER: "Poista kokoelma",
    REMOVE_COLLECTION_MESSAGE: "Tämän kokoelman poistaminen voi vaikuttaa näyttöihin, jotka käyttävät sitä.",
    REMOVE_COLLECTION: "Poista kokoelma",
    COLLECTION_DELETED: "Kokoelma poistettu",
    COLLECTION_CREATED_SUCCESS: "Kokoelma luotu",
    COLLECTION_UPDATED_SUCCESS: "Kokoelma päivitetty",
    ACTIVE_MENU_SLIDE: "Aktiivisen menun dia",
    CUSTOM_MENU_SLIDE: "Mukautetun menun dia",
    IMAGE_SLIDE: "Kuvadia",
    VIDEO_SLIDE: "Videodia",
    VIDEO_TOO_LARGE: "Videotiedoston koko saa olla enintään 50 MB",
    VIDEO_TOO_LONG: "Videon kesto saa olla enintään 60 sekuntia",
    VIDEO_INVALID_FORMAT: "Vain MP4-tiedostot ovat tuettuja",
    VIDEO_PROBE_FAILED: "Videon metatietoja ei voitu lukea",
    VIDEO_UPLOAD_FAILED: "Videon lataus epäonnistui",
    SLIDE_CUSTOM_MENU: "Mukautettu",
    CUSTOM_MENU_DISPLAYS_TITLE: "Mukautettu menunäyttö",
    CUSTOM_MENU_DISPLAY_CREATE: "Luo menunäyttö",
    SELECT_CUSTOM_MENU: "Valitse mukautettu menunäyttö",
    NO_CUSTOM_MENU_DISPLAYS: "Mukautettuja menunäyttöjä ei löytynyt",
    CUSTOM_MENU_DISPLAY: "Mukautettu menunäyttö",
    CUSTOM_ACTION: "Hallitse",
    CONFIRM_DELETE_CUSTOM_MENU_MESSAGE: "Haluatko varmasti poistaa mukautetun menunäytön? Tämä voi vaikuttaa joihinkin dioihin",
    CONFIRM_DELETE_CUSTOM_MENU_HEADER: "Poista mukautettu menunäyttö",
    CUSTOM_MENU_SUBTITLE: "Hallitse mukautettuja infonäyttöjäsi",
    CUSTOM_MENU_TOTAL_DISPLAYS: "Näyttöjä yhteensä",
    CUSTOM_MENU_TOTAL_PRODUCTS: "Tuotteita yhteensä",
    CUSTOM_MENU_THEMED_DISPLAYS: "Teemoitetut näytöt",
    CUSTOM_MENU_THEME: "Teema",
    CUSTOM_MENU_PRODUCT: "tuote",
    CUSTOM_MENU_BACKGROUND_IMAGE: "Taustakuva",
    CUSTOM_MENU_LOGO: "Logo",
    CUSTOM_MENU_PRODUCT_IMAGES_ON: "Tuotekuvat käytössä",
    CUSTOM_MENU_EMPTY_DESCRIPTION: "Luo ensimmäinen mukautettu näyttö esitelläksesi valittuja tuotteita infonäytöilläsi.",
    CUSTOM_MENU_EDIT_DISPLAY: "Muokkaa näyttöä",
    CUSTOM_MENU_NEW_DISPLAY: "Uusi mukautettu näyttö",
    CUSTOM_MENU_OF_5_SELECTED: "/ 5 valittu",
    CUSTOM_MENU_NO_PRODUCTS_SELECTED: "Tuotteita ei ole vielä valittu.",
    CUSTOM_MENU_SWITCH_AVAILABLE_PRODUCTS: "Lisää tuotteita siirtymällä kohtaan Saatavilla olevat tuotteet.",
    CUSTOM_MENU_NO_SEARCH_MATCH: "Hakuasi vastaavia tuotteita ei löytynyt.",
    CUSTOM_MENU_FONT_COLOR: "Fontin väri",
    CUSTOM_MENU_SHOW_PRODUCT_IMAGES: "Näytä tuotekuvat",
    CUSTOM_MENU_DISPLAY_THUMBNAILS: "Näytä pikkukuvat infonäytöllä",
    CUSTOM_MENU_SELECT_LOGO: "Valitse logo galleriasta",
    CUSTOM_MENU_LOGO_SELECTED: "Logo valittu",
    CUSTOM_MENU_SELECT_BACKGROUND: "Valitse tausta galleriasta",
    CUSTOM_MENU_BACKGROUND_SELECTED: "Tausta valittu",
    CUSTOM_MENU_THEME_SAVE_NOTE: "Teeman muutokset päivittyvät infonäytöille heti tallennuksen jälkeen.",
    CUSTOM_MENU_DISPLAY_SAVE_SUCCESS: "\"{name}\" tallennettiin.",
    CUSTOM_MENU_DISPLAY_SAVE_ERROR: "Mukautettua näyttöä ei voitu tallentaa. Yritä uudelleen.",
    CATERING_PICKUP_AVAILABILITY_DESC: "Määritä, mitä päiviä ja aikavälejä asiakkaat voivat valita noudolle. Ota kukin päivä käyttöön tai pois käytöstä ja lisää tarkat aikaikkunat.",
    CATERING_PICKUP_AVAILABILITY: "Noudon saatavuus",
    CATERING_SLOTS: "Aikavälit",
    CATERING_DISABLED: "Pois käytöstä",
    CATERING_START_TIME: "Alkamisaika",
    CATERING_END_TIME: "Päättymisaika",
    CATERING_DELIVERY_TIME: "Toimitusaika",
    CATERING_ADD_TIME_SLOT: "Lisää aikaväli",
    CATERING_PRODUCTION_DAYS_HEADER: "Tuotantopäivät",
    CATERING_PRODUCTION_DAYS_DESCRIPTION: "Määritä, mitkä viikonpäivät lasketaan tuotantopäiviksi, kun aikaisinta noutopäivää lasketaan. Muut kuin tuotantopäivät ohitetaan toimitusajan laskennassa.",
    CATERING_PRODUCTION_DAYS_LABEL: "Tuotantopäiviksi laskettavat päivät",
    DAYS_MONDAY: "Maanantai",
    DAYS_TUESDAY: "Tiistai",
    DAYS_WEDNESDAY: "Keskiviikko",
    DAYS_THURSDAY: "Torstai",
    DAYS_FRIDAY: "Perjantai",
    DAYS_SATURDAY: "Lauantai",
    DAYS_SUNDAY: "Sunnuntai",
    CONFIRMATION_REQUIRED: "Vahvistus vaaditaan",
    DO_YOU_WANT_TO_PROCEED: "Haluatko jatkaa?",
    REMOVING_LAST_TIMESLOT: "Viimeisen aikavälin poistaminen poistaa käytöstä",
    NO_DAYS_AVAILABLE: "Noudolle ei ole saatavilla päiviä",
    CREATE_CAMPAIGN_MENU_TITLE: "Luo kampanjamenu",
    EVENT_SETTINGS: "Tapahtuma-asetukset",
    CREATE_EVENT_MENU: "Luo tapahtumamenu",
    UPLOAD_HERO_IMAGE: "Lataa pääkuva",
    CAMPAIGN_BUTTON_TEXT: "Kampanjapainikkeen teksti",
    CAMPAIGN_BUTTON_PLACEHOLDER: "Kirjoita kampanjapainikkeen teksti",
    CAMPAIGN_MENU_LIST: "Kampanjamenut",
    VIEW_CAMPAIGN_MENUS: "Tarkastele ja hallitse kaikkia kampanjamenujasi",
    STARTS: "Alkaa",
    ENDS: "Päättyy",
    SAVE_CHANGES: "Tallenna muutokset",
    EVENT: "Tapahtuma",
    ACTIVATE_EVENT_MENU: "Aktivoi tapahtumamenu",
    ACTIVATE_EVENT_MENU_WARNING_MESSAGE: "Kaikki kampanjamenut poistetaan käytöstä, kun tapahtumamenu aktivoidaan. Sinun on vahvistettava tämä toiminto jatkaaksesi.",
    CONTINUE: "Ymmärrän, jatka",
    NO_REGULAR_MENU_WARNING: "Aktivoi tavallinen menu ennen kuin jatkat",
    MENU_ACTIVATION_REQUIRES_CATEGORY_WITH_PRODUCT: "Menussa on oltava vähintään yksi kategoria, jossa on vähintään yksi tuote, ennen kuin sen voi aktivoida.",
    EVENT_MENU_WARNING: "Poista tapahtumamenu käytöstä ja aktivoi ensin tavallinen menu",
    DEACTIVATE_MENU_WARNING_MESSAGE: "Tämän menun poistaminen käytöstä poistaa käytöstä myös tällä hetkellä aktiivisen kampanjamenun. Haluatko jatkaa?",
    DELETE_MENU_WARNING_MESSAGE: "Tämän menun poistaminen poistaa käytöstä myös tällä hetkellä aktiivisen kampanjamenun. Haluatko jatkaa?",
    HERO_IMAGE_TEXT: "Pääkuvan teksti",
    HERO_IMAGE_TEXT_PLACEHOLDER: "Lisää teksti, joka näytetään kampanjan pääkuvassa",
    EVENT_MENU_FIXED_DATE_WARNING: "Tapahtumamenuilla tulee olla kiinteät päivämäärät",
    CATERING_COMMUNICATION_TAB: "Viestintä",
    CATERING_THEME_TAB: "Teema",
    CATERING_ALERT_BANNER_HEADER: "Cateringin ilmoitusbanneri",
    CATERING_ALERT_BANNER_DESCRIPTION: "Lisää viesti, jolla kerrot asiakkaille ajankohtaisista ongelmista tai häiriöistä. Kun banneri on aktivoitu, teksti näkyy ilmoitusbannerina verkkosovelluksessa.",
    CATERING_ALERT_BANNER_TEXT_HEADER: "Ilmoitusbannerin teksti",
    CATERING_ALERT_BANNER_TEXT_COLOR: "Bannerin tekstin väri",
    CATERING_ALERT_BANNER_TEXT_COLOR_PLACEHOLDER: "esim. #000000 tai #FFFFFF",
    CATERING_ALERT_BANNER_BACKGROUND_COLOR: "Bannerin taustaväri",
    CATERING_ALERT_BANNER_BACKGROUND_COLOR_PLACEHOLDER: "esim. #FFF3CD tai #FFFFFF",
    CATERING_ALERT_BANNER_TEXT_PLACEHOLDER: "Kirjoita ilmoitusbannerin viesti",
    CATERING_ALERT_BANNER_TEXT_MAX_LENGTH: "Ilmoitusbannerin merkkien enimmäismäärä saavutettu.",
    CATERING_HERO_IMAGE_AND_LOGO_HEADER: "Pääkuva ja logo",
    CATERING_HERO_IMAGE_AND_LOGO_DESCRIPTION: "Määritä pääkuva ja logo.",
    CATERING_BUTTON_COLORS_HEADER: "Painikkeiden värit",
    CATERING_BUTTON_COLORS_DESCRIPTION: "Mukauta Catering-verkkosovelluksessa käytettävää painikkeen pääväriä ja painikkeen tekstin väriä.",
    CATERING_BUTTON_PRIMARY_COLOR: "Painikkeen pääväri",
    CATERING_BUTTON_TEXT_COLOR: "Painikkeen tekstin väri",
    CATERING_FONTS_HEADER: "Teeman fontit",
    CATERING_FONTS_DESCRIPTION: "Määritä otsikko- ja leipätekstin fontit.",
    CATERING_TITLE_FONT_LABEL: "Otsikkofontti",
    CATERING_BODY_FONT_LABEL: "Leipätekstin fontti",
    CATERING_THEME_LOGO_HEADER: "Logo",
    CATERING_THEME_HERO_IMAGE_HEADER: "Pääkuva",
    CATERING_THEME_PREVIEW_HEADER: "Esikatselu",
    CATERING_THEME_PREVIEW_BTN_SOLID: "Painike",
    CATERING_THEME_PREVIEW_BTN_OUTLINED: "Ääriviiva",
    CATERING_THEME_PREVIEW_BTN_TEXT: "Teksti",
    CATERING_THEME_REPLACE: "Korvaa",
    CATERING_HERO_IMAGE_HEADER: "Pääkuvan teksti",
    CATERING_HERO_IMAGE_DESCRIPTION: "Määritä pääkuvan teksti",
    CATERING_HERO_IMAGE_TITLE_HEADER: "Otsikko",
    CATERING_HERO_IMAGE_TITLE_PLACEHOLDER: "Kirjoita pääkuvan otsikko",
    CATERING_HERO_IMAGE_TITLE_MAX_LENGTH: "Pääkuvan otsikon merkkien enimmäismäärä saavutettu.",
    CATERING_HERO_IMAGE_BODY_HEADER: "Leipäteksti",
    CATERING_HERO_IMAGE_BODY_PLACEHOLDER: "Kirjoita pääkuvan kuvaus",
    CATERING_HERO_IMAGE_BODY_MAX_LENGTH: "Pääkuvan kuvauksen merkkien enimmäismäärä saavutettu.",
    CATERING_HERO_IMAGE_TEXT_CONFIGURATION_SAVED: "Pääkuvan tekstiasetukset tallennettu.",
    CATERING_HERO_IMAGE_TEXT_CONFIGURATION_SAVE_ERROR: "Pääkuvan tekstiasetusten tallennus epäonnistui. Yritä uudelleen.",
    CATERING_HERO_IMAGE_TITLE_REQUIRED: "Pääkuvan otsikko on pakollinen.",
    CATERING_HERO_IMAGE_BODY_REQUIRED: "Pääkuvan kuvaus on pakollinen.",
    CATERING_ALERT_BANNER_TEXT_REQUIRED: "Ilmoitusbannerin viesti on pakollinen.",
    CATERING_ALERT_BANNER_SWITCH_MESSAGE: "Kirjoita ilmoitusbannerin viesti ennen bannerin aktivointia.",
    SETTINGS_UPDATED: "Asetukset päivitetty.",
    SETTINGS_COULDNT_UPDATE: "Jokin meni vikaan. Asetuksia ei voitu päivittää.",
    CATERING_CUTOFF_TIME_UPDATED: "Tilausten takaraja päivitetty",
    CATERING_CUTOFF_TIME_COULDNT_UPDATE: "Jokin meni vikaan. Takarajaa ei voitu päivittää.",
    ORDER_CUTOFF_CONFIGURATION: "Tilausten takarajan asetukset",
    ORDER_CUTOFF_DESCRIPTION: "Aseta viimeisin kellonaika, johon mennessä tehty tilaus lasketaan saman päivän tilaukseksi ensimmäisen tuotantopäivän osalta",
    SELECT_TIME: "Valitse aika",
    ADJUST_CUTOFF_TIME: "Säädä takarajaa",
    ALLERGEN_DESCRIPTION: "Allergeenikuvaus",
    ENTER_ALLERGEN_DESCRIPTION: "Kirjoita allergeenikuvaus",
    NO_ACTIVE_CAMPAIGN_MENU: "Ei aktiivista kampanjamenua",
    CAMPAIGN_MENU_STATUS: "Kampanjamenun tila",
    AUTO_APPROVE_ORDERS_HEADER: "Hyväksy tilaukset automaattisesti",
    AUTO_APPROVE_ORDERS_DESCRIPTION: "Hyväksy saapuvat catering-tilaukset automaattisesti ilman manuaalista tarkistusta.",
    SHOW_MANDATORY_POPUP_FOR_DATE_HEADER: "Pakollinen päivämäärän valintaikkuna",
    SHOW_MANDATORY_POPUP_FOR_DATE_DESCRIPTION: "Näytä catering-verkkosovelluksessa ponnahdusikkuna, jossa asiakkaan on valittava päivämäärä ennen menun selaamista.",
    NOTIFICATION_EMAILS_HEADER: "Tilausilmoitusten sähköpostit",
    NOTIFICATION_EMAILS_DESCRIPTION: "Lisää sähköpostiosoitteet, joihin lähetetään ilmoitukset uusista catering-tilauksista. Voit lisätä useita osoitteita.",
    NOTIFICATION_EMAIL_LANGUAGE: "Ilmoitussähköpostien kieli",
    ADD_EMAIL: "Lisää sähköposti",
    ENTER_EMAIL_ADDRESS: "Kirjoita sähköpostiosoite",
    ADDED_EMAILS: "Lisätyt sähköpostit",
    NO_EMAILS_ADDED: "Sähköpostiosoitteita ei ole lisätty",
    INVALID_EMAIL_FORMAT: "Virheellinen sähköpostiosoite",
    EMAIL_ALREADY_EXISTS: "Sähköpostiosoite on jo lisätty",
    CATERING_MENU_PREFERENCE_HEADER: "Tuotteen menutyyppi",
    CATERING_MENU_PREFERENCE_DESCRIPTION: "Valitse, missä menutyypissä tuote näytetään, jos se on sekä tavallisessa menussa että kampanjamenussa. Kun tuote on lisätty kumpaankin menutyyppiin, se näkyy vain tässä asetuksessa valitussa menutyypissä.",
    IMPORTANT: "Tärkeää",
    MENU_PREFERENCE_NOTE: "Tuote voi kuulua vain yhteen menutyyppiin. Jos se on sekä kampanja- että tavallisessa menussa, se näytetään valitsemasi menuasetuksen mukaisesti.",
    CATERING_SELECT_MENU_TYPE: "Valitse menutyyppi",
    CATERING_MENU_PREFERENCE_NOTE: "Jos tuote on lisätty molempiin menutyyppeihin, se näytetään vain ensisijaisessa menutyypissä.",
    CATERING_CAMPAIGN_MENU: "Kampanja",
    CATERING_REGULAR_MENU: "Tavallinen",
    COMMENT_FIELD_ON_ORDER: "Tilauksen kommenttikenttä",
    COMMENT_FIELD_DESCRIPTION: "Ota tilausvaiheen kommenttikenttä käyttöön tai pois käytöstä.",
    CATERING_ADDONS_SUBTITLE: "Hallitse catering-lisäkeryhmiä ja niiden vaihtoehtoja",
    CATERING_ADDON_CREATE_GROUP: "Luo lisäkeryhmä",
    CATERING_ADDON_SEARCH_GROUPS: "Hae lisäkeryhmiä...",
    CATERING_ADDON_AVAILABILITY: "Saatavuus",
    CATERING_ADDON_OPTIONS_LABEL: "Vaihtoehdot",
    CATERING_ADDON_OPTION_SINGULAR: "vaihtoehto",
    CATERING_ADDON_OPTION_PLURAL: "vaihtoehtoa",
    CATERING_ADDON_PRODUCT_SINGULAR: "tuote",
    CATERING_ADDON_PRODUCT_PLURAL: "tuotetta",
    CATERING_ADDON_LOADING: "Ladataan…",
    CATERING_ADDON_NO_GROUPS: "Lisäkeryhmiä ei löytynyt",
    CATERING_ADDON_NO_GROUPS_HINT: "Aloita luomalla ensimmäinen lisäkeryhmä",
    CATERING_ADDON_LOAD_ERROR: "Lisäkeryhmien lataus epäonnistui.",
    CATERING_ADDON_SAVED: "Tallennettu",
    CATERING_ADDON_UPDATED: "Lisäkeryhmä päivitetty.",
    CATERING_ADDON_CREATED: "Lisäkeryhmä luotu.",
    CATERING_ADDON_SAVE_FAILED: "Tallennus epäonnistui",
    CATERING_ADDON_UPDATE_ERROR: "Lisäkeryhmää ei voitu päivittää. Yritä uudelleen.",
    CATERING_ADDON_CREATE_ERROR: "Lisäkeryhmää ei voitu luoda. Yritä uudelleen.",
    CATERING_ADDON_DELETE_FAILED: "Poisto epäonnistui",
    CATERING_ADDON_DELETE_ERROR: "Lisäkeryhmää ei voitu poistaa. Yritä uudelleen.",
    CATERING_ADDON_TYPE_SINGLE: "Yksi valinta",
    CATERING_ADDON_TYPE_MULTIPLE: "Monivalinta",
    CATERING_ADDON_EDIT_GROUP: "Muokkaa lisäkeryhmää",
    CATERING_ADDON_NEW_GROUP: "Uusi lisäkeryhmä",
    CATERING_ADDON_EDIT_SUBTITLE: "Päivitä tämän lisäkeryhmän tiedot",
    CATERING_ADDON_NEW_SUBTITLE: "Täytä tiedot luodaksesi uuden lisäkeryhmän",
    CATERING_ADDON_STEP_ADD_OPTIONS: "Lisää vaihtoehdot",
    CATERING_ADDON_NAME_PLACEHOLDER: "esim. Valitse kastike",
    CATERING_ADDON_DESCRIPTION_PLACEHOLDER: "Asiakkaalle näytettävä lyhyt kuvaus",
    CATERING_ADDON_TYPE_LABEL: "Lisäkkeen tyyppi",
    CATERING_ADDON_TYPE_SINGLE_DESC: "Asiakas valitsee tasan yhden vaihtoehdon",
    CATERING_ADDON_TYPE_MULTIPLE_DESC: "Asiakas valitsee yhden tai useamman vaihtoehdon",
    CATERING_ADDON_DELIVERY_METHOD_AVAILABILITY: "Saatavuus toimitustavan mukaan",
    CATERING_ADDON_PICKUP_HINT: "Näytä noutotilauksissa",
    CATERING_ADDON_DELIVERY_HINT: "Näytä kotiinkuljetustilauksissa",
    CATERING_ADDON_ADD_PRODUCT: "Lisää tuote",
    CATERING_ADDON_SEARCH_PRODUCT_PLACEHOLDER: "Hae tuotetta…",
    CATERING_ADDON_ADD: "Lisää",
    CATERING_ADDON_NOT_FOUND: "Ei löytynyt",
    CATERING_ADDON_REMOVE: "Poista",
    CATERING_ADDON_NO_PRODUCTS_LINKED: "Tähän ryhmään ei ole vielä linkitetty tuotteita.",
    CATERING_ADDON_LINKS_APPLIED_ON_SAVE: "Tuotelinkitykset otetaan käyttöön tallennettaessa.",
    CATERING_ADDON_SELECTION_RULES: "Valintasäännöt",
    CATERING_ADDON_PRESELECT: "Esivalinta",
    CATERING_ADDON_PRESELECT_HINT: "Oletusvaihtoehto, kun asiakas avaa tämän ryhmän.",
    CATERING_ADDON_PRESELECTED_OPTION: "Esivalittu vaihtoehto",
    CATERING_ADDON_CHOOSE_OPTION: "Valitse vaihtoehto",
    CATERING_ADDON_MIN_SELECTED: "Vähintään valittava",
    CATERING_ADDON_MIN_SELECTED_HINT: "Vaihtoehtojen vähimmäismäärä, joka asiakkaan on valittava.",
    CATERING_ADDON_MAX_SELECTED: "Enintään valittava",
    CATERING_ADDON_NO_LIMIT: "Ei rajaa",
    CATERING_ADDON_MAX_SELECTED_HINT: "Jätä tyhjäksi, jos ylärajaa ei ole.",
    CATERING_ADDON_OPTIONS_REQUIRED: "Lisäkkeen vaihtoehdot",
    CATERING_ADDON_DRAG_REORDER: "Järjestä vetämällä",
    CATERING_ADDON_OPTION_NAME: "Vaihtoehdon nimi",
    CATERING_ADDON_OPTION_NAME_PLACEHOLDER: "esim. Valkosipulimajoneesi",
    CATERING_ADDON_LINK: "Linkitä",
    CATERING_ADDON_REMOVE_LINK: "Poista linkitys",
    CATERING_ADDON_DELETE_OPTION: "Poista vaihtoehto",
    CATERING_ADDON_NO_OPTIONS_YET: "Vaihtoehtoja ei vielä ole. Aloita napsauttamalla \"Lisää vaihtoehto\".",
    CATERING_ADDON_PRESELECT_NONE: "Ei mitään",
    CATERING_ADDON_PRESELECT_FIRST: "Ensimmäinen vaihtoehto",
    CATERING_ADDON_PRESELECT_SPECIFIC: "Tietty vaihtoehto",
    CATERING_ADDON_ERR_FIRST_OPTION: "Lisää vähintään yksi vaihtoehto ennen kuin käytät valintaa \"Ensimmäinen vaihtoehto\".",
    CATERING_ADDON_ERR_CHOOSE_PRESELECT: "Valitse esivalittava vaihtoehto.",
    CATERING_ADDON_ERR_PRESELECT_INVALID: "Esivalitun vaihtoehdon on oltava jokin alla olevista vaihtoehdoista.",
    CATERING_ADDON_ERR_MIN_ZERO: "Vähintään valittavan määrän on oltava 0 tai suurempi.",
    CATERING_ADDON_ERR_MAX_ZERO: "Enintään valittavan määrän on oltava 0 tai suurempi, tai kenttä on jätettävä tyhjäksi.",
    CATERING_ADDON_ERR_MAX_LESS_MIN: "Enintään valittava määrä ei voi olla pienempi kuin vähintään valittava määrä.",
    CATERING_PRODUCT_LOADING_ADDONS: "Ladataan...",
    CATERING_PRODUCT_NO_ADDON_GROUPS_AVAILABLE: "Lisäkeryhmiä ei ole saatavilla",
    CATERING_PRODUCT_HIDE_OPTIONS: "Piilota vaihtoehdot",
    CATERING_PRODUCT_NO_OPTIONS_IN_GROUP: "Tässä ryhmässä ei ole vaihtoehtoja.",
    CATERING_PRODUCT_NO_ADDON_GROUPS_LINKED: "Lisäkeryhmiä ei ole linkitetty.",
    CATERING_PRODUCT_SET_SELLING_PRICE_HINT: "Aseta tämän tuotteen myyntihinta",
    CATERING_PRODUCT_SELECT_TAB: "Valitse välilehti.",
    CATERING_PRODUCT_PREVIEW: "Tuotteen esikatselu",
    CATERING_PRODUCT_NO_IMAGE: "Ei kuvaa",
    CATERING_PRODUCT_UNTITLED: "Nimetön tuote",
    CATERING_PRODUCT_NO_CATEGORY_SELECTED: "Kategoriaa ei ole valittu",
    CATERING_PRODUCT_NO_SHORT_DESCRIPTION: "Lyhyttä kuvausta ei ole annettu.",
    CATERING_PRODUCT_NO_LONG_DESCRIPTION: "Pitkää kuvausta ei ole annettu.",
    CATERING_PRODUCT_MIN_LEAD_DAYS_LABEL: "Vähimmäistoimitusaika (pv)",
    CATERING_PRODUCT_MODIFIED_AT: "Muokattu:",
    CATERING_PRODUCT_ID_LABEL: "Tuotetunnus:",
    CATERING_PRODUCT_ERR_MIN_EXCEEDS_MAX: "Vähimmäistilausmäärä ei voi ylittää enimmäistilausmäärää",
    CATERING_PRODUCT_ERR_STOCK_LT_MAX: "Varastosaldo ei voi olla pienempi kuin enimmäistilausmäärä",
    CATERING_PRODUCT_ERR_STOCK_LT_MIN: "Varastosaldo ei voi olla pienempi kuin vähimmäistilausmäärä",
    CATERING_PRODUCT_DAYS_SUFFIX: "päivää",
    CATERING_ORDER_UPDATE_DATE_TIME: "Päivitä päivämäärä ja aika",
    CATERING_ORDER_CUSTOMER_EMAIL_UNAVAILABLE: "Asiakkaan sähköpostiosoite ei ole saatavilla",
    CATERING_ORDER_SELECT_DATE_RANGE: "Valitse aikaväli",
    CATERING_ORDER_SELECT_VALID_DATE_RANGE: "Valitse kelvollinen aikaväli",
    CATERING_ORDER_NO_APPROVED_ORDERS: "Valittuja ehtoja vastaavia hyväksyttyjä tilauksia ei löytynyt",
    CATERING_ORDER_NO_APPROVED_IN_RANGE: "Valitulta aikaväliltä ei löytynyt hyväksyttyjä tilauksia",
    CATERING_ORDER_SELECT_DATE_AND_TIME: "Valitse päivämäärä ja aika",
    CATERING_ORDER_DATE_CANNOT_BE_PAST: "Päivämäärä ei voi olla menneisyydessä",
    CATERING_ORDER_EXPORT_PDF_SUCCESS: "Tilaukset viety PDF-tiedostoon",
    CATERING_ORDER_EXPORT_LOAD_FAILED: "Tilausten lataus vientiä varten epäonnistui",
    CATERING_ORDER_EXPORT_FAILED: "Tilausten vienti epäonnistui",
    CATERING_ORDER_PRINT_LOAD_FAILED: "Tilausten lataus tulostusta varten epäonnistui",
    CATERING_ORDER_PRINT_FAILED: "Tilausten tulostus epäonnistui",
    CATERING_ORDER_PRODUCTION_LOAD_FAILED: "Tilausten lataus tuotantotehtäviä varten epäonnistui",
    CATERING_ORDER_PRODUCTION_EXPORT_FAILED: "Tuotantotehtävien vienti epäonnistui",
    KDS_TITLE: "KDS",
    KDS_ORDERS_TITLE: "Keittiön tilaukset",
    KDS_ORDERS_DESC: "Seuraa paikan päällä syötäviä, noutoruoka- ja kotiinkuljetustilauksia niiden edetessä keittiössä",
    PENDING_TAG: "Odottaa",
    INPROGRESS_TAG: "Työn alla",
    COMPLETED_TAG: "Valmis",
    ORDER_STATUS_PLACEHOLDER: "Tilauksia ei ole valittu",
    ORDER_TYPE_PLACEHOLDER: "Kaikki tyypit",
    ORDER_SEARCH_PLACEHOLDER: "Hae...",
    TABLE_COLUMNS_PLACEHOLDER: "Valitse sarakkeet",
    ORDER_NUMBER_HEADER: "Tilausnumero",
    ORDER_CREATED_DATETIME_HEADER: "Luontipäivä/-aika",
    STATUS_HEADER: "Tila",
    ORDER: "Tilaus",
    REQUEST_REFUND_BTN: "Pyydä hyvitystä",
    REJECT_ORDER_BTN: "Hylkää tilaus",
    PRINT_BTN: "Tulosta",
    SET_COMPLETION_TIME: "Aseta valmistumisaika:",
    MINUTES_ABBR: "min",
    CUSTOM: "Mukautettu",
    ORDER_INFORMATION_HEADER: "Tilauksen tiedot",
    ORDER_DATE_LABEL: "Tilauspäivä:",
    ORDER_TIME_LABEL: "Tilausaika:",
    ORDER_METHOD_LABEL: "Tapa:",
    DELIVERY_METHOD_D: "Kotiinkuljetus",
    DELIVERY_METHOD_FD: "Kiinteä toimitus",
    EATIN_METHOD: "Syödään paikan päällä",
    TABLE_SERVING_METHOD: "Pöytiintarjoilu",
    TAKEAWAY_METHOD: "Noutoruoka",
    TAKEAWAY_FOOD: "Ruoka mukaan",
    TAKEAWAY_DRINKS: "Juomat mukaan",
    PRINT_ORDERS_DIALOG_HEADER: "Tulosta tilaukset",
    FILTER_BY_STATUS_LABEL: "Suodata tilan mukaan:",
    SELECT_STATUS_PLACEHOLDER: "Valitse tila",
    SELECT_PRINT_ORDERS_LABEL: "Valitse tulostettavat tilaukset:",
    SELECTED_ORDERS_LABEL: "{0} tilausta valittu",
    CHOOSE_ORDERS_PLACEHOLDER: "Valitse tilaukset",
    NO_ORDERS_WITH_STATUS: "Tilauksia ei löytynyt tilalla",
    CANCEL_BTN: "Peruuta",
    PRINT_SELECTED_BTN: "Tulosta valitut",
    RECEIPT_NUMBER_HEADER: "Kuittinumero",
    ORDER_USER_NAME_HEADER: "Nimi",
    ORDER_TYPE_HEADER: "Tilaustyyppi",
    EMAIL_HEADER: "Sähköposti",
    DELIVERY_LOCATION_HEADER: "Toimituspaikka",
    PHONE_NUMBER_HEADER: "Puhelinnumero",
    PAYMENT_METHOD_HEADER: "Maksutapa",
    DELIVERY_ADDRESS_LABEL: "Toimitusosoite:",
    DELIVERY_LOCATION_LABEL: "Toimituspaikka:",
    TABLE_LABEL: "Pöytä:",
    RESERVATION_LABEL: "Varaus:",
    SCHEDULED_TIME_LABEL: "Ajastettu aika:",
    DISCOUNT_CODE_LABEL: "Alennuskoodi",
    OFF: "alennus",
    CUSTOMER_NOTE_LABEL: "Asiakkaan viesti:",
    DELIVERY_INSTRUCTIONS_LABEL: "Toimitusohjeet:",
    PRODUCTS_HEADER: "Tuotteet",
    FOOD_HEADER: "Ruoka",
    DRINKS_HEADER: "Juomat",
    UNKNOWN_PRODUCT: "Tuntematon tuote",
    QUANTITY_LABEL: "Määrä",
    ITEM_COMMENT_LABEL: "Tuotteen kommentti",
    NO_ITEMS: "Ei tuotteita",
    TOTAL_HEADER: "Yhteensä:",
    CUSTOMER_INFO_HEADER: "Asiakastiedot",
    FULL_NAME_LABEL: "Koko nimi:",
    EMAIL_LABEL: "Sähköposti:",
    PHONE_LABEL: "Puhelin:",
    ADDRESS_LABEL: "Osoite:",
    PAYMENT_INFO_HEADER: "Maksutiedot",
    DETAILS_LABEL: "Tiedot:",
    DELIVERY_FEE_LABEL: "Toimitusmaksu",
    DISCOUNT_LABEL: "Alennus",
    COUPON_DISCOUNT_LABEL: "Kuponkialennus",
    BONUS_VOUCHER_LABEL: "Bonusseteli",
    TOTAL_LABEL: "Yhteensä",
    COMPLETE_SELECTED_ITEMS: "Merkitse valitut tuotteet valmiiksi",
    SET_ORDER_COMPLETED_HEADER: "Merkitse tilaus valmiiksi",
    SET_ORDER_COMPLETED_MESSAGE: "Haluatko varmasti merkitä koko tilauksen valmiiksi? Toimintoa ei voi kumota.",
    TIMER_STARTED_HEADER: "Ajastin käynnistetty",
    REJECT_ORDER_CONFIRM_MESSAGE: "Haluatko varmasti hylätä tämän tilauksen? Toimintoa ei voi kumota.",
    REJECT_ORDER_HEADER: "Hylkää tilaus",
    REJECTED_ORDER_SUMMARY: "Tilaus hylätty",
    REJECTED_ORDER_DETAIL: "Tilaus on hylätty.",
    REJECT_ORDER_ERROR_SUMMARY: "Virhe",
    REJECT_ORDER_ERROR_DETAIL: "Tilauksen hylkääminen epäonnistui.",
    REQUEST_REFUND_CONFIRM_MESSAGE: "Haluatko varmasti pyytää hyvitystä? Toimintoa ei voi perua.",
    REQUEST_REFUND_HEADER: "Pyydä hyvitystä",
    REFUND_REQUESTED_SUMMARY: "Hyvitystä pyydetty",
    REFUND_REQUESTED_DETAIL: "Hyvitystä on pyydetty.",
    REQUEST_REFUND_ERROR_SUMMARY: "Virhe",
    REQUEST_REFUND_ERROR_DETAIL: "Hyvityksen pyytäminen epäonnistui.",
    ORDER_STATUS_UPDATED: "Tilauksen tila päivitetty",
    FOOD_ITEM_COMPLETED_HEADER: "Ruoka valmis",
    DRINK_ITEM_COMPLETED_HEADER: "Juoma valmis",
    ITEMS_COMPLETED_HEADER: "Tuotteet valmiit",
    NO_ORDERS: "Tilauksia ei löytynyt",
    GENERAL_ERROR: "jokin meni vikaan, yritä myöhemmin uudelleen",
    COMMENT_ENABLED: "Kommentti käytössä",
    OVERLAPPING_TIME_SLOT: "Menee päällekkäin olemassa olevan aikavälin kanssa",
    DUPLICATE_DELIVERY_TIME: "Toimitusaika on jo olemassa",
    END_TIME_BEFORE_START_TIME: "Päättymisajan on oltava alkamisajan jälkeen",
    PASSWORD_MANAGEMENT: "Salasanan hallinta",
    SEND_PASSWORD_RESET_LINK: "Lähetä salasanan palautuslinkki",
    PASSWORD_RESET_DESCRIPTION: "Lähetä suojattu salasanan palautuslinkki käyttäjän sähköpostiosoitteeseen.",
    SEND_RESET_LINK: "Lähetä palautuslinkki",
    SET_NEW_PASSWORD: "Aseta uusi salasana",
    SET_PASSWORD_DESCRIPTION: "Aseta käyttäjälle suoraan uusi salasana. Käyttäjä kirjataan ulos välittömästi.",
    NEW_PASSWORD: "Uusi salasana",
    UPDATE_PASSWORD: "Päivitä salasana",
    PASSWORD_MIN_LENGTH: "Salasanan on oltava vähintään 6 merkkiä pitkä",
    FILTER_ALL_WARING: "Suodata tilaukset, joilla on sama tila",
    SELECT_ORDER_WARING: "Voit valita vain tilauksia, joilla on sama tila",
    SUCCESSFULLY_UPDATED_DATE_TIME: "Päivämäärä ja aika päivitetty",
    FAILED_TO_UPDATE_DATE_TIME: "Päivämäärän ja ajan päivitys epäonnistui",
    KIOSK_INFORMATION: "Kioskin sijainnit",
    ORDER_LIST_APP_HINT: "Määritä näyttöjärjestys sovelluksessa vetämällä. Ota käyttöön valitsemalla yllä Tallenna.",
    ORDER_LIST_KIOSK_HINT: "Määritä kioskin sijaintien näyttöjärjestys vetämällä. Ota käyttöön valitsemalla yllä Tallenna.",
    CORPORATE_CUSTOMERS: "Yritysasiakkaat",
    INVOICE_MENU: "Lasku",
    INVOICES: "Laskut",
    INVOICE_LIST_SUBTITLE: "POS- ja catering-tilausten laskut, jotka odottavat manuaalista välittämistä kirjanpitoon.",
    INVOICE_LIST_SEARCH: "Hae yritystä, Y-tunnusta tai laskua…",
    INVOICE_LIST_EMPTY: "Ei vielä laskuja",
    INVOICE_LIST_EMPTY_DESCRIPTION: "POS-laskumaksujen ja valmiiden laskulla maksettujen catering-tilausten laskut näkyvät täällä. Kokeile muuttaa aikaväliä tai suodattimia.",
    INVOICE_LIST_LOAD_FAILED: "Laskujen lataaminen epäonnistui",
    INVOICE_LIST_DATE_RANGE: "Valitse aikaväli",
    INVOICE_LIST_TEXT_SEARCH_HINT: "Haku kohdistuu yritykseen, Y-tunnukseen, laskunumeroon, kuittinumeroon ja catering-tilausnumeroon valitulla aikavälillä (enintään 100 viimeisintä laskua).",
    INVOICE_SOURCE: "Lähde",
    INVOICE_SOURCE_ALL: "Kaikki lähteet",
    INVOICE_SOURCE_POS: "POS",
    INVOICE_SOURCE_CATERING: "Catering",
    INVOICE_CATERING_ORDER: "Catering-tilaus",
    INVOICE_OPEN_CATERING_ORDERS: "Avaa Catering → Tilaukset",
    INVOICE_LIST_PREVIOUS: "Edellinen",
    INVOICE_LIST_NEXT: "Seuraava",
    INVOICE_LIST_PAGE: "Sivu",
    INVOICE_STATUS_CREATED: "Luotu",
    INVOICE_STATUS_SENT: "Lähetetty",
    INVOICE_MARK_SENT: "Merkitse lähetetyksi",
    INVOICE_MARKED_SENT: "Lasku merkitty lähetetyksi",
    INVOICE_MARK_SENT_FAILED: "Laskun tilaa ei voitu päivittää",
    INVOICE_PDF_FAILED: "Laskun PDF-tiedostoa ei voitu luoda",
    OPEN_INVOICE: "Avaa lasku",
    INVOICE_DOWNLOAD_SELECTED: "Lataa valitut",
    INVOICE_LOADING_DETAILS: "Ladataan laskun tietoja...",
    INVOICE_TITLE: "Lasku",
    INVOICE_BILL_FROM: "Laskuttaja",
    INVOICE_BILL_TO: "Laskun saaja",
    INVOICE_ISSUED_ON: "Laskun päivämäärä",
    INVOICE_DETAIL: "Laskun tiedot",
    INVOICE_GRAND_TOTAL: "Loppusumma",
    INVOICE_RECEIPT_LINES_UNAVAILABLE: "Kuitin rivitietoja ei ole saatavilla.",
    INVOICE_RECEIPT_DATA_UNAVAILABLE: "Kuitin tietoja ei saatavilla",
    INVOICE_NOT_AVAILABLE: "Ei saatavilla",
    INVOICE_CORPORATE_CUSTOMER: "Yritysasiakas",
    INVOICE_PAYMENT_METHOD: "Maksutapa",
    INVOICE_GENERATED_ON: "Luotu",
    INVOICE_PAGE_OF: "Sivu {0}/{1}",
    INVOICE_DESCRIPTION: "Kuvaus",
    INVOICE_UNIT_PRICE: "Yksikköhinta",
    INVOICE_QTY: "Määrä",
    INVOICE_VAT: "ALV",
    INVOICE_DISCOUNT: "Alennus",
    INVOICE_TOTAL: "Yhteensä",
    CORPORATE_CUSTOMERS_SUBTITLE: "Hallitse catering-palveluiden yrityksiä ja niiden toimitusosoitteita.",
    CREATE_CORPORATE_CUSTOMER: "Luo yritysasiakas",
    COMPANY_EMAIL: "Yrityksen sähköposti",
    CORPORATE_DELIVERY_LOCATIONS: "Toimitusosoitteet",
    LOCATIONS: "Sijainnit",
    CORPORATE_BILLING_INFO: "Laskutustiedot",
    NO_CORPORATE_CUSTOMERS_TITLE: "Ei vielä yritysasiakkaita",
    NO_CORPORATE_CUSTOMERS_DESCRIPTION: "Luo ensimmäinen yritysasiakas hallitaksesi laskutusyhteyshenkilöitä ja toimitusosoitteita.",
    CREATE_FIRST_CORPORATE_CUSTOMER: "Luo ensimmäinen yritysasiakas",
    ORGANIZATION_NUMBER: "Y-tunnus",
    ORGANIZATION_ID: "Organisaation tunnus",
    NEXT: "Seuraava",
    EDIT_CORPORATE_CUSTOMER: "Muokkaa yritysasiakasta",
    LEGAL_ENTITY_INFORMATION: "Oikeushenkilön tiedot",
    LEGAL_NAME: "Virallinen nimi",
    VAT_NUMBER: "ALV-numero",
    BILLING_ADDRESS: "Laskutusosoite",
    STREET_ADDRESS: "Katuosoite",
    POSTAL_CODE: "Postinumero",
    INVOICE_SETTINGS: "Laskutusasetukset",
    INVOICE_EMAIL: "Laskutussähköposti",
    PAYMENT_TERMS_DAYS: "Maksuehto (päivää)",
    BILLING_CONTACT: "Yhteyshenkilö",
    CONTACT_NAME: "Yhteyshenkilön nimi",
    ADDED_LOCATIONS: "Lisätyt sijainnit",
    ADD_DELIVERY_LOCATION: "Lisää toimitusosoite",
    FLOOR: "Kerros",
    ENTRANCE_CODE: "Ovikoodi",
    DEFAULT_REFERENCE: "Oletusviite",
    REVIEW_INFORMATION: "Tarkista tiedot",
    LEGAL_ENTITY: "Oikeushenkilö",
    PAYMENT_TERMS: "Maksuehdot",
    SUB_LOCATIONS: "Alisijainnit",
    ADD_SUB_LOCATION: "Lisää alisijainti",
    ROOM_CODE: "Huonekoodi",
    SUB_LOCATION_NAME: "Alisijainnin nimi",
    LOCATION_NAME: "Sijainnin nimi",
    STEP_COMPANY_INFO: "Yrityksen tiedot",
    EDIT_LOCATION_AND_SUBLOCATIONS: "Muokkaa sijaintia ja alisijainteja",
    STEP_BILLING_AND_INVOICE: "Laskutus",
    NO_DELIVERY_LOCATIONS: "Ei vielä toimitusosoitteita",
    CORPORATE_CUSTOMER_CREATED: "Yritysasiakas luotu.",
    CORPORATE_CUSTOMER_UPDATED: "Yritysasiakas päivitetty.",
    CORPORATE_CUSTOMER_DELETED: "Yritysasiakas poistettu.",
    CORPORATE_CUSTOMER_SAVE_FAILED: "Yritysasiakkaan tallentaminen epäonnistui.",
    CORPORATE_CUSTOMER_DELETE_FAILED: "Yritysasiakkaan poistaminen epäonnistui.",
    CORPORATE_GROUP_ERR_FORBIDDEN: "Et ole tämän ryhmän minkään ravintolan ylläpitäjä.",
    CORPORATE_GROUP_ERR_INVALID: "Yritystä ei tallennettu:",
    CORPORATE_CUSTOMER_DELETE_CONFIRM: "Haluatko varmasti poistaa tämän yritysasiakkaan?",
    DELETE_CONFIRMATION: "Poiston vahvistus",
    DELIVERY_LOCATIONS_SUBTITLE: "Tämän yrityksen toimitusosoitteet ja alisijainnit",
    BILLING_INFO_SUBTITLE: "Tämän yritysasiakkaan laskutustiedot",
    DELIVERY_INFORMATION: "Toimitustiedot",
    CORPORATE_COMPANY: "Yritys",
    COMPANY_PHONE: "Yrityksen puhelinnumero",
    DELIVERY_LOCATION: "Toimitusosoite",
    DELIVERY_ROOM: "Toimitushuone",
    DOOR_CODE: "Ovikoodi",
    INVOICE_NUMBER: "Laskunumero",
    SUCCEEDED: "Onnistui",
    DELIVERY_ROOM_FLOOR: "Huoneen kerros",
    DELIVERY_ROOM_DOOR_CODE: "Huonekoodi",
    YES_DELETE: "Kyllä, poista",
    TABLE_QR_CODE: "Pöydän QR-koodi",
    TABLE_DETAILS: "Pöydän tiedot",
    TABLE_MANAGMENT: "Pöytien hallinta",
    TABLE_MANAGMENT_DESCRIPTION: "Hallitse pöytäryhmiä. Jokainen ryhmä määrittää pöytävälin (esim. 70–100). Pöydät luodaan dynaamisesti — mitään ei tallenneta yksittäin",
    SERVING_METHOD_NAME: "Tarjoilutavan nimi",
    SERVING_METHOD_NAME_DESC: "Määritä, miten tämä tarjoilutapa näytetään eri myyntikanavissa.",
    TABLE_SERVING_OPTION: "Pöytiintarjoilu",
    SEAT_SERVING_OPTION: "Paikkatarjoilu",
    NEW_GROUP: "Lisää ryhmä",
    WEB_ORDER_URL: "Verkkotilauksen URL",
    GENERAL_: "Yleiset",
    ROUTE_NAME: "RouteName",
    WEB_ORDER_URL_NOTE: "Jos mukautettua URL-osoitetta ei anneta, järjestelmä käyttää automaattisesti oletusosoitetta",
    SEO_SETTINGS: "SEO-asetukset",
    SEO_SETTINGS_DESC: "Määritä tämän yksikön hakukoneoptimoinnin metatiedot, jotta se näkyy paremmin Googlessa.",
    SEO_TITLE: "SEO-otsikko",
    SEO_TITLE_NOTE: "Otsikko, joka näkyy Googlen hakutuloksissa ja selaimen välilehdellä. Jätä tyhjäksi käyttääksesi oletusotsikkoa.",
    SEO_DESCRIPTION: "SEO-kuvaus (metakuvaus)",
    SEO_DESCRIPTION_NOTE: "Lyhyt yhteenveto, joka näkyy otsikon alla Googlen hakutuloksissa. Suositeltu pituus: 120-160 merkkiä.",
    DOWNLOAD_ALL_QR: "Lataa kaikki QR-koodit",
    WEB_ORDER_BASE_URL: "Verkkotilauksen perus-URL",
    CREATE_TABLE_GROUP: "Luo pöytäryhmä",
    EDIT_TABLE_GROUP: "Muokkaa pöytäryhmää",
    CREATE_SEAT_GROUP: "Luo paikkaryhmä",
    EDIT_SEAT_GROUP: "Muokkaa paikkaryhmää",
    TABLE_RANGE: "Pöytäväli",
    SEAT_RANGE: "Paikkaväli",
    TABLES_WILL_GENERATE: "Tämä luo {count} pöytää",
    SEATS_WILL_GENERATE: "Tämä luo {count} paikkaa",
    END_MUST_BE_GREATER_EQUAL_START: "Lopun on oltava ≥ alku",
    SELECT_ALL: "Valitse kaikki",
    DOWNLOAD_RANGE: "Lataa väli",
    QR_CODE: "QR-koodi",
    FORMAT: "Muoto",
    DOWNLOAD_AS: "Lataa muodossa",
    TABLES: "Pöydät",
    SEATS: "Paikat",
    SEAT: "Paikka",
    SEAT_GROUPS: "Paikkaryhmät",
    SEAT_MANAGEMENT_DESCRIPTION: "Hallitse paikkaryhmiä. Jokainen ryhmä määrittää paikkavälin (esim. 70–100). Paikat luodaan dynaamisesti — mitään ei tallenneta yksittäin.",
    VIEW_TABLES: "Näytä pöydät",
    VIEW_SEATS: "Näytä paikat",
    NO_TABLE_GROUPS_YET: "Ei vielä pöytäryhmiä",
    NO_SEAT_GROUPS_YET: "Ei vielä paikkaryhmiä",
    GROUP_NAME_REQUIRED: "Ryhmän nimi on pakollinen",
    UNIT_NAME_REQUIRED: "Yksikön nimi on pakollinen",
    WEB_ORDER_URL_REQUIRED: "Verkkotilauksen URL on pakollinen",
    TABLE_RANGE_REQUIRED: "Pöytäväli on pakollinen",
    SEAT_RANGE_REQUIRED: "Paikkaväli on pakollinen",
    START_MUST_BE_LESS_EQUAL_END: "Alun on oltava ≤ loppu",
    MAX_1000_TABLES_ALLOWED: "Väli voi olla enintään 1000 pöytää ryhmää kohden",
    MAX_1000_SEATS_ALLOWED: "Väli voi olla enintään 1000 paikkaa ryhmää kohden",
    DELETE_GROUP_CONFIRM: "Poistetaanko \"{group}\" ({tables} {start}–{end})? Toimintoa ei voi perua.",
    GROUP_DELETED: "Ryhmä poistettu",
    FAILED_DELETE_GROUP: "Ryhmän poistaminen epäonnistui",
    SEARCH_GROUPS: "Hae ryhmiä...",
    DOWNLOADED: "Ladattu",
    DOWNLOADING_QR_CODES: "Ladataan QR-koodeja",
    NO_PRINTERS_SELECTED: "Tulostimia ei ole valittu",
    SELECT_PRINTERS_IN_SETTINGS: "Valitse tulostimet kohdasta Asetukset -> Tulostimet",
    PRINT_SUCCESS: "Onnistui",
    ORDER_PRINTED_SUCCESSFULLY: "Tilaus tulostettu",
    CURRENT_WEEK: "Kuluva viikko",
    NEXT_WEEK: "Seuraava viikko",
    ROLLOVER_SETTINGS: "Viikonvaihdon asetukset",
    ROLLOVER_DESCRIPTION: "Määritä, milloin tilaussovellus tarjoaa seuraavaa viikkoa ennakkotilattavaksi.",
    ROLLOVER_ENABLED: "Automaattinen viikonvaihto",
    ROLLOVER_ENABLED_HINT: "Kun käytössä, seuraavasta viikosta tulee kuluva viikko määritettynä päivänä ja kellonaikana.",
    ROLLOVER_CUTOFF_DAY: "Katkaisupäivä",
    ROLLOVER_CUTOFF_TIME: "Katkaisuaika",
    ROLLOVER_NOW: "Vaihda viikko nyt",
    ROLLOVER_CONFIRM_MESSAGE: "Tämä siirtää seuraavan viikon kuluvaksi viikoksi. Seuraava viikko säilyy ennallaan — käytä toimintoa \"Tyhjennä seuraava viikko\", jos haluat tyhjentää sen. Jatketaanko?",
    ROLLOVER_PERFORMED: "Viikonvaihto tehty",
    ROLLOVER_FAILED: "Viikonvaihto epäonnistui",
    ROLLOVER_SETTINGS_SAVED: "Viikonvaihdon asetukset tallennettu",
    NEXT_ROLLOVER_IN: "Asiakkaat voivat tilata seuraavalle viikolle alkaen",
    MANUAL_ACTIONS: "Manuaaliset toiminnot",
    MANUAL_ROLLOVER_DESCRIPTION: "Viikot tallennetaan viikkonumeron mukaan, joten tietoja ei tarvitse siirtää. Näillä toiminnoilla voit täyttää tai tyhjentää seuraavan viikon manuaalisesti.",
    CLONE_CURRENT_TO_NEXT: "Kopioi kuluva viikko seuraavaan",
    CLONE_CURRENT_TO_NEXT_CONFIRM: "Tämä korvaa seuraavan viikon kopiolla kuluvasta viikosta. Jatketaanko?",
    CLONE_CURRENT_TO_NEXT_DONE: "Kuluva viikko kopioitu seuraavaan",
    CLONE_CURRENT_TO_NEXT_FAILED: "Kuluvan viikon kopiointi seuraavaan epäonnistui",
    RESET_NEXT_WEEK: "Tyhjennä seuraava viikko",
    RESET_NEXT_WEEK_CONFIRM: "Tämä palauttaa seuraavan viikon tyhjäksi pohjaksi (ei tuotteita, viikonloput suljettu). Jatketaanko?",
    RESET_NEXT_WEEK_DONE: "Seuraava viikko palautettu tyhjäksi pohjaksi",
    RESET_NEXT_WEEK_FAILED: "Seuraavan viikon tyhjentäminen epäonnistui",
    REMOVE_ORPHAN_WEEKLY_MENUS: "Poista {{count}} vanhaa viikkomenun viikkoa",
    REMOVE_ALL_PAST_WEEKS_CONFIRM: "Poistetaanko {{count}} mennyttä viikkoa tietokannasta? Kuluva ja seuraava viikko säilytetään. Toimintoa ei voi perua.",
    REMOVE_ALL_PAST_WEEKS_DONE: "{{count}} mennyttä viikkoa poistettu",
    REMOVE_ALL_PAST_WEEKS_FAILED: "Menneiden viikkojen poistaminen epäonnistui",
    TIME_SETTINGS: "Aika-asetukset",
    NO_PRODUCTS_YET: "Ei vielä tuotteita",
    ALL_PRODUCTS_ALREADY_ADDED: "Kaikki tuotteet on jo lisätty",
    NO_WEEKLY_MENU_PRODUCTS_ENABLED: "Yhtään tuotetta ei ole otettu käyttöön viikkomenun tilauksille. Ota tuotteita käyttöön tuotteen lisäasetuksissa, jotta voit lisätä niitä viikkomenuun.",
    ENABLE_MORE_PRODUCTS_HINT: "Lisää tuotteita ottamalla ne käyttöön kohdassa Tuote > Lisäasetukset.",
    ADD_PRODUCTS: "Lisää tuotteita",
    ADD_MORE_PRODUCTS: "Lisää muita tuotteita",
    NO_PRODUCTS_SELECTED_FOR_DAY: "Tälle päivälle ei ole vielä lisätty tuotteita",
    SCHEDULED_TAG: "Ajastettu",
    ACTIVE_TAG: "Aktiivinen",
    TODAY_LABEL: "Tänään",
    WEEKLY_MENU_ORDERING: "Viikkomenun tilaus",
    ALL_DAYS: "Kaikki päivät",
    DAYS_SELECTED_LABEL: "{0} päivää valittu",
    ALL_WEEKS_LABEL: "Kaikki viikot",
    CURRENT_WEEK_LABEL: "Kuluva viikko",
    UPCOMING_WEEK_LABEL: "Tuleva viikko",
    WEEK_SCOPE_PLACEHOLDER: "Viikko",
    DAYS_LABEL: "Päivät",
    WEEKLY_TIMELINE_HEADER: "Viikon aikajana",
    WEEKLY_SCOPED_READONLY_BANNER: "Tämän viikkotilauksen voi valmistaa vain sen ajoitettuna päivänä.",
    WEEKLY_SCOPED_START_PREPARING_BTN: "Aloita valmistus",
    WEEKLY_SCOPED_STARTED_SUCCESS_SUMMARY: "Valmistus aloitettu",
    WEEKLY_SCOPED_STARTED_SUCCESS_DETAIL: "Viikkotilaus on nyt työn alla.",
    WEEKLY_SCOPED_MISSING_ETA_SUMMARY: "Tälle päivälle ei ole valmistumisaikaa",
    WEEKLY_SCOPED_MISSING_ETA_DETAIL: "Aseta ajastin valmistusta aloittaessasi, jos haluat näkyvän lähtölaskennan tähän.",
    WEEKLY_SCOPED_PENDING_SELECTION_HINT: "Aloita valmistus, jotta voit valita tämän päivän tuotteita.",
    ADDON_SERVING_METHODS: "Tarjoilutavat",
    ADDON_SERVING_METHODS_HINT: "Kaikki tarjoilutavat ovat oletuksena käytössä. Poista tarjoilutavan valinta piilottaaksesi tämän lisäkkeen kyseisessä tarjoilutavassa.",
    ADDONS_V2_RULES_SECTION: "Valintasäännöt",
    ADDON_WIZARD_RULES: "Säännöt",
    ADDON_LABEL_SELECTION_TYPE: "Lisäkkeen tyyppi",
    ADDON_LABEL_PRESELECT_MODE: "Esivalintatila",
    ADDON_LABEL_MIN_SELECTIONS: "Valintoja vähintään",
    ADDON_LABEL_MAX_SELECTIONS: "Valintoja enintään",
    ADDON_REQUIRED_BEFORE_PROCEED: "Pakollinen ennen kuin asiakas voi jatkaa",
    ADDON_LABEL_PRESELECTED_OPTION: "Esivalittu vaihtoehto",
    SHOW_WHEN_RULES: "Milloin näytetään",
    SHOW_WHEN_HINT: "Tämä ryhmä näytetään vain, kun toisen ryhmän valinnat täyttävät tietyt ehdot.",
    ACTIVE_DEPENDENCIES: "Aktiiviset riippuvuudet",
    DEPENDS_ON_GROUP: "Riippuu ryhmästä",
    OPTIONS_TO_TRIGGER: "Laukaisevat vaihtoehdot",
    ADD_DEPENDENCY: "Lisää riippuvuus",
    SHOW_WHEN_GROUP_PREFIX: "Näytä, kun",
    SHOW_WHEN_INCLUDES_VERB: "sisältää",
    ADDON_VALIDATE_INVALID_PAYLOAD: "Virheelliset lisäkesäännöt",
    ADDON_VALIDATE_MAX_SELECTIONS_RADIO: "Yksittäisvalintaryhmissä valintoja saa olla enintään 1",
    ADDON_VALIDATE_PRESELECT_SPECIFIC: "Valitse esivalittu vaihtoehto tai vaihda esivalintatilaa",
    ADDON_VALIDATE_MAX_LT_MIN: "Valintojen enimmäismäärä ei voi olla pienempi kuin vähimmäismäärä",
    ADDON_SELECT_ONE_RADIO: "Yksi valinta (valintanappi)",
    ADDON_SELECT_MULTIPLE_CHECKBOX: "Useita (valintaruudut)",
    ADDON_PRESELECT_NONE: "Ei mitään",
    ADDON_PRESELECT_FIRST: "Ensimmäinen vaihtoehto",
    ADDON_PRESELECT_SPECIFIC: "Tietty vaihtoehto",
    SUBTITLE_LABEL: "Alaotsikko",
    ALWAYS_VISIBLE: "Aina näkyvissä",
    VISIBLE_IN_DELIVERY_MENU: "Näkyy kotiinkuljetusmenussa",
    VISIBLE_IN_TAKEAWAY_MENU: "Näkyy noutomenussa",
    VISIBLE_IN_EATIN_MENU: "Näkyy paikan päällä syötävien menussa",
    VISIBLE_IN_TABLEORDER_MENU: "Näkyy pöytätilausmenussa",
    VISIBLE_IN_DELIVERYSETLOCATION_MENU: "Näkyy kiinteän toimitusosoitteen menussa",
    WELCOME: "Tervetuloa",
    HELLO: "Hei",
    GOOD_MORNING: "Hyvää huomenta",
    GOOD_EVENING: "Hyvää iltaa",
    GOOD_NIGHT: "Hyvää yötä",
    OPTIONAL: "Valinnainen",
    UNLINK: "Poista linkitys",
    CAROUSEL: "Kokoelmat",
    SLIDE_PLAYBACK_FAILED: "Toisto epäonnistui",
    MENU_DISPLAY: "Menunäyttö",
    INGREDIENTS: "Ainesosat",
    INGREDIENTS_DESCRIPTION: "Valitse ainesosat, jotka sisältyvät tähän tuotteeseen oletuksena.",
    SELECT_FROM_LIBRARY: "Valitse kirjastosta",
    CHOOSE_INGREDIENTS: "Valitse ainesosat...",
    NO_INGREDIENTS_LIBRARY: "Kirjastossa ei ole ainesosia.",
    CREATE_NEW_INGREDIENT: "Luo uusi ainesosa",
    INGREDIENT_PLACEHOLDER: "esim. Sipuli",
    INGREDIENT_HINT: "Lisää painamalla Enter tai napsauttamalla +.",
    SELECTED_INGREDIENTS: "Valitut ainesosat",
    NO_INGREDIENTS_SELECTED: "Ainesosia ei ole vielä valittu.",
    FAILED_LOAD_INGREDIENTS: "Ainesosien lataaminen epäonnistui. Yritä uudelleen.",
    FAILED_CREATE_INGREDIENT: "Ainesosan luominen epäonnistui. Yritä uudelleen.",
    CONFIRM_DELETE_INGREDIENT: "Haluatko varmasti poistaa tämän ainesosan kirjastosta pysyvästi?",
    DELETE_INGREDIENT: "Poista ainesosa",
    INGREDIENT_DELETED_LIBRARY: "Ainesosa poistettu kirjastosta.",
    FAILED_DELETE_INGREDIENT: "Ainesosan poistaminen epäonnistui. Yritä uudelleen.",
    WITHOUT: "Ilman",
    CATERING_ADDON_ERR_DELIVERY_METHOD_REQUIRED: "Vähintään yksi toimitustapa on valittava.",
    CATERING_ADDON_ERR_PRICE_NEGATIVE: "Vaihtoehdon hinta ei voi olla negatiivinen.",
    NO_DATA: "Ei tietoja saatavilla",
    NO_DATA_HINT: "Tällä hetkellä ei ole mitään näytettävää.",
    GUEST_INVOICE_ORDERING: "Laskutilaus ilman kirjautumista",
    GUEST_INVOICE_ORDERING_DESC: "Mahdollistaa laskulla tilaamisen ilman kirjautumista tässä ravintolassa. Asiakkaat antavat kassalla yritys- ja laskutustietonsa maksamisen sijaan.",
    CATERING_SHOW_PRICES_EX_VAT: "Näytä hinnat ilman ALV:tä (B2B)",
    CATERING_SHOW_PRICES_EX_VAT_DESC: "Näyttää catering-hinnat verkkokaupassa ilman ALV:tä, ja kassalla ALV:n sekä kokonaissumman sis. ALV. Vain näyttö: veloitettava summa ei muutu.",
    TABLE_BOOKING_SETTINGS: "Pöytävaraus",
    TABLE_BOOKING_SETTINGS_DESC: "Hallitse pöytävarausten vierasmääriä, varausten kestoja ja vuoroasetuksia.",
    RESTAURANT_LOGO_URL: "Ravintolan logon URL (logoUrl)",
    RESTAURANT_LOGO_URL_HINT: "Logo näytetään ravintolan nimen yläpuolella varaussivulla.",
    MIN_NR_OF_GUESTS: "Vieraiden vähimmäismäärä (minNrOfGuests)",
    MIN_NR_OF_GUESTS_HINT: "Pienin seurueen koko, jonka asiakas voi valita varatessaan.",
    MAX_NR_OF_GUESTS: "Vieraiden enimmäismäärä (maxNrOfGuests)",
    MAX_NR_OF_GUESTS_HINT: "Suurin seurueen koko, jonka asiakas voi valita varatessaan.",
    DEFAULT_BOOK_DURATION_HOURS: "Varauksen oletuskesto tunteina (bookDurationHours)",
    DEFAULT_BOOK_DURATION_HOURS_HINT: "Ruokailun oletuskesto pöytävarausta kohden (esim. 2 tuntia).",
    DEFAULT_SLOT_INTERVAL_HOURS: "Varausvälin oletus tunteina (slotIntervalHours)",
    DEFAULT_SLOT_INTERVAL_HOURS_HINT: "Varattavien alkamisaikojen väli (esim. 0.25 = 15 minuuttia).",
    BOOK_DURATIONS_TITLE: "Vuorojen ja jaksojen asetukset (bookDurations)",
    BOOK_DURATIONS_DESC: "Mukauta ruokailun kestoja ja aikavälejä eri vuorokaudenaikoina (esim. lounas vs. illallinen).",
    ADD_SHIFT: "Lisää vuoro",
    START_TIME: "Alkamisaika (startTime)",
    DURATION_HOURS: "Ruokailun kesto tunteina (durationHours)",
    SLOT_HOURS: "Aikaväli tunteina (slotHours)",
    NO_SHIFTS_CONFIGURED: "Vuorokohtaisia asetuksia ei ole lisätty. Yllä olevia oletusasetuksia käytetään koko päivän.",
    SETTINGS_SAVE_ERROR: "Asetusten tallentaminen epäonnistui.",
    POS_V2_FREE_TEXT_BUTTON_LABEL: "Painikkeen teksti",
    POS_V2_FREE_TEXT_BUTTON_LABEL_HELP: "Teksti, joka näkyy painikeruudussa POS-näkymässä.",
    POS_V2_FREE_TEXT_PRESET_LABEL: "Valmis kuittiteksti",
    POS_V2_FREE_TEXT_PRESET_HELP: "Jos kenttä on täytetty, painikkeen napautus lisää tämän huomautuksen heti yhdellä napautuksella. Jos kenttä jätetään tyhjäksi, POS avaa näppäimistön, jotta kassahenkilö voi kirjoittaa tekstin paikan päällä.",
    POS_V2_BUTTON_STOCK: "Painikevalikoima",
    POS_V2_BUTTON_STOCK_DESC: "Toissijainen ponnahdusruudukko POS:ssa",
    POS_V2_FREE_TEXT_DESC: "Kuittihuomautus tai mukautettu viesti",
    POS_V2_FREE_TEXT_LABEL_PLACEHOLDER: "esim. Huomautus",
    POS_V2_FREE_TEXT_PRESET_PLACEHOLDER: "esim. Ei sipulia",
    POS_V2_STOCK_LABEL_PLACEHOLDER: "esim. Kastikkeet",
    POS_V2_STOCK_BUTTON_LABEL: "Valikoimapainikkeen nimi",
    POS_V2_ADD_STOCK_BUTTON: "Lisää painikevalikoima",
    CLEAR_SEARCH: "Tyhjennä haku",
    BUTTONS: "Painikkeet",
    ITEM: "tuote",
    ITEMS: "tuotetta",
    BACKGROUND: "Tausta:",
    POS_V2_CUSTOM_NAME: "Mukautettu nimi",
    POS_V2_EDIT_CUSTOM_NAME: "Muokkaa mukautettua nimeä",
    POS_V2_RESET_TO_MENU_NAME: "Palauta menun nimi",
    POS_V2_SOLID_COLOR: "Yksivärinen",
    POS_V2_PRODUCT_PHOTO: "Tuotekuva",
    ORDER_VALIDATION_MENU: "Tilausten tarkistus",
    ORDER_VALIDATION_DEVICES: "Laitteet",
    ORDER_VALIDATION_DEVICES_SUBTITLE: "QR-päätteet, joilla asiakkaat skannaavat tilauksensa. Täällä tehdyt muutokset päivittyvät päätteelle automaattisesti.",
    ORDER_VALIDATION_DEVICES_TABLE_TITLE: "Päätteet",
    ORDER_VALIDATION_DEVICES_ADD: "Lisää pääte",
    ORDER_VALIDATION_DEVICES_CREATE: "Luo",
    ORDER_VALIDATION_DEVICES_EDIT: "Päätteen asetukset",
    ORDER_VALIDATION_DEVICES_NAME: "Nimi",
    ORDER_VALIDATION_DEVICES_NAME_PLACEHOLDER: "esim. Sisäänkäynnin pääte",
    ORDER_VALIDATION_DEVICES_NAME_REQUIRED: "Anna päätteelle nimi",
    ORDER_VALIDATION_DEVICES_ID: "Laitetunnus",
    ORDER_VALIDATION_DEVICES_ROUTE: "Ravintola",
    ORDER_VALIDATION_DEVICES_ROUTE_HELP: "Yksikkö, jonka tilauksia tämä pääte tarkistaa. Muualta tulevat tilaukset hylätään.",
    ORDER_VALIDATION_DEVICES_ROUTE_REQUIRED: "Valitse ravintola",
    ORDER_VALIDATION_DEVICES_LANGUAGE: "Kieli",
    ORDER_VALIDATION_DEVICES_LANGUAGE_UNSET: "Päätteen oma valinta",
    ORDER_VALIDATION_DEVICES_LANGUAGE_HELP: "Jos kenttä jätetään tyhjäksi, päätteellä säilyy siihen valittu kieli.",
    ORDER_VALIDATION_DEVICES_SOUNDS: "Äänet",
    ORDER_VALIDATION_DEVICES_SOUND_SUCCESS: "Ääni onnistuneesta skannauksesta",
    ORDER_VALIDATION_DEVICES_SOUND_FAILURE: "Ääni epäonnistuneesta skannauksesta",
    ORDER_VALIDATION_DEVICES_VERSION: "Versio",
    ORDER_VALIDATION_DEVICES_LAST_SEEN: "Viimeksi yhteydessä",
    ORDER_VALIDATION_DEVICES_ONLINE: "Verkossa",
    ORDER_VALIDATION_DEVICES_EMPTY: "Ei vielä päätteitä. Lisää pääte ja syötä sen tunnus päätteelle.",
    ORDER_VALIDATION_DEVICES_CREATED_HELP: "Yhdistä pääte syöttämällä tämä tunnus päätteelle PubQ-logon alle.",
    ORDER_VALIDATION_DEVICES_ID_COPIED: "Laitetunnus kopioitu",
    ORDER_VALIDATION_DEVICES_CREATE_FAILED: "Päätettä ei voitu luoda",
    ORDER_VALIDATION_DEVICES_SAVED: "Päätteen asetukset tallennettu",
    ORDER_VALIDATION_DEVICES_SAVE_ERROR: "Päätteen asetuksia ei voitu tallentaa",
    ORDER_VALIDATION_DEVICES_LOAD_ERROR: "Päätteitä ei voitu ladata",
    ORDER_VALIDATION_DEVICES_REMOVE: "Poista",
    ORDER_VALIDATION_DEVICES_REMOVE_CONFIRM: "Poistetaanko tämä pääte yksiköstä?",
    ORDER_VALIDATION_DEVICES_REMOVE_WARNING: "Pääte jatkaa tarkistamista nykyisillä asetuksillaan. Poistaminen täältä poistaa sen vain tältä listalta.",
    ORDER_VALIDATION_DEVICES_REMOVED: "Pääte poistettu",
    ORDER_VALIDATION_DEVICES_REMOVE_FAILED: "Päätettä ei voitu poistaa",
    ENTER_COMPANY_NUMBER: "Anna Y-tunnus",
    MENU_SCHEDULE_DEACTIVATED: "Menun aikataulu poistettu käytöstä",
    CHECKBOX: "Valintaruutu",
    TOTALT: "Yhteensä",
    APPLY_TO_SELECTED: "Käytä valittuihin",
    LAST_30_DAY: "Viimeiset 30 päivää",
    NAME_AND_COUPON: "Sinun on annettava nimi ja valittava kuponki",
    DISCOUNT_CODE: "Alennuskoodi",
    NEWS_POSTS: "Uutiset",
    COMPANY_NUMBER: "Y-tunnus",
    COST_CENTER: "Kustannuspaikka",
    OVERWRITE_POS_BUTTONS: "Vanhat kassapainikkeesi poistetaan. Haluatko jatkaa?",
    THIS_YEAR: "Tämä vuosi",
    HEADER_IMAGE: "Otsikkokuva",
    EMPLOYEE_ID: "Työntekijätunnus",
    TAG_ID: "Tunnisteen ID",
    ENTER_EMPLOYEE_ID: "Anna työntekijätunnus",
    ENTER_TAG_ID: "Anna tunnisteen ID",
    START_DATE_REQUIRED: "Aloituspäivä vaaditaan nouto-/toimituspäivien lisäämiseksi",
    DATE_ALREADY_EXISTS: "Tämä päivämäärä on jo lisätty. Valitse toinen päivämäärä.",
    COURSE: "Ruokalaji",
    NO_COURSE: "Ei ruokalajia",
    NO_COURSE_DIRECT: "Ei ruokalajia (lähetetään heti)",
    COURSE_HINT: "Kassa sijoittaa tämän keittiötulostuskategorian tuotteet valittuun ruokalajiin. Ei ruokalajia: lähetetään keittiöön heti.",
    COURSE_NAME_1: "Alkuruoka",
    COURSE_NAME_2: "Pääruoka",
    COURSE_NAME_3: "Jälkiruoka",
    // Integrations + Fortnox (Z): MACHINE-TRANSLATED from Swedish/English, needs native-Finnish review (language.fi.REVIEW.md)
    INTEG_TITLE: "Integraatiot",
    INTEG_OVERVIEW: "Yleiskatsaus",
    INTEG_THIS_RESTAURANT: "ravintola",
    INTEG_LOADING_STATUS: "Haetaan tilaa…",
    INTEG_COMING_SOON: "Tulossa pian",
    INTEG_REAUTH: "Yhteys on hyväksyttävä uudelleen",
    INTEG_NOT_CONNECTED: "Ei yhdistetty",
    INTEG_NO_ACCESS: "Ei käyttöoikeutta",
    INTEG_MANAGE: "Hallinnoi",
    INTEG_ACTIVATE: "Ota käyttöön",
    INTEG_DESC_FORTNOX: "Kirjaa jokaisen suljetun Z-raportin tositteeksi yrityksen Fortnoxiin. Kustannuspaikka ja tilien kohdistus ravintolakohtaisesti.",
    INTEG_DESC_PERSONALKOLLEN: "Työvuorosuunnittelu ja tuntiraportointi: henkilöstö, vuorot ja palkkakulut synkronoidaan PubQ:n kanssa.",
    INTEG_DESC_TCPOS: "Myynnin vienti TCPOS-järjestelmään (SOAP / REST) ketjuille, jotka raportoivat TCPOS:ssä.",
    FZ_TITLE: "Fortnox – Z-raportit",
    FZ_INTRO: "Jokainen suljettu Z-raportti voidaan kirjata tositteeksi yrityksen Fortnoxiin.",
    FZ_MODE_MOCK: "TESTITILA (mock): mitään ei lähetetä Fortnoxiin, tositenumerot ovat keksittyjä.",
    FZ_MODE_READONLY: "LUKUTILA: yhteys ja tarkistukset Fortnoxia vasten toimivat, mutta tositteita ei luoda.",
    FZ_NO_UNIT: "Ravintolaa ei ole valittu. Valitse ravintola valikosta.",
    FZ_NOTICE_CONNECTED: "Fortnox on yhdistetty yritykselle.",
    FZ_CONNECTION_HEADER: "Yhteys (yritys)",
    FZ_RETRY: "Yritä uudelleen",
    FZ_CONNECTED_TO: "Yhdistetty yritykseen",
    FZ_DISCONNECT_COMPANY: "Katkaise yrityksen yhteys…",
    FZ_BELONGS_TO: "Ravintolan yritys:",
    FZ_ORG_MISSING: "Y-tunnus puuttuu",
    FZ_CONNECT_HELP: "Kirjaudut yrityksen Fortnoxiin pääkäyttäjänä ja hyväksyt. Fortnox-tilillä on oltava sama Y-tunnus.",
    FZ_CONNECT: "Yhdistä Fortnox",
    FZ_DISCONNECTED_OK: "Fortnox-yhteys katkaistu yritykseltä",
    FZ_LISTS_STILL_SAVE: "voit silti tallentaa asetukset.",
    FZ_AUTO_EXPORT: "Automaattinen vienti",
    FZ_COST_CENTER: "Kustannuspaikka",
    FZ_NONE: "– ei mitään –",
    FZ_LOADING_COST_CENTERS: "Haetaan kustannuspaikkoja…",
    FZ_NO_COSTCENTER_SCOPE: "Yhteydeltä puuttuu \"kustannuspaikat\"-oikeus – Fortnox tarkistaa koodin kirjauksen yhteydessä.",
    FZ_VOUCHER_SERIES: "Tositesarja",
    FZ_COMPANY_DEFAULT: "– yrityksen oletus –",
    FZ_ROUNDING_ACCOUNT: "Pyöristystili",
    FZ_REVIEW_FIRST: "Tarkista ensimmäiset käsin",
    FZ_ACCOUNT_MAPPING: "Tilien kohdistus",
    FZ_ACCOUNT_MAPPING_HELP: "Korvaa kassan tilin toisella Fortnox-tilillä (tai \"drop\" riveille, joilla ei ole summaa).",
    FZ_POS_ACCOUNT: "Kassan tili",
    FZ_FORTNOX_ACCOUNT: "Fortnox-tili",
    FZ_ADD_MAPPING: "Lisää kohdistus",
    FZ_SAVE: "Tallenna",
    FZ_SETTINGS_SAVED: "Asetukset tallennettiin",
    FZ_ZREPORTS: "Z-raportit",
    FZ_COL_BUSINESS_DATE: "Myyntipäivä",
    FZ_COL_TOTAL: "Yhteensä",
    FZ_COL_STATUS: "Tila",
    FZ_TEST: "testi",
    FZ_STATUS_NOT_SENT: "Ei lähetetty",
    FZ_STATUS_PENDING: "Jonossa",
    FZ_STATUS_HELD: "Odottaa tarkistusta",
    FZ_STATUS_SENDING: "Lähetetään",
    FZ_STATUS_SENT: "Lähetetty",
    FZ_STATUS_FAILED: "Epäonnistui",
    FZ_STATUS_LEGACY: "Kirjattu (vanha prosessi)",
    FZ_PREVIEW: "Esikatsele",
    FZ_APPROVE_SEND: "Hyväksy ja lähetä",
    FZ_SEND: "Lähetä",
    FZ_RESEND_ELLIPSIS: "Lähetä uudelleen…",
    FZ_EMPTY: "Ei vielä suljettuja Z-raportteja.",
    FZ_BACKFILL_LABEL: "Lähetä jälkikäteen Z",
    FZ_FROM: "alkaen",
    FZ_TO: "asti",
    FZ_BACKFILL: "Lähetä jälkikäteen",
    FZ_BACKFILL_HELP: "Vanhimmat ensin. Jo kirjatut ohitetaan. Pysähtyy ensimmäiseen virheeseen.",
    FZ_NOT_SENT_BECAUSE: "Ei lähetetä:",
    FZ_COL_ACCOUNT: "Tili",
    FZ_COL_TEXT: "Teksti",
    FZ_COL_DEBIT: "Debet",
    FZ_COL_CREDIT: "Kredit",
    FZ_COL_COST_CENTER_SHORT: "KP",
    FZ_SUM: "Yhteensä",
    FZ_CLOSE: "Sulje",
    FZ_RESEND_SECOND: "Uudelleenlähetys luo saman päivän toisen tositteen.",
    FZ_RESEND_VOID_HINT: "Mitätöi ensimmäinen Fortnoxissa, jos se on väärin.",
    FZ_TYPE_TO_CONFIRM: "Vahvista kirjoittamalla seuraava:",
    FZ_TYPE_ORGNO_TO_CONFIRM: "Vahvista kirjoittamalla Y-tunnus:",
    FZ_CANCEL: "Peruuta",
    FZ_RESEND: "Lähetä uudelleen",
    FZ_DISCONNECT_TITLE: "Katkaistaanko Fortnox-yhteys?",
    FZ_DISCONNECT_EFFECT: "Automaattinen vienti lakkaa toimimasta, kunnes joku yhdistää uudelleen.",
    FZ_DISCONNECT: "Katkaise yhteys",
    FZ_ERROR: "Virhe",
    FZ_REFUSED_ALREADY_SENT: "jo kirjattu",
    FZ_REFUSED_IN_PROGRESS: "lähetys on jo käynnissä",
    FZ_REFUSED_HELD: "odottaa tarkistusta",
    FZ_TOAST_MOCK: "TESTI – mock",
    FZ_ERR_FORBIDDEN: "Sinulla ei ole käyttöoikeutta tähän ravintolaan.",
    FZ_ERR_LOAD: "Ei voitu hakea",
    FZ_ERR_CONNECTION: "Yhteyden tietoja ei voitu hakea",
    FZ_ERR_LISTS: "Tilejä ja kustannuspaikkoja ei voitu hakea Fortnoxista",
    FZ_ERR_ZLIST: "Z-raportteja ei voitu hakea",
    FZ_ERR_NOT_SIGNED_IN: "Et ole kirjautunut sisään.",
    FZ_ERR_SERVICE_TIMEOUT: "Fortnox-palvelu ei vastannut ajoissa",
    FZ_ERR_UNREACHABLE: "Fortnox-palveluun ei saatu yhteyttä (verkko tai CORS)",

    // --- Organisaatio: ryhmän luvut, jaettu luettelo, jaetut tarjoukset ------
    ORG_MENU: "Organisaatio",
    ORG_ORGANISATION: "Organisaatio",
    ORG_DASHBOARD: "Yleiskatsaus",
    ORG_DASHBOARD_SUBTITLE: "Koko ryhmän myynti, ja yksikköä kohden.",
    ORG_CATALOG: "Jaettu tuoteluettelo",
    ORG_CATALOG_SUBTITLE: "Ryhmän jakamat tuotteet. Julkaisu kirjoittaa jokaisen yksikön omaan ruokalistaan.",
    ORG_CATALOG_HOW_IT_WORKS: "Julkaisu kirjoittaa tuotteen jokaisen valitun yksikön omaan ruokalistaan — siksi jokainen kassa kirjaa oman hinnanmuutoksensa. Yksiköt, joilla on oma kiinnitetty hinta, ohitetaan.",
    ORG_COUPONS: "Jaetut tarjoukset",
    ORG_COUPONS_SUBTITLE: "Kupongit ja tarjoukset, jotka ryhmä jakaa yksiköilleen.",
    ORG_COUPONS_HOW_IT_WORKS: "Määritä tarjous keskitetysti ja jaa se niille yksiköille, joilla se pitää olla. Yksiköllä voi olla oma arvo.",
    ORG_ACCESS: "Organisaation käyttöoikeudet",
    ORG_ACCESS_SUBTITLE: "Kuka näkee ryhmän luvut ja kuka saa hallinnoida niitä.",
    ORG_ACCESS_WARNING: "Organisaation jäsenyys ei anna oikeutta ryhmän myyntiin. Vain tässä annettu nimenomainen rooli antaa — 841 käyttäjällä on jo organisaatiorivi, eivätkä he saa nähdä ketjun lukuja vahingossa.",
    ORG_UNITS: "yksikköä",
    ORG_UNIT: "Yksikkö",
    ORG_COMPANIES: "yhtiötä",
    ORG_PERIOD: "Jakso",
    ORG_TOTAL_SALES: "Myynti",
    ORG_RECEIPTS: "kuittia",
    ORG_AVG_RECEIPT: "Keskiostos",
    ORG_SALES_PER_DAY: "Myynti päivässä",
    ORG_SALES_PER_HOUR: "Myynti tunnissa",
    ORG_PER_UNIT: "Yksikköä kohden",
    ORG_PAYMENTS: "Maksutavat",
    ORG_PAYMENT_METHOD: "Maksutapa",
    ORG_TOP_PRODUCTS: "Myydyimmät tuotteet",
    ORG_PRODUCT: "Tuote",
    ORG_CATEGORY: "Kategoria",
    ORG_QUANTITY: "Määrä",
    ORG_AMOUNT: "Summa",
    ORG_COUNT: "Määrä",
    ORG_SHARE: "Osuus",
    ORG_TOTAL: "Yhteensä",
    ORG_NO_DATA: "Ei tietoja jaksolta.",
    ORG_NO_UNITS: "Tässä organisaatiossa ei ole yksiköitä.",
    ORG_MULTI_CURRENCY: "Ryhmällä on yksiköitä useassa valuutassa. Summat näytetään valuutoittain — niitä ei koskaan lasketa yhteen.",
    ORG_UNITS_TRUNCATED: "Enemmän yksiköitä kuin yksi kutsu kantaa. Näitä ei ole mukana:",
    ORG_STATS_UNAVAILABLE: "Tilastopalvelua ei ole otettu käyttöön tässä ympäristössä.",
    ORG_STATS_FAILED: "Tilastoja ei voitu hakea.",
    ORG_LOAD_FAILED: "Ei voitu hakea.",
    ORG_SAVE_FAILED: "Ei voitu tallentaa.",
    ORG_ERROR: "Virhe",
    ORG_SAVED: "Tallennettu",
    ORG_UNITS_SAVED: "Yksiköt tallennettiin",
    ORG_DEMO_DATA: "DEMODATA",
    ORG_DEMO_DATA_HELP: "Rajapintaa ei ole vielä. Näytetty tieto on keksittyä eikä sitä tallenneta.",
    ORG_DEMO_NOT_SAVED: "Demotieto — mitään ei tallennettu.",
    ORG_LIVE_DATA: "Live-tieto",
    ORG_DERIVED_UNITS: "Omat yksiköt",
    ORG_DERIVED_UNITS_HELP: "Yksiköt ovat ne, joihin sinut on liitetty, organisaatioittain. Palvelimen oma yksikkölista ei ole valmis, joten ryhmä voi näyttää liian vähän yksiköitä.",
    ORG_NEW_PRODUCT: "Uusi tuote",
    ORG_EDIT_PRODUCT: "Muokkaa tuotetta",
    ORG_NO_PRODUCTS: "Luettelossa ei ole vielä tuotteita.",
    ORG_NAME: "Nimi",
    ORG_DESCRIPTION: "Kuvaus",
    ORG_BASE_PRICE: "Hinta",
    ORG_BASE_PRICE_ORE: "Hinta (sentteinä)",
    ORG_VAT: "ALV",
    ORG_SALES_ACCOUNT: "Myyntitili",
    ORG_ACTIVE: "Aktiivinen",
    ORG_INACTIVE: "Ei aktiivinen",
    ORG_ASSIGNED_UNITS: "Yksiköt",
    ORG_VERSION: "Versio",
    ORG_EDIT: "Muokkaa",
    ORG_ASSIGN_UNITS: "Valitse yksiköt",
    ORG_SHARE_WITH_UNITS: "Jaa yksiköille",
    ORG_PUBLISH: "Julkaise",
    ORG_PUBLISH_NOW: "Julkaise nyt",
    ORG_PUBLISHED: "Julkaistu",
    ORG_UNITS_QUEUED: "yksikköä jonossa",
    ORG_PUBLISH_FAILED: "Julkaisu epäonnistui.",
    ORG_PREVIEW_FAILED: "Esikatselua ei voitu hakea.",
    ORG_ON: "Päällä",
    ORG_PRICE_OVERRIDE: "Oma hinta (sentteinä)",
    ORG_VALUE_OVERRIDE: "Oma arvo",
    ORG_ORG_PRICE: "Ryhmän hinta",
    ORG_ORG_VALUE: "Ryhmän arvo",
    ORG_CLEAR_OVERRIDE: "Poista oma arvo",
    ORG_WONT_BE_PUBLISHED: "Julkaisu ei korvaa",
    ORG_PUBLISHED_LABEL: "Julkaistu",
    ORG_OVERRIDE_HELP: "Yksikön omaa hintaa ei koskaan korvata julkaisulla. Poista se, jos yksikön pitää seurata ryhmän hintaa uudelleen.",
    ORG_COUPON_OVERRIDE_HELP: "Yksikön oma arvo on ryhmän arvon edellä.",
    ORG_EDIT_NOT_PUBLISHED: "Tallennus muuttaa luetteloa. Yksiköt saavat muutoksen vasta kun julkaiset.",
    ORG_WILL_UPDATE: "Päivitetään",
    ORG_WILL_SKIP: "Ohitetaan",
    ORG_PUBLISH_JOURNAL_NOTE: "Jokainen päivitetty yksikkö kirjaa oman hinnanmuutoksensa. Kirjauksia odotetaan:",
    ORG_PUBLISH_BLOCKED_REGISTER: "Julkaisu on pysäytetty: kassaa ei löytynyt kaikille yksiköille, ja hinnanmuutos menisi läpi ilman kirjausta. Yksiköitä:",
    ORG_PUBLISH_NOTHING: "Ei julkaistavaa — kaikki yksiköt ovat ajan tasalla.",
    ORG_COUPON: "Tarjous",
    ORG_NEW_COUPON: "Uusi tarjous",
    ORG_EDIT_COUPON: "Muokkaa tarjousta",
    ORG_NO_COUPONS: "Ei tarjouksia vielä.",
    ORG_CODE: "Koodi",
    ORG_VALUE: "Arvo",
    ORG_VALID: "Voimassa",
    ORG_VALID_FROM: "Voimassa alkaen",
    ORG_VALID_TO: "Voimassa asti",
    ORG_COUPON_KIND: "Tyyppi",
    ORG_COUPON_PERCENTAGE: "Prosentti",
    ORG_COUPON_AMOUNT: "Summa",
    ORG_COUPON_FREE_ITEM: "Ilmainen tuote",
    ORG_COUPON_PCT_HELP: "0–100",
    ORG_GRANT_ACCESS: "Myönnä oikeus",
    ORG_GRANT: "Myönnä",
    ORG_REVOKE: "Poista oikeus",
    ORG_REVOKE_CONFIRM: "Poista organisaatio-oikeus käyttäjältä",
    ORG_ACCESS_GRANTED: "Oikeus myönnetty",
    ORG_ACCESS_REVOKED: "Oikeus poistettu",
    ORG_USER: "Käyttäjä",
    ORG_ROLE: "Rooli",
    ORG_GRANTED: "Myönnetty",
    ORG_EMAIL: "Sähköposti",
    ORG_ROLE_ADMIN: "Organisaation ylläpitäjä",
    ORG_ROLE_VIEWER: "Katselija",
    ORG_ROLE_ADMIN_HELP: "näkee ryhmän myynnin ja hallinnoi luetteloa, tarjouksia ja käyttöoikeuksia.",
    ORG_ROLE_VIEWER_HELP: "näkee ryhmän myynnin. Ei muuta.",
    ORG_ROLES_EXPLAINED: "Mitä roolit tarkoittavat",
    ORG_ADMIN_ONLY: "Vain organisaation ylläpitäjä voi muuttaa tätä.",
    ORG_NO_ACCESS_ROWS: "Kenelläkään ei ole vielä organisaatio-oikeutta.",
    ORG_GRANT_EMAIL_HELP: "Käyttäjän täytyy olla jo PubQ:ssa.",
    ORG_GRANT_ADMIN_WARNING: "Organisaation ylläpitäjä näkee koko ryhmän myynnin ja voi antaa saman oikeuden muille.",

    ORG_STAFF_ACCESS: "PubQ-henkilöstö",
    ORG_STAFF_ACCESS_HELP: "Olet kirjautunut PubQ-henkilöstönä ja voit avata minkä tahansa organisaation.",
    ORG_API_PROBLEM: "API-ongelma",
    ORG_API_NOT_DEPLOYED: "Organisaatio-API:ta ei ole julkaistu tässä ympäristössä.",
    ORG_FORBIDDEN: "Sinulla ei ole organisaatio-oikeutta tähän organisaatioon.",
    ORG_NET: "Netto",
    ORG_NO_SALES: "Ei myyntiä",
    ORG_OTHER_TYPES: "Muut kuitit",
    ORG_OTHER_TYPES_HELP: "Kuitit jotka eivät ole myyntiä (palautukset, proforma). Raportoidaan erikseen eikä lasketa myyntiin.",
    ORG_SOLD_IN_UNITS: "Yksiköt",
    ORG_SHOW_ARCHIVED: "Näytä arkistoidut",
    ORG_ARCHIVED_TAG: "Arkistoitu",
    ORG_ARCHIVE: "Arkistoi",
    ORG_ARCHIVED: "Arkistoitu",
    ORG_ARCHIVE_PUBLISH_NOTE: "Arkistoitu luettelossa. Julkaise poistaaksesi sen yksiköistä.",
    ORG_PRODUCT_TYPE: "Tuotetyyppi",
    ORG_CONTAINS_ALCOHOL: "Sisältää alkoholia",
    ORG_VAT_ACCOUNT_HINT: "Myyntitili (vihje)",
    ORG_VAT_ACCOUNT_HINT_HELP: "Yksiköillä on usein useita tilejä samalle ALV-kannalle (12 % ruoka ja 12 % virvoitusjuomat). Ilman vihjettä tai yksikkökohtaista valintaa julkaisu kieltäytyy arvaamasta.",
    ORG_SELLABLE: "Myytävissä",
    ORG_SELLABLE_HELP: "Pois tarkoittaa, että tuote on yksikössä mutta ei myynnissä. Sitä ei koskaan poisteta.",
    ORG_STALE: "Ei ajan tasalla",
    ORG_UNITS_IN_SCOPE: "yksikköä laajuudessa",
    ORG_UNCHANGED: "muuttumattomia",
    ORG_WOULD_WITHDRAW: "poistetaan",
    ORG_WOULD_FAIL: "epäonnistuu",
    ORG_WARNINGS: "varoituksia",
    ORG_PUBLISH_SOME_FAIL: "Jotkin yksiköt epäonnistuisivat. Julkaisu ajetaan muille — korjaa nämä ja julkaise uudelleen.",
    ORG_PUBLISH_QUEUED: "Julkaisu jonossa",
    ORG_RUN: "Ajo",
    ORG_RUN_SWEEP: "poimitaan 15 min sisällä",
    ORG_ENABLED: "Käytössä",
    ORG_DISCOUNT: "Alennus",
    ORG_DISCOUNT_HELP: "1–100 %. Sovellukset tukevat vain prosenttia.",
    ORG_OFFER_KIND_CODE: "Alennuskoodi",
    ORG_OFFER_KIND_OFFER: "Tarjous",
    ORG_CODE_HELP: "A–Z, 0–9, _ ja -. 3–50 merkkiä. Yksilöllinen organisaation aktiivisten koodien joukossa.",
    ORG_CODE_CONFLICT: "Koodi on jo käytössä organisaation aktiivisessa tarjouksessa.",
    ORG_KIND_LOCKED: "Tyyppiä ei voi muuttaa jälkikäteen.",
    ORG_LIVE_UNITS: "Live",
    ORG_LIVE_NOW: "Live nyt",
    ORG_WITHDRAWN: "Poistettu",
    ORG_VALIDITY_ENFORCED: "Voimassaoloaika ohjaa julkaisua: sen ulkopuolella koodi poistetaan jokaisesta yksiköstä ja palautetaan noin 15 minuutin sisällä.",
    ORG_OFFER_CONFLICT_NOTE: "Yksikkö jolla on jo oma samantekstinen koodi ei saa organisaation koodia. Yksikön omaa koodia ei koskaan muuteta.",
    ORG_UNIT_FLAG_NOTE: "Varoitukset: sovellukset näyttävät koodit vain jos yksiköllä on kuponkikoodit päällä, ja tarjoukset vain jos globaalit tarjoukset ovat päällä. Julkaisu ei muuta yksikön asetuksia.",
    ORG_STAFF_ONLY: "Vain PubQ-henkilöstö voi muuttaa tätä.",
    ORG_STAFF_ONLY_NOTE: "Näet keillä on oikeus. Oikeuden myöntää ja poistaa PubQ-henkilöstö — organisaation ylläpitäjä ei voi ylentää muita.",
    ORG_ROLE_STAFF: "PubQ-henkilöstö",
    ORG_ROLE_STAFF_HELP: "näkee kaiken, ja on ainoa joka voi myöntää tai poistaa organisaatio-oikeuden.",
    ORG_ACCESS_ALREADY: "Oikeus oli jo",
    ORG_USER_NOT_FOUND: "Kyseisellä sähköpostilla ei ole PubQ-tiliä. Oikeuden myöntäminen ei koskaan luo tiliä.",
    ORG_AUDIT: "Historia",
    ORG_NO_AUDIT: "Ei historiaa.",
    ORG_REASON: "Syy",
    ORG_REASON_HELP: "Tallentuu historiaan.",
    ORG_WHEN: "Milloin",
    ORG_ACTION: "Toimenpide",
    ORG_BY: "Tekijä",

    ORG_MANAGED_TAG: "Organisaatio",
    ORG_MANAGED_HELP: "Organisaation hallinnoima. Se tuotiin tänne organisaation julkaisulla, ei luotu tässä yksikössä.",
    ORG_MANAGED_EDIT_WARNING: "Voit muuttaa tätä tuotetta, mutta organisaation seuraava julkaisu korvaa organisaation omistamat kentät. Jos yksikkö tarvitsee oman hintansa pysyvästi, pyydä organisaatiota asettamaan yksikkökohtainen poikkeus.",

    ORG_EXTERNAL_ID: "Ulkoinen tunnus",
    ORG_EXTERNAL_ID_HELP: "Tuotteen tunnus toisessa järjestelmässä, esim. Compass Groupin TCPOS-tuotenumero. Lähetetään jokaiseen yksikköön ja on kenttä jonka TCPOS-vienti lukee. Tyhjennä kenttä poistaaksesi sen.",
    ORG_EXTERNAL_ID_KEY: "Järjestelmä",
    ORG_EXTERNAL_ID_OVERRIDE: "Yksikön ulkoinen tunnus",
    ORG_WRITTEN: "kirjoitettu",
    ORG_FAILED: "epäonnistui",
    ORG_RETRY: "Yritä uudelleen",
    ORG_PUBLISH_DONE: "Julkaisu valmis",
    ORG_PUBLISH_PARTIAL: "Julkaisu valmis virheillä",
    ORG_RUN_STILL_GOING: "Ajo on yhä käynnissä. Se jatkuu taustalla — lataa sivu myöhemmin uudelleen nähdäksesi tuloksen.",

    ORG_IMAGE: "Kuva",
    ORG_IMAGE_CHOOSE: "Valitse kuva",
    ORG_IMAGE_REPLACE: "Vaihda kuva",
    ORG_IMAGE_CLEAR: "Poista",
    ORG_IMAGE_HELP: "Ladataan organisaation omana kuvana (org/{id}/products/) ja julkaistaan jokaiseen yksikköön tuotteen mukana.",

    ORG_IMAGE_NOT_AN_IMAGE: "Tiedosto ei ole kuva.",
    ORG_IMAGE_UPLOAD_FAILED: "Kuvaa ei voitu ladata.",
    ORG_IMAGE_DENIED: "Tallennussäännöt estäivät kirjoituksen organisaation polkuun. Pyydä PubQ:ta lisäämään sääntö polulle:",

    // --- Laskun lähetys Fortnoxiin (luonnos; PubQ ei koskaan kirjaa sitä) --
    FZ_INV_COLUMN: "Fortnox",
    FZ_INV_SEND: "Lähetä Fortnoxiin",
    FZ_INV_RETRY: "Yritä uudelleen",
    FZ_INV_RESEND: "Lähetä uudelleen",
    FZ_INV_SENDING: "Lähetetään…",
    FZ_INV_FAILED: "Epäonnistui",
    FZ_INV_UNCERTAIN: "Epävarma",
    FZ_INV_NOT_SENT: "Ei lähetetty",
    FZ_INV_NOT_SENT_YET: "Laskua ei ole lähetetty Fortnoxiin.",
    FZ_INV_DOC: "Fortnox-lasku",
    FZ_INV_DRAFT_NOTE: "luotu kirjaamattomana luonnoksena. Kirjaa ja lähetä se Fortnoxissa.",
    FZ_INV_SENT_TITLE: "Lähetetty Fortnoxiin",
    FZ_INV_ALREADY_TITLE: "Löytyy jo Fortnoxista",
    FZ_INV_FAILED_TITLE: "Fortnox hylkäsi laskun",
    FZ_INV_NOT_READY: "Laskua ei voi vielä lähettää Fortnoxiin.",
    FZ_INV_CONFIRM: "Tämä luo uuden kirjaamattoman laskun Fortnoxiin. PubQ ei kirjaa sitä eikä lähetä sitä asiakkaalle.",
    FZ_INV_CONFIRM_DRIFT: "Fortnox summaa laskun hieman eri tavalla — tarkista se siellä.",
    FZ_INV_LINK_CUSTOMER_FIRST: "Liitä asiakas ensin Fortnoxiin",
    FZ_INV_GO_LINK_CUSTOMER: "Siirry yritysasiakkaisiin",
    FZ_INV_RECONNECT: "Yhdistä Fortnox uudelleen laskutuksen käyttöön",
    FZ_INV_RECONNECT_CTA: "Yhdistä Fortnox uudelleen",
    FZ_INV_DISABLED: "Fortnox-laskutusta ei ole otettu käyttöön tässä ympäristössä",
    FZ_INV_NOT_CONNECTED: "Ravintolaa ei ole yhdistetty Fortnoxiin",
    FZ_INV_IN_PROGRESS: "Laskua lähetetään juuri nyt",
    FZ_INV_UNCERTAIN_HELP: "Aiempi lähetys on voinut jo luoda laskun Fortnoxiin. Tarkista Fortnoxista ennen uutta lähetystä.",
    FZ_INV_RESEND_TITLE: "Lähetetäänkö lasku uudelleen?",
    FZ_INV_RESEND_CONFIRM_LABEL: "Kirjoita vahvistus lähettääksesi uudelleen:",
    FZ_INV_RECONCILE: "Summa PubQ:ssa / Fortnoxissa",

    // --- Asiakastuonti Fortnoxista (kirjanpitojärjestelmä lähteenä) ---------
    FZ_CUST_SEARCH_LABEL: "Etsi asiakasta Fortnoxista",
    FZ_CUST_SEARCH_PLACEHOLDER: "Nimi, asiakasnumero tai Y-tunnus",
    FZ_CUST_SEARCH_HINT: "Kirjoita vähintään kaksi merkkiä. Haku kohdistuu liitetyn Fortnox-yhtiön asiakkaisiin.",
    FZ_CUST_INCLUDE_INACTIVE: "Näytä myös ei-aktiiviset",
    FZ_CUST_INACTIVE: "ei aktiivinen",
    FZ_CUST_NO_RESULTS: "Yksikään Fortnoxin asiakas ei vastaa hakua.",
    FZ_CUST_OR_MANUAL: "tai täytä tiedot itse",
    FZ_CUST_PREFILLED_FROM: "Esitäytetty Fortnoxista:",
    FZ_CUST_DISCARD_PICK: "Poista",
    FZ_CUST_REVIEW_HELP: "Tarkista ja korjaa tiedot ennen tallennusta. Fortnoxiin ei kirjoiteta mitään — PubQ vain lukee asiakasrekisteriä.",
    FZ_CUST_REVIEW_TERMS: "Fortnoxin maksuehto ei ole päivien lukumäärä. Kenttään on täytetty 30 päivää — tarkista se.",
    FZ_CUST_REVIEW_EMAIL: "Asiakkaalla ei ole sähköpostiosoitetta Fortnoxissa. Täytä laskun vastaanottaja itse.",
    FZ_CUST_REVIEW_ORGNO: "Asiakkaalla ei ole Y-tunnusta Fortnoxissa. Täytä se itse.",
    FZ_CUST_WILL_CREATE: "Tallennetaan uutena yritysasiakkaana.",
    FZ_CUST_WILL_LINK: "Y-tunnus on jo yritysasiakkaana. Se liitetään Fortnox-asiakkaaseen; omia tietojasi ei muuteta.",
    FZ_CUST_ALREADY_TITLE: "Jo tuotu",
    FZ_CUST_ALREADY_HELP: "Tämä Fortnox-asiakas on jo tuotu. Avaa olemassa oleva asiakas tai käytä siinä Päivitä Fortnoxista -toimintoa.",
    FZ_CUST_OPEN_EXISTING: "Avaa olemassa oleva asiakas",
    FZ_CUST_CONFLICT_TITLE: "Useita mahdollisia osumia",
    FZ_CUST_CONFLICT_HELP: "Löytyi yritysasiakas, joka voi olla sama yritys, mutta osuma on liian heikko automaattiseen liittämiseen. Valitse liitettävä asiakas tai luo uusi asiakas.",
    FZ_CUST_MATCHED_ON: "Osuma kohteessa",
    FZ_CUST_LINK_THIS: "Liitä tähän",
    FZ_CUST_CREATE_ANYWAY: "Luo silti uusi asiakas",
    FZ_CUST_CHOOSE_FIRST: "Valitse liittäminen tai uuden luominen ennen tallennusta.",
    FZ_CUST_IMPORTED: "Yritysasiakas tuotiin Fortnoxista.",
    FZ_CUST_LINKED: "Yritysasiakas liitettiin Fortnox-asiakkaaseen.",
    FZ_CUST_SOURCE_TAG: "Fortnox",
    FZ_CUST_REFRESH: "Päivitä Fortnoxista",
    FZ_CUST_REFRESH_NO_CHANGE: "Kaikki oli jo ajan tasalla Fortnoxin kanssa.",
    FZ_CUST_RECONNECT_TITLE: "Asiakastuontia ei ole otettu käyttöön",
    FZ_CUST_RECONNECT_CTA: "Yhdistä Fortnox uudelleen ottaaksesi asiakastuonnin käyttöön",
    FZ_CUST_CONSENT_NOTE: "Yhteys antaa PubQ:lle myös lukuoikeuden Fortnoxin asiakasrekisteriisi, jotta voit tuoda asiakkaita. PubQ ei koskaan muuta sitä.",
    // X/Z-dagrapport (FR_), Dricks (TIP_), staff scheduling (STAFF_), 2026-10-15: MACHINE/LLM-TRANSLATED
    // from language.se.ts (with language.en.ts), NOT reviewed by a native Finnish speaker. See language.fi.REVIEW.md.
    FR_ACCOUNT: "Tili",
    FR_ACCOUNTINGS_FROM: "Tiliöinti on peräisin",
    FR_ACCOUNTINGS_FROM_NOTE: "Päivänpäätös tehdään kassassa, eikä se välttämättä noudata Z-raportin myyntipäivää; vertaa jaksoja.",
    FR_ACCOUNTINGS_NONE: "Yksikään kassan päivänpäätös ei ala tämän myyntipäivän aikana, joten näytettävää tiliöintiä ei ole. Z-raportti on silti täydellinen.",
    FR_ADDRESS: "Osoite",
    FR_AMOUNT: "Summa",
    FR_BALANCE: "Erotus",
    FR_BUSINESS_DATE: "Myyntipäivä",
    FR_CASHIER: "Kassanhoitaja",
    FR_CASH_FLOAT: "Vaihtokassa",
    FR_CASH_TAKEN: 'Käteistä sisään',
    FR_CASH_EXPECTED: 'Kassassa pitäisi olla',
    FR_CASH_COUNTED: 'Laskettu (viimeisin)',
    FR_CASH_DIFFERENCE: 'Kassaero',
    FR_NOTE_CASH_FROM_TILL: 'Kassaan jäänyt käteinen (vaihtorahan jälkeen) päivän aikana, kassan mukaan.',
    FR_NOTE_CASH_EXPECTED: 'Vaihtokassa + käteistä sisään.',
    FR_NOTE_CASH_COUNTED: 'Päivän viimeisin kassan laskenta, tehty kassalla.',
    FR_NOTE_CASH_DIFFERENCE: 'Laskettu miinus mitä kassassa olisi pitänyt olla laskennan hetkellä.',
    FR_COMPANY: "Yrityksen nimi",
    FR_CONTROL_UNIT: "Valvontayksikkö (kontrollenhet), valmistusnumero",
    FR_CORRECTIONS: "Korjatut kuitit (virhelyönnit), lukumäärä",
    FR_CSV_FIELD: "Tieto",
    FR_CSV_NOTE: "Kommentti",
    FR_CSV_SKVFS: "SKVFS",
    FR_CSV_STATE: "Tila",
    FR_CSV_VALUE: "Arvo",
    FR_DAY_CLOSED_AT: "Päivä suljettu",
    FR_DIALOG_SETTLEMENT: "Päivänpäätös nro",
    FR_DISCOUNTS: "Alennukset, summa",
    FR_DISCOUNT_COUNT: "Alennukset, lukumäärä",
    FR_DRAWER_OPENINGS: "Kassalaatikon avausten määrä",
    FR_EMAIL_SIE: "Lähetä tiliöinti sähköpostilla (SIE)",
    FR_EVENT_CLOCK_CHANGE: "Kellonajan muutokset",
    FR_EVENT_LOGIN: "Sisäänkirjautumiset",
    FR_EVENT_LOGOUT: "Uloskirjautumiset",
    FR_EVENT_MODE_CHANGE: "Tilan vaihdot",
    FR_EVENT_PRICE_CHANGE: "Hinnanmuutokset",
    FR_EXPORT_CSV: "CSV",
    FR_EXPORT_PDF: "PDF",
    FR_FILE_PREFIX: "paivaraportti",
    FR_FIRST_SALE: "Ensimmäinen rekisteröinti",
    FR_FOOTNOTE: "Summat kruunuina (SEK). Ajat Ruotsin aikaa (Europe/Stockholm). Viiva tarkoittaa, että tietoa ei voida hakea lähdeaineistosta — ei sitä, että arvo on nolla.",
    FR_FOOTNOTE_PLAIN: "Summat kruunuina (SEK). Ajat Ruotsin aikaa (Europe/Stockholm).",
    FR_GAPS_TITLE: "Seuraavia SKVFS 2014:9 7 kap. edellyttämiä tietoja ei voida hakea lähdeaineistosta:",
    FR_GOODS_QTY: "Myytyjen tuotteiden määrä",
    FR_GRAND_NET: "Grand total, netto",
    FR_GRAND_RETURNS: "Grand total, palautukset",
    FR_GRAND_SALES: "Grand total, myynti",
    FR_GROUP: "Tuoteryhmä",
    FR_GROUPS: "Myynti pääryhmittäin",
    FR_GROUP_NONE: "Ei tuoteryhmää",
    FR_INTERRUPTED: "Keskeneräiset myynnit, lukumäärä",
    FR_INTERRUPTED_AMOUNT: "Keskeneräiset myynnit, summa",
    FR_KASSABETECKNING: "Kassan tunniste (kassabeteckning)",
    FR_LAST_SALE: "Viimeinen rekisteröinti",
    FR_LIST_SOURCE_JOURNAL: "Z-raportit journaalimuistista, yksi myyntipäivää kohden. Avaa raportti napsauttamalla riviä.",
    FR_LIST_SOURCE_SETTLEMENT: "Päivänpäätökset. Yksiköllä ei ole Z-raportteja journaalimuistissa.",
    FR_NOTE_CASHIER_SETTLEMENT: "Raportti laaditaan hallinnassa, ei kassanhoitajan toimesta.",
    FR_NOTE_CASHIER_Z: "Palvelin laatii Z-raportin automaattisesti, kun päivä suljetaan.",
    FR_NOTE_CASH_FLOAT_CLIENT: "Rekisteröity kassassa päivän alussa.",
    FR_NOTE_CASH_FLOAT_NOT_REGISTERED: "Kassaan ei rekisteröity vaihtokassaa tänä päivänä.",
    FR_NOTE_CLOSE_TIME: "Yksikön asetetun sulkemisajan mukaan.",
    FR_NOTE_COMPILATION: "Useamman päivänpäätöksen koosteella ei ole omaa juoksevaa numeroa, eikä se ole Z-raportti.",
    FR_NOTE_CONTROL_UNIT: "Valvontayksikköä ei ole vielä liitetty. Valmistusnumero vaaditaan kuitissa (7 kap. 1 § l), ei päiväraportissa.",
    FR_NOTE_COPIES_AMOUNT_X: "Kuittikopioiden summa ei sisälly päivänpäätökseen eikä journaalimuistin juokseviin summiin; se on vasta Z-raportissa.",
    FR_NOTE_COPIES_IN_JOURNAL: "Kuittikopiot lasketaan journaalimuistissa, ei päivänpäätöksessä.",
    FR_NOTE_COPIES_SINCE_JOURNAL_Z: "Journaalimuistista: kopiot edellisen Z-raportin jälkeen, mikä voi olla eri aloituskohta kuin päivänpäätöksellä.",
    FR_NOTE_EVENTS: "Ei vaatimus päiväraportissa, mutta tapahtumien on oltava journaalimuistissa (SKVFS 2014:9 4 kap.). Tämä lukumäärä on se, jota tarkastaja vertaa journaaliin.",
    FR_NOTE_FROM_JOURNAL: "Journaalimuistista.",
    FR_NOTE_GRAND_FROM_JOURNAL: "Journaalimuistin juoksevasta summasta, sellaisena kuin se on juuri nyt. Ei koskaan nollaudu.",
    FR_NOTE_GRAND_NET: "Grand total -myynti miinus grand total -palautukset (2 kap. 5 §).",
    FR_NOTE_GRAND_ZERO: "Kuitti-API palauttaa grand totalille aina nollan (peritty vanhasta VB-toteutuksesta). Kertyneet summat ovat journaalimuistissa, mutta niitä ei välitetä tänne.",
    FR_NOTE_GROUPS_NOT_IN_JOURNAL: "Journaalimuistin riveillä ei ole tuoteryhmää, joten myyntiä ei voida jakaa pääryhmittäin.",
    FR_NOTE_GROUP_ID: "Lähdeaineisto ilmoittaa tuoteryhmän tunnuksen (ID), ei sen nimeä, eivätkä yhdistetyt rivit sisällä määriä — myytyjen tuotteiden ja palvelujen määrät esitetään sen sijaan kohdassa Laskurit.",
    FR_NOTE_INTERRUPTED_AMOUNT: "Journaalimuisti laskee keskeneräiset myynnit, mutta ei tallenna niiden summaa.",
    FR_NOTE_INTERRUPTED_AMOUNT_SETTLEMENT: "Päivänpäätös laskee keskeneräiset kuitit, mutta ei laske yhteen niiden summaa.",
    FR_NOTE_NO_CASH_FLOAT: "Vaihtokassa kirjataan päiväkohtaisesti yksikön asetuksiin, mutta päivänpäätös ei välitä sitä, eikä sitä lueta tähän.",
    FR_NOTE_NO_DRAWER: "Kassa ei raportoi kassalaatikkotapahtumia, joten näytettävää laskuria ei ole.",
    FR_NOTE_NO_KASSABETECKNING: "Kassan tunniste ei sisälly päivänpäätöksen vastaukseen. Se löytyy journaalimuistin raportin otsakkeesta.",
    FR_NOTE_NO_KASSABETECKNING_JOURNAL: "Raportin otsakkeesta puuttuu kassan tunniste.",
    FR_NOTE_NO_OTHER_REDUCTIONS: "Muita hinnanalennuksia kuin alennuksia ei eritellä lähdeaineistossa.",
    FR_NOTE_NO_TRAINING: "Kassajärjestelmässä ei ole harjoitustilaa, joten vaatimus ei tule sovellettavaksi.",
    FR_NOTE_NO_ZNO: "Juoksevaa numeroa ei ole asetettu — X-raportti ei kuluta numeroa.",
    FR_NOTE_OTHER_REDUCTIONS_JOURNAL: "Journaalimuisti laskee korjatut kuitit, mutta ei erittele muita myyntiä vähentäneitä rekisteröintejä tai niiden summaa.",
    FR_NOTE_RECEIPTS_SUM: "Myynti- ja palautuskuitit yhteensä, jotka journaalimuisti laskee erikseen.",
    FR_NOTE_RETURNS_FOLDED: "Palautus tallennetaan kuittina, jossa on negatiiviset summat, ja se sisältyy myyntisummiin. Journaalimuisti erittelee palautukset.",
    FR_NOTE_ROUNDING: "Luettu pyöristystilin kirjanpitoriviltä. Pyöristys ei ole SKVFS:n vaatimus päiväraportissa, mutta sitä tarvitaan täsmäytykseen.",
    FR_NO_REPORT: "Valitulle jaksolle ei ole näytettävää raporttia.",
    FR_NO_ROWS: "Ei rivejä.",
    FR_ORGNO: "Y-tunnus",
    FR_OTHER_REDUCTIONS: "Muut hinnanalennukset",
    FR_PAYMENT_MEANS: "Maksutapa",
    FR_PDF_PAGE: "Sivu",
    FR_PDF_SUBTITLE: "Päiväraportti SKVFS 2014:9 7 kap. mukaisesti. Oikean sarakkeen viittaus ilmoittaa määräyksen kohdan.",
    FR_PERIOD_FROM: "Jakso alkaa",
    FR_PERIOD_TO: "Jakso päättyy",
    FR_PRINT: "Tulosta",
    FR_PRINTED_AT: "Raportti otettu",
    FR_PROFORMA: "Alustavat kuitit (proforma), lukumäärä",
    FR_QTY: "Määrä",
    FR_RECEIPT_COPIES: "Kuittikopiot, lukumäärä",
    FR_RECEIPT_COPIES_AMOUNT: "Kuittikopiot, summa",
    FR_RECEIPT_COUNT: "Kuittien määrä",
    FR_RECEIPT_RANGE: "Kuittinumerot alkaen–asti",
    FR_RETURNS: "Palautukset, summa",
    FR_RETURNS_AMOUNT_TOTALS: "Vähennetään: palautukset",
    FR_RETURNS_COUNT: "Palautukset, lukumäärä",
    FR_ROUNDING: "Pyöristys",
    FR_SALESLOCATION: "Myyntipaikka",
    FR_SALES_AFTER_RETURNS: "Myynti palautusten jälkeen (sis. ALV)",
    FR_SALES_GROSS: "Kokonaismyynti (ennen palautuksia)",
    FR_SALES_NET: "Myynti netto (ilman ALV)",
    FR_SALES_TOTAL: "Myynti brutto (sis. ALV)",
    FR_SALES_VAT: "ALV",
    FR_SECTION_ACCOUNTINGS: "Kirjanpitotilit",
    FR_SECTION_COUNTERS: "Laskurit",
    FR_SECTION_EVENTS: "Jatkuva käyttö",
    FR_SECTION_GAPS: "Lähdeaineistosta puuttuvat tiedot",
    FR_SECTION_GROUPS: "Myynti tuoteryhmittäin",
    FR_SECTION_IDENTITY: "Myyjä ja kassajärjestelmä",
    FR_SECTION_PAYMENTS: "Myynti maksutavoittain",
    FR_SECTION_PERIOD: "Jakso ja ajankohta",
    FR_SECTION_REDUCTIONS: "Palautukset, alennukset ja keskeneräiset myynnit",
    FR_SECTION_TOTALS: "Myynti ja summat",
    FR_SECTION_VAT: "ALV verokannoittain",
    FR_SERVICES_QTY: "Myytyjen palvelujen määrä",
    FR_SETTLEMENT: "päivänpäätös nro",
    FR_SOURCE_JOURNAL: "Lähde: kassajärjestelmän journaalimuistissa oleva Z-raportti, sellaisena kuin se sinetöitiin päivän sulkemisen yhteydessä. Tiliöinti saman päivän päivänpäätöksestä.",
    FR_SOURCE_SETTLEMENT: "Lähde: päivänpäätös (SQL). Tiedot, joita päivänpäätös ei sisällä, on merkitty alla puuttuviksi.",
    FR_SOURCE_SETTLEMENT_JOURNAL: "Lähde: päättämättömät kuitit edellisen päivänpäätöksen jälkeen. Grand totalit, kuittikopiot ja kassan tunniste journaalimuistista.",
    FR_STATE_DERIVED: "Laskettu tässä, ei raportoitu suoraan",
    FR_STATE_MISSING: "Lähdeaineisto ei sisällä tietoa",
    FR_STATE_NOT_APPLICABLE: "Toimintoa ei ole kassajärjestelmässä",
    FR_STATE_OK: "Haettu lähdeaineistosta",
    FR_STATE_UNRELIABLE: "Lähdeaineisto antaa tunnetusti virheellisen arvon",
    FR_SUBTITLE: "Sisältö noudattaa Ruotsin verohallinnon (Skatteverket) määräyksiä SKVFS 2014:9, 7 kap. 2 § (X) ja 3 § (Z). Kunkin rivin viittaus osoittaa, minkä vaatimuksen rivi täyttää.",
    FR_TITLE_COMPILATION: "Päivänpäätösten kooste",
    FR_TITLE_X: "X-raportti",
    FR_TITLE_Z: "Z-raportti",
    FR_TOTAL: "Yhteensä",
    FR_TRAINING_COUNT: "Harjoitusrekisteröintien määrä",
    FR_VATNO: "ALV-tunniste",
    FR_VAT_CHECK_BAD: "ALV-erittely EI täsmää myyntiin palautusten jälkeen: summa verokannoittain {actual}, myynti {expected}, erotus {diff} {cur}. Lähdeaineisto on tarkistettava.",
    FR_VAT_CHECK_OK: "ALV-erittely täsmää myyntiin palautusten jälkeen ({expected} {cur}).",
    FR_VAT_GROSS: "Brutto",
    FR_VAT_NET: "Netto",
    FR_VAT_RATE: "Verokanta",
    FR_VAT_VAT: "ALV",
    FR_ZNO: "Z-raportin juokseva numero",
    PRINT_TO_POS_PRINTER: "Tulosta kassan tulostimelle",
    STAFF_ABSENCE_APPROVE: "Hyväksy",
    STAFF_ABSENCE_DECLINE: "Hylkää",
    STAFF_ABSENCE_PENDING: "Päätöstä odottavat poissaolopyynnöt",
    STAFF_INACTIVE: "ei aktiivinen",
    STAFF_PHONE_HINT: "Ruotsalainen matkapuhelinnumero tai maatunnuksen kanssa: +358…. Käytetään kirjautumiseen Omat sivut -palveluun ja työvuorolistan tekstiviesteihin.",
    STAFF_ROLE_ADD: "Uusi rooli",
    STAFF_ROLE_ADD_THIS: "Lisää tämä rooli",
    STAFF_ROLE_COLOUR: "Väri työvuorolistassa",
    STAFF_ROLE_DRIFT_HINT: "Ne tulevat työvuoroista ja työntekijöistä. Lisää ne, jotta voit antaa niille värin ja järjestyksen — tai siivoa pois ne, joita ei pitäisi olla.",
    STAFF_ROLE_DRIFT_TITLE: "Käytössä olevat roolit, jotka puuttuvat luettelosta",
    STAFF_ROLE_EDIT: "Muokkaa roolia",
    STAFF_ROLE_NAME: "Rooli",
    STAFF_ROLE_NAME_REQUIRED: "Anna roolin nimi.",
    STAFF_ROLE_NONE: "Rooleja ei ole määritetty. Työvuorolista käyttää silloin rooleja, jotka on jo merkitty työvuoroihin ja työntekijöille.",
    STAFF_ROLE_ORDER: "Järjestys",
    STAFF_ROLE_REINSTATE: "Aktivoi uudelleen",
    STAFF_ROLE_RENAME_WARNING: "Nimen muuttaminen muuttaa vain luetteloa. Olemassa olevat työvuorot säilyttävät vanhan nimen ja näkyvät luetteloimattomina.",
    STAFF_ROLE_RETIRE: "Poista käytöstä — roolia ei voi valita uusiin työvuoroihin",
    STAFF_ROLE_RETIRED: "Poistettu käytöstä",
    STAFF_ROLE_SECTION: "Roolit",
    STAFF_ROLE_SEED: "Lisää kaikki",
    STAFF_ROLE_SEEDED: "{count} roolia lisättiin.",
    STAFF_ROLE_USAGE: "Työvuorot, joissa on tämä rooli",
    STAFF_SCHEDULE_ACTUAL: "Toteutunut",
    STAFF_SCHEDULE_ADD: "Lisää työvuoro",
    STAFF_SCHEDULE_BAD_TIME: "Anna aika muodossa HH:MM, esimerkiksi 16:00.",
    STAFF_SCHEDULE_BREAK: "Tauko (min)",
    STAFF_SCHEDULE_BY_EMPLOYEE: "Työntekijöittäin",
    STAFF_SCHEDULE_BY_ROLE: "Rooleittain",
    STAFF_SCHEDULE_CHANGED: "Muutettu julkaisun jälkeen",
    STAFF_SCHEDULE_COPY_ADD: "Lisää työvuorot",
    STAFF_SCHEDULE_COPY_ADD_HINT: "Työvuorot lisätään jo olemassa olevien lisäksi. Voi syntyä kaksoiskappaleita.",
    STAFF_SCHEDULE_COPY_DO: "Kopioi",
    STAFF_SCHEDULE_COPY_FROM: "Kopioi viikolta…",
    STAFF_SCHEDULE_COPY_MODE: "Miten",
    STAFF_SCHEDULE_COPY_PREVIOUS: "Kopioi edellinen viikko",
    STAFF_SCHEDULE_COPY_REPLACE: "Korvaa viikko",
    STAFF_SCHEDULE_COPY_REPLACE_HINT: "Tämän viikon työvuorot poistetaan ensin. Myös julkaistut työvuorot korvataan.",
    STAFF_SCHEDULE_COPY_RESULT: "{created} työvuoroa kopioitu ajalta {from}.",
    STAFF_SCHEDULE_COPY_SOURCE: "Kopioi lähteestä",
    STAFF_SCHEDULE_COPY_TARGET: "Kopioidaan kohteeseen",
    STAFF_SCHEDULE_COST: "Kustannus",
    STAFF_SCHEDULE_DATE: "Päivämäärä",
    STAFF_SCHEDULE_DELETE: "Poista",
    STAFF_SCHEDULE_DIFF: "Ero",
    STAFF_SCHEDULE_DRAFT: "Luonnos",
    STAFF_SCHEDULE_EDIT_SHIFT: "Muokkaa työvuoroa",
    STAFF_SCHEDULE_END: "Päättyy",
    STAFF_SCHEDULE_EVERY_2ND_WEEK: "Joka toinen viikko",
    STAFF_SCHEDULE_EVERY_3RD_WEEK: "Joka kolmas viikko",
    STAFF_SCHEDULE_EVERY_4TH_WEEK: "Joka neljäs viikko",
    STAFF_SCHEDULE_EVERY_WEEK: "Joka viikko",
    STAFF_SCHEDULE_EXPORT_CSV: "Vie CSV",
    STAFF_SCHEDULE_FOOTER: "{shifts} työvuoroa tällä viikolla, {open} avoinna.",
    STAFF_SCHEDULE_INTRO: "Suunnittele viikon työvuorot, vertaa suunniteltua toteutuneeseen työaikaan ja julkaise, kun lista on valmis.",
    STAFF_SCHEDULE_NEW_SHIFT: "Uusi työvuoro",
    STAFF_SCHEDULE_NOTE: "Muistiinpano",
    STAFF_SCHEDULE_NO_EMPLOYEES: "Toimipisteessä ei ole vielä työntekijöitä. Lisää heidät ensin kohdassa Työntekijät.",
    STAFF_SCHEDULE_NO_ROLE: "Ei roolia",
    STAFF_SCHEDULE_NO_ROLES_USED: "Ei työvuoroja tällä viikolla.",
    STAFF_SCHEDULE_NO_WEATHER: "Ei säätietoja: anna toimipisteen koordinaatit, jotta ennuste voidaan näyttää.",
    STAFF_SCHEDULE_NO_WORKPLACE: "Henkilöstömoduulia ei ole vielä otettu käyttöön tässä toimipisteessä.",
    STAFF_SCHEDULE_OPEN_SHIFT: "Avoin työvuoro (ei ketään)",
    STAFF_SCHEDULE_OPEN_SHIFTS: "Avoimet työvuorot",
    STAFF_SCHEDULE_OPEN_SHORT: "avoinna",
    STAFF_SCHEDULE_PLANNED: "Suunniteltu",
    STAFF_SCHEDULE_PRINT: "Tulosta",
    STAFF_SCHEDULE_PRINTED_AT: "Tulostettu",
    STAFF_SCHEDULE_PUBLISH: "Julkaise",
    STAFF_SCHEDULE_PUBLISHED: "Julkaistu",
    STAFF_SCHEDULE_REPEAT: "Toista",
    STAFF_SCHEDULE_REPEAT_CAPPED: "Raja saavutettiin — toista uudelleen loppuja varten.",
    STAFF_SCHEDULE_REPEAT_CREATED: "{count} työvuoroa luotu.",
    STAFF_SCHEDULE_REPEAT_DAYS: "Viikonpäivät",
    STAFF_SCHEDULE_REPEAT_DAYS_HINT: "Jätä tyhjäksi, niin käytetään työvuoron omaa viikonpäivää.",
    STAFF_SCHEDULE_REPEAT_DO: "Luo työvuorot",
    STAFF_SCHEDULE_REPEAT_EVERY: "Kuinka usein",
    STAFF_SCHEDULE_REPEAT_FROM: "Toistetaan työvuoro alkaen",
    STAFF_SCHEDULE_REPEAT_NOTE: "Työvuorot luodaan luonnoksina ja ne ovat itsenäisiä — yhden muokkaaminen muuttaa vain sitä. Jos haluat muuttaa toistokaavaa, poista työvuorot ja toista uudelleen.",
    STAFF_SCHEDULE_REPEAT_SKIPPED: "{count} päivää ohitettiin (työvuoro oli jo olemassa).",
    STAFF_SCHEDULE_REPEAT_UNTIL: "Saakka (mukaan lukien)",
    STAFF_SCHEDULE_REPUBLISH: "Julkaise muutokset",
    STAFF_SCHEDULE_ROLE: "Rooli",
    STAFF_SCHEDULE_START: "Alkaa",
    STAFF_SCHEDULE_THIS_MONTH: "Tämä kuukausi",
    STAFF_SCHEDULE_THIS_WEEK: "Tämä viikko",
    STAFF_SCHEDULE_TIME_HINT: "Jos päättymisaika on ennen alkamisaikaa, työvuoro jatkuu keskiyön yli.",
    STAFF_SCHEDULE_TITLE: "Työvuorolista",
    STAFF_SCHEDULE_TOTAL: "Yhteensä",
    STAFF_SCHEDULE_VIEW_DAY: "Päivä",
    STAFF_SCHEDULE_VIEW_MONTH: "Kuukausi",
    STAFF_SCHEDULE_VIEW_WEEK: "Viikko",
    STAFF_SCHEDULE_WARNINGS: "{count} työaikavaroitus(ta)",
    STAFF_SCHEDULE_WARNINGS_HINT: "vain ohjeellinen, työvuorolista tallennetaan silti. Työehtosopimus voi olla lakia tiukempi.",
    STAFF_SCHEDULE_WEATHER_SOURCE: "Säätiedot: SMHI.",
    STAFF_SCHEDULE_WEEKDAY: "Viikonpäivä",
    STAFF_SCHEDULE_WEEK_SHORT: "vko",
    STAFF_SCHEDULE_WHO: "Kuka",
    STAFF_SETTINGS_BACK: "Takaisin työvuorolistaan",
    STAFF_SETTINGS_INTRO: "Mitä rooleja toimipisteessä miehitetään ja millaisia työvuoromuotoja käytetään. Muutetaan harvoin.",
    STAFF_SETTINGS_TITLE: "Roolit ja pohjat",
    STAFF_SMS_OPT_OUT: "Ei työvuorolistan tekstiviestejä",
    STAFF_SMS_OPT_OUT_HINT: "Kun valinta on päällä, työntekijä ei saa tekstiviestiä, kun työvuorolista tai avoimia työvuoroja julkaistaan.",
    STAFF_TEMPLATE_ADD: "Uusi pohja",
    STAFF_TEMPLATE_EDIT: "Muokkaa pohjaa",
    STAFF_TEMPLATE_HINT: "Pohja on oikotie, ei sääntö: pohjan muokkaaminen ei muuta jo luotuja työvuoroja.",
    STAFF_TEMPLATE_NAME: "Nimi",
    STAFF_TEMPLATE_NAME_REQUIRED: "Anna pohjalle nimi.",
    STAFF_TEMPLATE_NONE: "Ei vielä pohjia.",
    STAFF_TEMPLATE_NO_LINK: "Pohja täyttää tiedot, kun lisäät työvuoron. Sitä ei linkitetä työvuoroon jälkikäteen.",
    STAFF_TEMPLATE_PAID: "Palkallinen",
    STAFF_TEMPLATE_SECTION: "Vuoropohjat",
    STAFF_TEMPLATE_TIME: "Aika",
    STAFF_UNIT_ALERT_PHONE: "Puhelinnumero poissaolopyynnöille",
    STAFF_UNIT_ALERT_PHONE_HINT: "Tähän numeroon lähetetään tekstiviesti, kun työntekijä tekee poissaolopyynnön. Jätä tyhjäksi, jos et halua viestejä — pyynnöt näkyvät silti kohdassa Työvuorolista.",
    TIP_AVERAGE: "Keskiarvo per kuitti",
    TIP_CHECK_BAD: "Ei täsmää",
    TIP_CHECK_BAD_SUMMARY: "Erittelyjen summa ei vastaa kauden kokonaissummaa:",
    TIP_CHECK_OK: "Täsmää",
    TIP_CHECK_OK_SUMMARY: "Päiväkohtaiset, päivänpäätöskohtaiset, maksutapakohtaiset ja kuittikohtaiset summat vastaavat kaikki kauden kokonaissummaa.",
    TIP_COL_DATE: "Päivämäärä",
    TIP_COL_MEANS: "Maksutapa",
    TIP_COL_RECEIPTS: "Kuitit",
    TIP_COL_RECEIPT_NO: "Kuittinro",
    TIP_COL_RECEIPT_RANGE: "Kuittinro alkaen–asti",
    TIP_COL_RECEIPT_TOTAL: "Kuitin summa",
    TIP_COL_SETTLEMENT: "Päivänpäätös",
    TIP_COL_TIME: "Aika",
    TIP_COL_TIP: "Juomaraha",
    TIP_DAYS_WITH_TIPS: "Päivät, joina juomarahaa",
    TIP_DEFINITION: "Juomarahat ovat kuittirivejä, joiden nimi on \"Extra\" ja ALV 0 %, sekä vanhoista että uusista kassoista. Peruste palkanlaskennalle, ei osa kassajärjestelmän päiväraportteja.",
    TIP_ERROR: "Juomaraharaporttia ei voitu hakea.",
    TIP_EXPORT_RECEIPTS_CSV: "CSV kuiteittain (palkat)",
    TIP_EXPORT_SUMMARY_CSV: "CSV-yhteenveto",
    TIP_FILE_PREFIX: "juomarahat",
    TIP_FILE_RECEIPTS: "kuiteittain",
    TIP_FILE_SUMMARY: "yhteenveto",
    TIP_FOOTNOTE: "Summat SEK. Ajat Ruotsin aikaa (Europe/Stockholm).",
    TIP_GENERATED: "Luotu",
    TIP_LINE_COUNT: "Juomaraharivit",
    TIP_NONE: "Kaudella ei ole kirjattu juomarahaa.",
    TIP_NOTE_DAY: "Kuitin oma päivä Ruotsin aikaa, ei liiketoimintapäivä.",
    TIP_NOTE_MEANS: "\"Inget\", \"Okänt\" ja \"Flera betalsätt\" ovat juomarahoja, joita ei voida kohdistaa yksittäiseen maksutapaan.",
    TIP_NOTE_SETTLEMENT: "\"Päättämätön päivä\" tarkoittaa kuitteja, jotka eivät vielä sisälly mihinkään päivänpäätökseen.",
    TIP_OPEN_DAY: "Päättämätön päivä",
    TIP_PERIOD: "Kausi",
    TIP_PER_DAY: "Juomarahat päivittäin",
    TIP_PER_MEANS: "Juomarahat maksutavoittain",
    TIP_PER_SETTLEMENT: "Juomarahat päivänpäätöksittäin (Z)",
    TIP_PRINT_TOO_MANY: "Liian monta kuittia tulostettavaksi. Käytä PDF- tai CSV-tiedostoa koko listaan.",
    TIP_RECEIPTS: "Kuittilista",
    TIP_RECEIPTS_WORD: "kuittia",
    TIP_RECEIPT_COUNT: "Kuitit, joissa juomarahaa",
    TIP_SECTION_CHECK: "Täsmäytys",
    TIP_SECTION_RECEIPTS: "Juomarahat kuiteittain",
    TIP_SECTION_SUMMARY: "Yhteenveto",
    TIP_TAB: "Juomarahat",
    TIP_TITLE: "Juomarahat",
    TIP_TOTAL: "Juomarahat yhteensä",
    TIP_TRUNCATED: "Kuittilista on rajattu 5 000 viimeisimpään kuittiin. Kokonaissummat ja erittelyt kattavat koko kauden; valitse lyhyempi kausi nähdäksesi koko listan.",
    TIP_UNIT: "Yksikkö",
    // Status page (third-party service status)
    MENU_NAV_STATUS: "Järjestelmän tila",
    MENU_SECTION_OVERVIEW: "Yleiskatsaus",
    MENU_SECTION_MENU: "Menu ja tuotteet",
    MENU_SECTION_CHANNELS: "Myyntikanavat",
    MENU_SECTION_GUESTS: "Markkinointi",
    MENU_SECTION_ECONOMY: "Talous",
    MENU_SECTION_ADMIN: "Hallinta",
    MENU_SEARCH_PLACEHOLDER: "Hae valikosta",
    MENU_SEARCH_EMPTY: "Ei osuvia sivuja",
    STATUS_PAGE_TITLE: "Järjestelmän tila",
    STATUS_PAGE_SUBTITLE: "Yksikkösi käyttämien kolmannen osapuolen palveluiden tila",
    PROVIDER_REFRESH: "Päivitä",
    PROVIDER_SECTION_TITLE: "Kolmannen osapuolen palvelut",
    PROVIDER_ISSUES_COUNT: "Palvelut, joissa on ongelmia",
    PROVIDER_ALL_OPERATIONAL: "Kaikki palvelut toiminnassa",
    PROVIDER_LAST_UPDATED: "Päivitetty",
    PROVIDER_STATUS_PAGE: "Tilasivu",
    PROVIDER_FETCH_FAILED: "Tilaa ei voitu hakea",
    PROVIDER_LOADING: "Haetaan…",
    PROVIDER_EVENTS_TITLE: "Tapahtumat",
    PROVIDER_NO_EVENTS: "Ei käynnissä olevia, suunniteltuja tai äskettäin ratkaistuja tapahtumia.",
    PROVIDER_PER_PAGE: "Sivulla:",
    PROVIDER_LEVEL_OPERATIONAL: "Toiminnassa",
    PROVIDER_LEVEL_MAINTENANCE: "Huolto",
    PROVIDER_LEVEL_DEGRADED: "Heikentynyt",
    PROVIDER_LEVEL_PARTIAL_OUTAGE: "Osittainen katkos",
    PROVIDER_LEVEL_MAJOR_OUTAGE: "Laaja katkos",
    PROVIDER_LEVEL_UNKNOWN: "Tuntematon",
    PROVIDER_EVENT_RESOLVED: "Ratkaistu",
    PROVIDER_EVENT_SCHEDULED_MAINTENANCE: "Suunniteltu huolto",
    PROVIDER_EVENT_ONGOING_MAINTENANCE: "Käynnissä oleva huolto",
    PROVIDER_EVENT_ONGOING_INCIDENT: "Käynnissä oleva häiriö",

    // Catering: partner-group companies, invoice PDF switch, delivery-time generator
    CC_GROUP_BANNER_TITLE: "Yhteinen kaikille ryhmän ravintoloille:",
    CC_GROUP_BANNER_DESC: "Nämä yritykset kuuluvat kumppaniryhmälle, eivät tälle ravintolalle. Muutokset koskevat kaikkia ryhmän ravintoloita.",
    CC_GROUP_MISCONFIGURED_TITLE: "Tämän ravintolan kumppaniryhmää ei ole määritetty oikein",
    CC_GROUP_NOT_MEMBER: "Ryhmä on olemassa, mutta tätä ravintolaa ei ole lisätty siihen.",
    CC_GROUP_NOT_FOUND: "Tällä tunnuksella ei löytynyt kumppaniryhmää.",
    CC_GROUP_FIX_IN_SETTINGS: "Korjaa tai poista kumppaniryhmä kohdassa Catering > Asetukset > Toimitus. Yrityksiä ei voi muokata ennen sitä.",
    CC_EMAIL_DOMAINS: "Sähköpostiverkkotunnukset",
    CC_EMAIL_DOMAINS_NONE: "Ei verkkotunnuksia (vain manuaalisesti liitetyt käyttäjät)",
    CC_EMAIL_DOMAINS_HELP: "Kirjautuneet käyttäjät, joiden vahvistettu sähköposti päättyy johonkin näistä verkkotunnuksista, voivat tilata tämän yrityksen laskulla. Kirjoita verkkotunnus ilman \"@\"-merkkiä, esim. soupster.fi.",
    CC_EMAIL_DOMAINS_EMPTY_HINT: "Ei vielä verkkotunnuksia: vain manuaalisesti liitetyt käyttäjät (Käyttäjät) saavat tämän yrityksen.",
    CC_EMAIL_DOMAIN_INVALID: "Virheellinen verkkotunnus. Esimerkki: soupster.fi",
    CC_EMAIL_DOMAIN_PUBLIC: "Julkisia sähköpostipalveluja (gmail.com, outlook.com, ...) ei voi käyttää: kuka tahansa voi luoda niihin osoitteen.",
    CC_EMAIL_DOMAIN_DUPLICATE: "Verkkotunnus on jo listalla.",
    CC_EMAIL_DOMAIN_SHARED: "Käytössä myös yrityksellä:",
    CC_COST_CENTERS: "Kustannuspaikat",
    CC_COST_CENTERS_HELP: "Valinnainen. Jos lisäät kustannuspaikkoja, käyttäjä valitsee yhden tilatessaan; muuten sen voi kirjoittaa vapaasti.",
    CC_COST_CENTER_PLACEHOLDER: "esim. 4010 Markkinointi",
    CATERING_INVOICE_PDF: "Lasku-PDF",
    CATERING_INVOICE_PDF_ON_DESC: "Päällä: lasku-PDF luodaan ja lähetetään sähköpostilla, kun laskutilaus tehdään.",
    CATERING_INVOICE_PDF_OFF_DESC: "Ei lasku-PDF:ää — ravintola laskuttaa kassajärjestelmästään; hyväksyntäsähköposti toimii tilausvahvistuksena.",
    CATERING_PARTNER_GROUP: "Kumppaniryhmä",
    CATERING_PARTNER_GROUP_DESC: "Jos ravintola kuuluu kumppaniryhmään, anna ryhmän tunnus. Yritysasiakkaat ovat silloin yhteisiä kaikille ryhmän ravintoloille.",
    CATERING_PARTNER_GROUP_PLACEHOLDER: "Ryhmän tunnus, esim. soupster",
    CATERING_PARTNER_GROUP_CHECK: "Tarkista",
    CATERING_PARTNER_GROUP_OK: "Ryhmä löytyi:",
    CATERING_PARTNER_GROUP_NOT_MEMBER: "Ravintolaa ei ole lisätty ryhmään:",
    CATERING_PARTNER_GROUP_NOT_FOUND: "Tällä tunnuksella ei löytynyt kumppaniryhmää.",
    CATERING_PARTNER_GROUP_INVALID_SLUG: "Ryhmän tunnus voi sisältää vain kirjaimia, numeroita sekä merkit \"-\" ja \"_\".",
    CATERING_PARTNER_GROUP_UNCHECKED: "Paina Tarkista vahvistaaksesi ryhmän ennen tallentamista.",
    CATERING_PARTNER_GROUP_NONE: "Ei kumppaniryhmää: yritysasiakkaat kuuluvat vain tälle ravintolalle.",
    CATERING_PARTNER_GROUP_NOT_SAVED: "Kumppaniryhmää ei tallennettu: sitä ei ole olemassa tai ravintolaa ei ole lisätty siihen.",
    CATERING_DELIVERY_DEFAULT_TIME_ADDED: "Oletustoimitusaika (10:00) lisättiin. Muuta sitä, lisää aikoja tai luo päivän ajat alla.",
    CATERING_GENERATE_TIMES: "Luo ajat",
    CATERING_GENERATE_TIMES_FROM: "Alkaen",
    CATERING_GENERATE_TIMES_TO: "Asti",
    CATERING_GENERATE_TIMES_STEP: "Välein",
    CATERING_GENERATE_TIMES_APPLY: "Luo",
    CATERING_SORT_TIMES: "Järjestä",
    CATERING_GENERATE_TIMES_HELP: "Korvaa päivän toimitusajat jokaisella välillä alku- ja loppuajan välillä (mukaan lukien). Mitään ei tallenneta ennen kuin painat Tallenna.",
    CATERING_GENERATE_TIMES_ERR_INVALID: "Anna molemmat ajat muodossa TT:MM.",
    CATERING_GENERATE_TIMES_ERR_ORDER: "Loppuaika ei voi olla ennen alkuaikaa.",
    CATERING_GENERATE_TIMES_ERR_STEP: "Valitse aikaväli.",
    CATERING_GENERATE_TIMES_ERR_TOO_MANY: "Liian monta aikaa yhdelle päivälle. Valitse pidempi aikaväli.",
}
